export const lemmata =  [
  {
    "lemma": "",
    "cyr": "",
    "translation": ""
  },
  {
    "lemma": "a",
    "cyr": "а",
    "translation": "and, but"
  },
  {
    "lemma": "Ad",
    "cyr": "Ад",
    "translation": "Hades"
  },
  {
    "lemma": "Adam",
    "cyr": "Адам",
    "translation": "Adam"
  },
  {
    "lemma": "Adamov",
    "cyr": "Адамов",
    "translation": "Adam's"
  },
  {
    "lemma": "Adov",
    "cyr": "Адов",
    "translation": "of Hades"
  },
  {
    "lemma": "Agara",
    "cyr": "Агара",
    "translation": "Hagar"
  },
  {
    "lemma": "agne",
    "cyr": "агне",
    "translation": "lamb"
  },
  {
    "lemma": "agnec",
    "cyr": "агнец",
    "translation": "lamb (male)"
  },
  {
    "lemma": "ako",
    "cyr": "ако",
    "translation": "if"
  },
  {
    "lemma": "ali",
    "cyr": "али",
    "translation": "but"
  },
  {
    "lemma": "aliluia",
    "cyr": "алилуя",
    "translation": "hallelujah"
  },
  {
    "lemma": "ama",
    "cyr": "ама",
    "translation": "but"
  },
  {
    "lemma": "ami",
    "cyr": "ами",
    "translation": "but"
  },
  {
    "lemma": "amin",
    "cyr": "амин",
    "translation": "amen"
  },
  {
    "lemma": "angel",
    "cyr": "ангел",
    "translation": "angel"
  },
  {
    "lemma": "angelski",
    "cyr": "ангелски",
    "translation": "angelic"
  },
  {
    "lemma": "Antioxija",
    "cyr": "Антиохия",
    "translation": "Antioch"
  },
  {
    "lemma": "Antixrist",
    "cyr": "Антихрист",
    "translation": "Antichrist"
  },
  {
    "lemma": "Antixristov",
    "cyr": "Антихристов",
    "translation": "Antichrist's"
  },
  {
    "lemma": "apostol",
    "cyr": "апостол",
    "translation": "apostle"
  },
  {
    "lemma": "apostolski",
    "cyr": "апостолски",
    "translation": "apostolic"
  },
  {
    "lemma": "april",
    "cyr": "април",
    "translation": "April"
  },
  {
    "lemma": "Aravija",
    "cyr": "Аравия",
    "translation": "Arabia"
  },
  {
    "lemma": "artisam",
    "cyr": "артисам",
    "translation": "remain"
  },
  {
    "lemma": "arxangel",
    "cyr": "архангел",
    "translation": "archangel"
  },
  {
    "lemma": "arxangelski",
    "cyr": "архангелски",
    "translation": "archangelic"
  },
  {
    "lemma": "arxiereiski",
    "cyr": "архиерейски",
    "translation": "archihieratic"
  },
  {
    "lemma": "Arxip",
    "cyr": "Архип",
    "translation": "Archippus"
  },
  {
    "lemma": "arxistratig",
    "cyr": "архистратиг",
    "translation": "archistratege"
  },
  {
    "lemma": "Asadita",
    "cyr": "Асадита",
    "translation": "Asadite"
  },
  {
    "lemma": "Asirion",
    "cyr": "Асирион",
    "translation": "Assyria"
  },
  {
    "lemma": "aspida",
    "cyr": "аспида",
    "translation": "asp"
  },
  {
    "lemma": "ašte",
    "cyr": "аще",
    "translation": "if"
  },
  {
    "lemma": "atonski",
    "cyr": "атонски",
    "translation": "of Athos"
  },
  {
    "lemma": "Avakum",
    "cyr": "Авакум",
    "translation": "Habakkuk"
  },
  {
    "lemma": "Avel",
    "cyr": "Авел",
    "translation": "Abel"
  },
  {
    "lemma": "avgust",
    "cyr": "август",
    "translation": "August"
  },
  {
    "lemma": "Avraam",
    "cyr": "Авраам",
    "translation": "Abraham"
  },
  {
    "lemma": "axčija",
    "cyr": "ахчия",
    "translation": "cook"
  },
  {
    "lemma": "az",
    "cyr": "аз",
    "translation": "I"
  },
  {
    "lemma": "bakъr",
    "cyr": "бакър",
    "translation": "copper"
  },
  {
    "lemma": "banja",
    "cyr": "баня",
    "translation": "bath"
  },
  {
    "lemma": "Baronii",
    "cyr": "Баронии",
    "translation": "Baronius"
  },
  {
    "lemma": "baška",
    "cyr": "башка",
    "translation": "apart, separately"
  },
  {
    "lemma": "bašta",
    "cyr": "баща",
    "translation": "father"
  },
  {
    "lemma": "baždarin",
    "cyr": "баждарин",
    "translation": "customs officer"
  },
  {
    "lemma": "beda",
    "cyr": "беда",
    "translation": "woe"
  },
  {
    "lemma": "beden",
    "cyr": "беден",
    "translation": "poor"
  },
  {
    "lemma": "bedstvovati",
    "cyr": "бедствовати",
    "translation": "suffer"
  },
  {
    "lemma": "běgam",
    "cyr": "бягам",
    "translation": "run"
  },
  {
    "lemma": "běl",
    "cyr": "бял",
    "translation": "white"
  },
  {
    "lemma": "beleg",
    "cyr": "белег",
    "translation": "evidence, scar"
  },
  {
    "lemma": "bera",
    "cyr": "бера",
    "translation": "take"
  },
  {
    "lemma": "bereket",
    "cyr": "берекет",
    "translation": "abundance"
  },
  {
    "lemma": "běs",
    "cyr": "бяс",
    "translation": "demon (evil)"
  },
  {
    "lemma": "běsen",
    "cyr": "бясен",
    "translation": "possessed"
  },
  {
    "lemma": "běsovski",
    "cyr": "бясовски",
    "translation": "demonic"
  },
  {
    "lemma": "bez",
    "cyr": "без",
    "translation": "without"
  },
  {
    "lemma": "bezbožen",
    "cyr": "безбожен",
    "translation": "godless"
  },
  {
    "lemma": "bezčiselen",
    "cyr": "безчиселен",
    "translation": "immeasurable"
  },
  {
    "lemma": "bezdna",
    "cyr": "бездна",
    "translation": "abyss"
  },
  {
    "lemma": "bezdušen",
    "cyr": "бездушен",
    "translation": "soulless"
  },
  {
    "lemma": "bezglasen",
    "cyr": "безгласен",
    "translation": "voiceless"
  },
  {
    "lemma": "bezgrižen",
    "cyr": "безгрижен",
    "translation": "careless, safe"
  },
  {
    "lemma": "bezkraen",
    "cyr": "безкраен",
    "translation": "endless"
  },
  {
    "lemma": "bezočliv",
    "cyr": "безочлив",
    "translation": "heedless"
  },
  {
    "lemma": "bezploden",
    "cyr": "безплоден",
    "translation": "barren"
  },
  {
    "lemma": "bezsmъrten",
    "cyr": "безсмъртен",
    "translation": "immortal"
  },
  {
    "lemma": "bezsrebъrnik",
    "cyr": "безсребърник",
    "translation": "unmercenary"
  },
  {
    "lemma": "bezumen",
    "cyr": "безумен",
    "translation": "foolish"
  },
  {
    "lemma": "bezumie",
    "cyr": "безумие",
    "translation": "folly"
  },
  {
    "lemma": "bezumnica",
    "cyr": "безумница",
    "translation": "foolish woman"
  },
  {
    "lemma": "bezumnik",
    "cyr": "безумник",
    "translation": "foolish man"
  },
  {
    "lemma": "bezvoden",
    "cyr": "безводен",
    "translation": "waterless"
  },
  {
    "lemma": "bezzakonen",
    "cyr": "беззаконен",
    "translation": "lawless"
  },
  {
    "lemma": "bezzakonnik",
    "cyr": "беззаконник",
    "translation": "lawless"
  },
  {
    "lemma": "bezzakonie",
    "cyr": "беззаконие",
    "translation": "lawlessness"
  },
  {
    "lemma": "bezzakonstvo",
    "cyr": "беззаконство",
    "translation": "lawlessness"
  },
  {
    "lemma": "bija",
    "cyr": "бия",
    "translation": "beat"
  },
  {
    "lemma": "bivam",
    "cyr": "бивам",
    "translation": "be, dwell"
  },
  {
    "lemma": "blag",
    "cyr": "благ",
    "translation": "good"
  },
  {
    "lemma": "blago",
    "cyr": "благо",
    "translation": "good"
  },
  {
    "lemma": "blagodaren",
    "cyr": "благодарен",
    "translation": "thankful"
  },
  {
    "lemma": "blagodarja",
    "cyr": "благодаря",
    "translation": "thank"
  },
  {
    "lemma": "blagodarovati",
    "cyr": "благодаровати",
    "translation": "thank"
  },
  {
    "lemma": "blagodat",
    "cyr": "благодат",
    "translation": "virtue"
  },
  {
    "lemma": "blagodatel",
    "cyr": "благодател",
    "translation": "benefactor"
  },
  {
    "lemma": "blagoslovenie",
    "cyr": "благословение",
    "translation": "blessing"
  },
  {
    "lemma": "blagoslovja",
    "cyr": "благословя",
    "translation": "bless"
  },
  {
    "lemma": "blagoutroben",
    "cyr": "благоутробен",
    "translation": "merciful"
  },
  {
    "lemma": "blagoveren",
    "cyr": "благоверен",
    "translation": "pious"
  },
  {
    "lemma": "blažen",
    "cyr": "блажен",
    "translation": "blessed, blissful"
  },
  {
    "lemma": "blaznja",
    "cyr": "блазня",
    "translation": "seduce, deceive"
  },
  {
    "lemma": "bledav",
    "cyr": "бледав",
    "translation": "pale"
  },
  {
    "lemma": "blizo",
    "cyr": "близо",
    "translation": "close"
  },
  {
    "lemma": "bljudo",
    "cyr": "блюдо",
    "translation": "dish"
  },
  {
    "lemma": "blud",
    "cyr": "блуд",
    "translation": "sin, adultery"
  },
  {
    "lemma": "bluden",
    "cyr": "блуден",
    "translation": "sinful"
  },
  {
    "lemma": "bludnica",
    "cyr": "блудница",
    "translation": "adulterous woman"
  },
  {
    "lemma": "bludničin",
    "cyr": "блудничин",
    "translation": "of adulterous woman"
  },
  {
    "lemma": "bludnik",
    "cyr": "блудник",
    "translation": "adulterer"
  },
  {
    "lemma": "blъsъk",
    "cyr": "блъсък",
    "translation": "lightning"
  },
  {
    "lemma": "bo",
    "cyr": "бо",
    "translation": "because"
  },
  {
    "lemma": "bog",
    "cyr": "бог",
    "translation": "god"
  },
  {
    "lemma": "bogat",
    "cyr": "богат",
    "translation": "rich"
  },
  {
    "lemma": "bogojavlenie",
    "cyr": "богоявление",
    "translation": "Epiphany of God"
  },
  {
    "lemma": "bogopleten",
    "cyr": "богоплетен",
    "translation": "woven by God"
  },
  {
    "lemma": "bogopočten",
    "cyr": "богопочтен",
    "translation": "honored by God"
  },
  {
    "lemma": "bogopriimec",
    "cyr": "богоприимец",
    "translation": "receiving God"
  },
  {
    "lemma": "Bogorodica",
    "cyr": "Богородица",
    "translation": "Mother of God"
  },
  {
    "lemma": "bogosvětliv",
    "cyr": "богосвятлив",
    "translation": "shining by the grace of God"
  },
  {
    "lemma": "bogotъkan",
    "cyr": "боготъкан",
    "translation": "woven by God"
  },
  {
    "lemma": "boi",
    "cyr": "бой",
    "translation": "fight"
  },
  {
    "lemma": "boja",
    "cyr": "боя",
    "translation": "fear"
  },
  {
    "lemma": "bojazliv",
    "cyr": "боязлив",
    "translation": "fearful"
  },
  {
    "lemma": "bolě",
    "cyr": "боля",
    "translation": "more"
  },
  {
    "lemma": "bolen",
    "cyr": "болен",
    "translation": "ill"
  },
  {
    "lemma": "bolest",
    "cyr": "болест",
    "translation": "illness"
  },
  {
    "lemma": "boljarin",
    "cyr": "болярин",
    "translation": "boyar, noble"
  },
  {
    "lemma": "boljarka",
    "cyr": "болярка",
    "translation": "boyar lady"
  },
  {
    "lemma": "borja",
    "cyr": "боря",
    "translation": "struggle"
  },
  {
    "lemma": "božestven",
    "cyr": "божествен",
    "translation": "divine"
  },
  {
    "lemma": "božestvo",
    "cyr": "божество",
    "translation": "divinity"
  },
  {
    "lemma": "božii",
    "cyr": "божии",
    "translation": "God's"
  },
  {
    "lemma": "branja",
    "cyr": "браня",
    "translation": "defend"
  },
  {
    "lemma": "brat",
    "cyr": "брат",
    "translation": "brother"
  },
  {
    "lemma": "bratstvo",
    "cyr": "братство",
    "translation": "brotherhood"
  },
  {
    "lemma": "brěg",
    "cyr": "бряг",
    "translation": "shore"
  },
  {
    "lemma": "broenička",
    "cyr": "броеничка",
    "translation": "rosary"
  },
  {
    "lemma": "broja",
    "cyr": "броя",
    "translation": "count"
  },
  {
    "lemma": "brъkna",
    "cyr": "бръкна",
    "translation": "touch"
  },
  {
    "lemma": "buen",
    "cyr": "буен",
    "translation": "foolish"
  },
  {
    "lemma": "bunište",
    "cyr": "бунище",
    "translation": "dump"
  },
  {
    "lemma": "byti",
    "cyr": "быти",
    "translation": "be"
  },
  {
    "lemma": "bъda",
    "cyr": "бъда",
    "translation": "become"
  },
  {
    "lemma": "bъlgarin",
    "cyr": "българин",
    "translation": "Bulgarian"
  },
  {
    "lemma": "bъlgarski",
    "cyr": "български",
    "translation": "of Bulgaria"
  },
  {
    "lemma": "bъrz",
    "cyr": "бърз",
    "translation": "fast"
  },
  {
    "lemma": "car",
    "cyr": "цар",
    "translation": "king"
  },
  {
    "lemma": "carev",
    "cyr": "царев",
    "translation": "king's"
  },
  {
    "lemma": "carski",
    "cyr": "царски",
    "translation": "of king"
  },
  {
    "lemma": "carstvuvam",
    "cyr": "царствувам",
    "translation": "have a kingdom"
  },
  {
    "lemma": "carstvie",
    "cyr": "царствие",
    "translation": "kingdom"
  },
  {
    "lemma": "carstvo",
    "cyr": "царство",
    "translation": "kingdom"
  },
  {
    "lemma": "caruvam",
    "cyr": "царувам",
    "translation": "reign"
  },
  {
    "lemma": "čas",
    "cyr": "час",
    "translation": "hour"
  },
  {
    "lemma": "čaša",
    "cyr": "чаша",
    "translation": "cup"
  },
  {
    "lemma": "čast",
    "cyr": "част",
    "translation": "part"
  },
  {
    "lemma": "če",
    "cyr": "че",
    "translation": "that"
  },
  {
    "lemma": "čedo",
    "cyr": "чедо",
    "translation": "child"
  },
  {
    "lemma": "čeljad",
    "cyr": "челяд",
    "translation": "family, household"
  },
  {
    "lemma": "celomudъr",
    "cyr": "целомудър",
    "translation": "prudent"
  },
  {
    "lemma": "celuvane",
    "cyr": "целуване",
    "translation": "kissing"
  },
  {
    "lemma": "celuvam",
    "cyr": "целувам",
    "translation": "kiss"
  },
  {
    "lemma": "cena",
    "cyr": "цена",
    "translation": "price"
  },
  {
    "lemma": "čengel",
    "cyr": "ченгел",
    "translation": "hook"
  },
  {
    "lemma": "čeren",
    "cyr": "черен",
    "translation": "black"
  },
  {
    "lemma": "červo",
    "cyr": "черво",
    "translation": "intestines"
  },
  {
    "lemma": "čest",
    "cyr": "чест",
    "translation": "honor"
  },
  {
    "lemma": "česten",
    "cyr": "честен",
    "translation": "true, honorable"
  },
  {
    "lemma": "čestit",
    "cyr": "честит",
    "translation": "honorable"
  },
  {
    "lemma": "čestiti",
    "cyr": "честити",
    "translation": "honor"
  },
  {
    "lemma": "čestiv",
    "cyr": "честив",
    "translation": "honoring"
  },
  {
    "lemma": "čestno",
    "cyr": "честно",
    "translation": "honorably"
  },
  {
    "lemma": "često",
    "cyr": "често",
    "translation": "often"
  },
  {
    "lemma": "četa",
    "cyr": "чета",
    "translation": "read"
  },
  {
    "lemma": "četiri",
    "cyr": "четири",
    "translation": "four"
  },
  {
    "lemma": "četvertovlastnik",
    "cyr": "четвертовластник",
    "translation": "tetrarch"
  },
  {
    "lemma": "četvertovolen",
    "cyr": "четвертоволен",
    "translation": "tetrarch"
  },
  {
    "lemma": "četvorica",
    "cyr": "четворица",
    "translation": "group of four"
  },
  {
    "lemma": "četvъrti",
    "cyr": "четвърти",
    "translation": "fourth"
  },
  {
    "lemma": "čii",
    "cyr": "чий",
    "translation": "whose"
  },
  {
    "lemma": "čin",
    "cyr": "чин",
    "translation": "rank"
  },
  {
    "lemma": "činja",
    "cyr": "чиня",
    "translation": "do"
  },
  {
    "lemma": "činonačelnik",
    "cyr": "чиноначелник",
    "translation": "commander of the (angelic) ranks"
  },
  {
    "lemma": "čirep",
    "cyr": "чиреп",
    "translation": "splitter"
  },
  {
    "lemma": "čist",
    "cyr": "чист",
    "translation": "clear"
  },
  {
    "lemma": "čitatel",
    "cyr": "читател",
    "translation": "reader"
  },
  {
    "lemma": "človečeski",
    "cyr": "чловечески",
    "translation": "of humans"
  },
  {
    "lemma": "človek",
    "cyr": "чловек",
    "translation": "human"
  },
  {
    "lemma": "črъv",
    "cyr": "чръв",
    "translation": "worm"
  },
  {
    "lemma": "čtenie",
    "cyr": "чтение",
    "translation": "lecture"
  },
  {
    "lemma": "čto",
    "cyr": "что",
    "translation": "what"
  },
  {
    "lemma": "čuden",
    "cyr": "чуден",
    "translation": "miraculous"
  },
  {
    "lemma": "čudja",
    "cyr": "чудя",
    "translation": "wonder"
  },
  {
    "lemma": "čudo",
    "cyr": "чудо",
    "translation": "miracle"
  },
  {
    "lemma": "čudotvorec",
    "cyr": "чудотворец",
    "translation": "wonderworker"
  },
  {
    "lemma": "čuja",
    "cyr": "чуя",
    "translation": "hear"
  },
  {
    "lemma": "čuvam",
    "cyr": "чувам",
    "translation": "hear, listen, care"
  },
  {
    "lemma": "čužd",
    "cyr": "чужд",
    "translation": "foreign"
  },
  {
    "lemma": "čuždenec",
    "cyr": "чужденец",
    "translation": "foreigner"
  },
  {
    "lemma": "cъrkoven",
    "cyr": "църковен",
    "translation": "ecclesiastic"
  },
  {
    "lemma": "cъrkovnik",
    "cyr": "църковник",
    "translation": "cleric"
  },
  {
    "lemma": "cъrkva",
    "cyr": "църква",
    "translation": "church"
  },
  {
    "lemma": "da",
    "cyr": "да",
    "translation": "to"
  },
  {
    "lemma": "dalek",
    "cyr": "далек",
    "translation": "far"
  },
  {
    "lemma": "daleko",
    "cyr": "далеко",
    "translation": "far"
  },
  {
    "lemma": "dali",
    "cyr": "дали",
    "translation": "whether"
  },
  {
    "lemma": "dam",
    "cyr": "дам",
    "translation": "give"
  },
  {
    "lemma": "Damian",
    "cyr": "Дамян",
    "translation": "Damian"
  },
  {
    "lemma": "dan",
    "cyr": "дан",
    "translation": "tax"
  },
  {
    "lemma": "Daniil",
    "cyr": "Даниил",
    "translation": "Daniel"
  },
  {
    "lemma": "dano",
    "cyr": "дано",
    "translation": "may"
  },
  {
    "lemma": "danъk",
    "cyr": "данък",
    "translation": "tax"
  },
  {
    "lemma": "dar",
    "cyr": "дар",
    "translation": "gift"
  },
  {
    "lemma": "darba",
    "cyr": "дарба",
    "translation": "gift, talent"
  },
  {
    "lemma": "Darii",
    "cyr": "Дарий",
    "translation": "Darius"
  },
  {
    "lemma": "daruvam",
    "cyr": "дарувам",
    "translation": "give a present"
  },
  {
    "lemma": "davam",
    "cyr": "давам",
    "translation": "give"
  },
  {
    "lemma": "David",
    "cyr": "Давид",
    "translation": "David"
  },
  {
    "lemma": "davno",
    "cyr": "давно",
    "translation": "long ago"
  },
  {
    "lemma": "daže",
    "cyr": "даже",
    "translation": "even"
  },
  {
    "lemma": "de",
    "cyr": "де",
    "translation": "where"
  },
  {
    "lemma": "dejanie",
    "cyr": "деяние",
    "translation": "deeds"
  },
  {
    "lemma": "dekna",
    "cyr": "декна",
    "translation": "quarrel"
  },
  {
    "lemma": "děl",
    "cyr": "дял",
    "translation": "part"
  },
  {
    "lemma": "delja",
    "cyr": "деля",
    "translation": "part"
  },
  {
    "lemma": "delo",
    "cyr": "дело",
    "translation": "deed"
  },
  {
    "lemma": "den",
    "cyr": "ден",
    "translation": "day"
  },
  {
    "lemma": "dera",
    "cyr": "дера",
    "translation": "tear"
  },
  {
    "lemma": "derzaja",
    "cyr": "дерзая",
    "translation": "dare, proceed with confidence"
  },
  {
    "lemma": "desen",
    "cyr": "десен",
    "translation": "right (side)"
  },
  {
    "lemma": "deset",
    "cyr": "десет",
    "translation": "ten"
  },
  {
    "lemma": "desnica",
    "cyr": "десница",
    "translation": "right hand"
  },
  {
    "lemma": "dete",
    "cyr": "дете",
    "translation": "child"
  },
  {
    "lemma": "detinski",
    "cyr": "детински",
    "translation": "of children"
  },
  {
    "lemma": "detko",
    "cyr": "детко",
    "translation": "child"
  },
  {
    "lemma": "deto",
    "cyr": "дето",
    "translation": "which"
  },
  {
    "lemma": "deva",
    "cyr": "дева",
    "translation": "maiden"
  },
  {
    "lemma": "devet",
    "cyr": "девет",
    "translation": "nine"
  },
  {
    "lemma": "devica",
    "cyr": "девица",
    "translation": "maiden"
  },
  {
    "lemma": "diavol",
    "cyr": "дявол",
    "translation": "devil"
  },
  {
    "lemma": "diavolski",
    "cyr": "дяволски",
    "translation": "devilish"
  },
  {
    "lemma": "digna",
    "cyr": "дигна",
    "translation": "raise"
  },
  {
    "lemma": "dirja",
    "cyr": "диря",
    "translation": "search"
  },
  {
    "lemma": "div",
    "cyr": "див",
    "translation": "wonder"
  },
  {
    "lemma": "diven",
    "cyr": "дивен",
    "translation": "wonderful"
  },
  {
    "lemma": "divja",
    "cyr": "дивя",
    "translation": "be amazed"
  },
  {
    "lemma": "dixanie",
    "cyr": "дихание",
    "translation": "breath, animal"
  },
  {
    "lemma": "djukjandžija",
    "cyr": "дюкянджия",
    "translation": "store owner"
  },
  {
    "lemma": "dnes",
    "cyr": "днес",
    "translation": "today"
  },
  {
    "lemma": "dnešen",
    "cyr": "днешен",
    "translation": "contemporary"
  },
  {
    "lemma": "dneska",
    "cyr": "днеска",
    "translation": "today"
  },
  {
    "lemma": "do",
    "cyr": "до",
    "translation": "until"
  },
  {
    "lemma": "dobija",
    "cyr": "добия",
    "translation": "gain"
  },
  {
    "lemma": "dobitъk",
    "cyr": "добитък",
    "translation": "cattle"
  },
  {
    "lemma": "dobre",
    "cyr": "добре",
    "translation": "well"
  },
  {
    "lemma": "dobro",
    "cyr": "добро",
    "translation": "goodness, goods"
  },
  {
    "lemma": "dobroumen",
    "cyr": "доброумен",
    "translation": "soothing"
  },
  {
    "lemma": "dobъr",
    "cyr": "добър",
    "translation": "good"
  },
  {
    "lemma": "dočakam",
    "cyr": "дочакам",
    "translation": "wait"
  },
  {
    "lemma": "dočuja",
    "cyr": "дочуя",
    "translation": "receive news"
  },
  {
    "lemma": "dogde",
    "cyr": "догде",
    "translation": "until"
  },
  {
    "lemma": "dogovaram",
    "cyr": "договарам",
    "translation": "give advice"
  },
  {
    "lemma": "dogovorja",
    "cyr": "договоря",
    "translation": "give advice"
  },
  {
    "lemma": "doida",
    "cyr": "дойда",
    "translation": "come"
  },
  {
    "lemma": "doideže",
    "cyr": "дойдеже",
    "translation": "until"
  },
  {
    "lemma": "dokaram",
    "cyr": "докарам",
    "translation": "bring in by a vehicle"
  },
  {
    "lemma": "dokoga",
    "cyr": "докога",
    "translation": "until when"
  },
  {
    "lemma": "dokogi",
    "cyr": "докоги",
    "translation": "until when"
  },
  {
    "lemma": "dole",
    "cyr": "доле",
    "translation": "down"
  },
  {
    "lemma": "dolno",
    "cyr": "долно",
    "translation": "lowly, insiduously"
  },
  {
    "lemma": "dolu",
    "cyr": "долу",
    "translation": "downward"
  },
  {
    "lemma": "dom",
    "cyr": "дом",
    "translation": "house"
  },
  {
    "lemma": "domašen",
    "cyr": "домашен",
    "translation": "of house"
  },
  {
    "lemma": "domislja",
    "cyr": "домисля",
    "translation": "think out"
  },
  {
    "lemma": "donesa",
    "cyr": "донеса",
    "translation": "bring in"
  },
  {
    "lemma": "doplъzja",
    "cyr": "доплъзя",
    "translation": "crawl in"
  },
  {
    "lemma": "dopratja",
    "cyr": "допратя",
    "translation": "send in"
  },
  {
    "lemma": "dori",
    "cyr": "дори",
    "translation": "even if"
  },
  {
    "lemma": "dosada",
    "cyr": "досада",
    "translation": "annoyance"
  },
  {
    "lemma": "dosaždam",
    "cyr": "досаждам",
    "translation": "annoy"
  },
  {
    "lemma": "dosetja",
    "cyr": "досетя",
    "translation": "understand"
  },
  {
    "lemma": "dososam",
    "cyr": "дососам",
    "translation": "be enough"
  },
  {
    "lemma": "dosta",
    "cyr": "доста",
    "translation": "enough"
  },
  {
    "lemma": "dostigna",
    "cyr": "достигна",
    "translation": "reach"
  },
  {
    "lemma": "dostoen",
    "cyr": "достоен",
    "translation": "worthy"
  },
  {
    "lemma": "dostojanie",
    "cyr": "достояние",
    "translation": "worth"
  },
  {
    "lemma": "dostoxvalen",
    "cyr": "достохвален",
    "translation": "worthy of praise"
  },
  {
    "lemma": "dosvideja",
    "cyr": "досвидея",
    "translation": "cease to like (?)"
  },
  {
    "lemma": "doveda",
    "cyr": "доведа",
    "translation": "lead in"
  },
  {
    "lemma": "doveza",
    "cyr": "довеза",
    "translation": "bring in by a vehicle"
  },
  {
    "lemma": "dovolno",
    "cyr": "доволно",
    "translation": "well enough"
  },
  {
    "lemma": "dovъrša",
    "cyr": "довърша",
    "translation": "finish"
  },
  {
    "lemma": "Doxiar",
    "cyr": "Дохяр",
    "translation": "Docheiarios"
  },
  {
    "lemma": "doxoždam",
    "cyr": "дохождам",
    "translation": "come often"
  },
  {
    "lemma": "drag",
    "cyr": "драг",
    "translation": "dear"
  },
  {
    "lemma": "drago",
    "cyr": "драго",
    "translation": "dearly"
  },
  {
    "lemma": "drexa",
    "cyr": "дреха",
    "translation": "clothing"
  },
  {
    "lemma": "drug",
    "cyr": "друг",
    "translation": "other"
  },
  {
    "lemma": "drug",
    "cyr": "друг",
    "translation": "friend"
  },
  {
    "lemma": "drugar",
    "cyr": "другар",
    "translation": "comrade"
  },
  {
    "lemma": "druguvam",
    "cyr": "другувам",
    "translation": "befriend"
  },
  {
    "lemma": "družina",
    "cyr": "дружина",
    "translation": "band, retinue"
  },
  {
    "lemma": "duma",
    "cyr": "дума",
    "translation": "word"
  },
  {
    "lemma": "dumam",
    "cyr": "думам",
    "translation": "speak, think"
  },
  {
    "lemma": "dupka",
    "cyr": "дупка",
    "translation": "hole"
  },
  {
    "lemma": "duša",
    "cyr": "душа",
    "translation": "soul"
  },
  {
    "lemma": "dušmanin",
    "cyr": "душманин",
    "translation": "enemy"
  },
  {
    "lemma": "dux",
    "cyr": "дух",
    "translation": "spirit"
  },
  {
    "lemma": "duxarski",
    "cyr": "духарски",
    "translation": "of Docheiarios"
  },
  {
    "lemma": "duxovnik",
    "cyr": "духовник",
    "translation": "cleric"
  },
  {
    "lemma": "duxna",
    "cyr": "духна",
    "translation": "blow"
  },
  {
    "lemma": "dva",
    "cyr": "два",
    "translation": "two"
  },
  {
    "lemma": "dvoica",
    "cyr": "двойца",
    "translation": "pair"
  },
  {
    "lemma": "dvor",
    "cyr": "двор",
    "translation": "court, yard"
  },
  {
    "lemma": "džalatin",
    "cyr": "джалатин",
    "translation": "executioner"
  },
  {
    "lemma": "dъlbina",
    "cyr": "дълбина",
    "translation": "depth"
  },
  {
    "lemma": "dъlbok",
    "cyr": "дълбок",
    "translation": "deep"
  },
  {
    "lemma": "dъlboko",
    "cyr": "дълбоко",
    "translation": "deeply"
  },
  {
    "lemma": "dъlgo",
    "cyr": "дълго",
    "translation": "for long"
  },
  {
    "lemma": "dъlžen",
    "cyr": "дължен",
    "translation": "indebted"
  },
  {
    "lemma": "dъlžina",
    "cyr": "дължина",
    "translation": "length"
  },
  {
    "lemma": "dъlъg",
    "cyr": "дълъг",
    "translation": "long"
  },
  {
    "lemma": "dъno",
    "cyr": "дъно",
    "translation": "bottom"
  },
  {
    "lemma": "dъrvo",
    "cyr": "дърво",
    "translation": "wood, tree"
  },
  {
    "lemma": "dъrža",
    "cyr": "държа",
    "translation": "hold"
  },
  {
    "lemma": "dъržava",
    "cyr": "държава",
    "translation": "domain, state"
  },
  {
    "lemma": "dъržavеn",
    "cyr": "държавен",
    "translation": "of the state"
  },
  {
    "lemma": "dъšter",
    "cyr": "дъщер",
    "translation": "daughter"
  },
  {
    "lemma": "dъšterja",
    "cyr": "дъщеря",
    "translation": "daughter"
  },
  {
    "lemma": "dъšterka",
    "cyr": "дъщерка",
    "translation": "daughter"
  },
  {
    "lemma": "dъžd",
    "cyr": "дъжд",
    "translation": "rain"
  },
  {
    "lemma": "Edem",
    "cyr": "Едем",
    "translation": "Eden"
  },
  {
    "lemma": "edin",
    "cyr": "един",
    "translation": "one"
  },
  {
    "lemma": "edinomateren",
    "cyr": "единоматерен",
    "translation": "born by one mother"
  },
  {
    "lemma": "edinoroden",
    "cyr": "единороден",
    "translation": "only born"
  },
  {
    "lemma": "edvam",
    "cyr": "едвам",
    "translation": "hardly"
  },
  {
    "lemma": "Efrat",
    "cyr": "Ефрат",
    "translation": "Euphrates"
  },
  {
    "lemma": "egda",
    "cyr": "егда",
    "translation": "when"
  },
  {
    "lemma": "Egipet",
    "cyr": "Египет",
    "translation": "Egypt"
  },
  {
    "lemma": "egipetski",
    "cyr": "египетски",
    "translation": "of Egypt"
  },
  {
    "lemma": "egiptěnin",
    "cyr": "египтянин",
    "translation": "Egyptian"
  },
  {
    "lemma": "ei",
    "cyr": "ей",
    "translation": "yes"
  },
  {
    "lemma": "ela",
    "cyr": "ела",
    "translation": "come!"
  },
  {
    "lemma": "elei",
    "cyr": "елей",
    "translation": "oil"
  },
  {
    "lemma": "eliko",
    "cyr": "елико",
    "translation": "as much"
  },
  {
    "lemma": "elinec",
    "cyr": "елинец",
    "translation": "pagan, Greek"
  },
  {
    "lemma": "elinin",
    "cyr": "елинин",
    "translation": "pagan, Greek"
  },
  {
    "lemma": "elinski",
    "cyr": "елински",
    "translation": "of pagans, Greeks"
  },
  {
    "lemma": "Elisaveta",
    "cyr": "Елисавета",
    "translation": "Elisabeth"
  },
  {
    "lemma": "Elisavetin",
    "cyr": "Елисаветин",
    "translation": "of Elisabeth"
  },
  {
    "lemma": "emer",
    "cyr": "емер",
    "translation": "emer"
  },
  {
    "lemma": "Enos",
    "cyr": "Енос",
    "translation": "Enos"
  },
  {
    "lemma": "Enosov",
    "cyr": "Еносов",
    "translation": "Enos'"
  },
  {
    "lemma": "Enox",
    "cyr": "Енох",
    "translation": "Enoch"
  },
  {
    "lemma": "Enoxov",
    "cyr": "Енохов",
    "translation": "Enoch's"
  },
  {
    "lemma": "erei",
    "cyr": "ерей",
    "translation": "priest"
  },
  {
    "lemma": "ete",
    "cyr": "ете",
    "translation": "behold!"
  },
  {
    "lemma": "etiopski",
    "cyr": "етиопски",
    "translation": "of Ethiopia"
  },
  {
    "lemma": "Eva",
    "cyr": "Ева",
    "translation": "Eve"
  },
  {
    "lemma": "evangelist",
    "cyr": "евангелист",
    "translation": "Evangelist"
  },
  {
    "lemma": "evilatski",
    "cyr": "евилатски",
    "translation": "of Havilah"
  },
  {
    "lemma": "Evin",
    "cyr": "Евин",
    "translation": "Eve's"
  },
  {
    "lemma": "evrein",
    "cyr": "еврейн",
    "translation": "Jew, Hebrew"
  },
  {
    "lemma": "evreiski",
    "cyr": "еврейски",
    "translation": "of Jews, Hebrews"
  },
  {
    "lemma": "ezer",
    "cyr": "езер",
    "translation": "chasm"
  },
  {
    "lemma": "ezero",
    "cyr": "езеро",
    "translation": "lake"
  },
  {
    "lemma": "ezičnik",
    "cyr": "езичник",
    "translation": "heathen"
  },
  {
    "lemma": "ezik",
    "cyr": "език",
    "translation": "language, tongue"
  },
  {
    "lemma": "faida",
    "cyr": "файда",
    "translation": "benefit"
  },
  {
    "lemma": "fala",
    "cyr": "фала",
    "translation": "praise"
  },
  {
    "lemma": "falja",
    "cyr": "фаля",
    "translation": "praise"
  },
  {
    "lemma": "fana",
    "cyr": "фана",
    "translation": "catch"
  },
  {
    "lemma": "faraon",
    "cyr": "фараон",
    "translation": "Pharaoh"
  },
  {
    "lemma": "faraonov",
    "cyr": "фараонов",
    "translation": "Pharaoh's"
  },
  {
    "lemma": "fariseiski",
    "cyr": "фарисейски",
    "translation": "of the Pharisees"
  },
  {
    "lemma": "Filip",
    "cyr": "Филип",
    "translation": "Philipp"
  },
  {
    "lemma": "Filipov",
    "cyr": "Филипов",
    "translation": "Philipp's"
  },
  {
    "lemma": "Fison",
    "cyr": "Фисон",
    "translation": "Pishon"
  },
  {
    "lemma": "Foroki",
    "cyr": "Фороки",
    "translation": "Phoroca"
  },
  {
    "lemma": "frъkna",
    "cyr": "фръкна",
    "translation": "fly away"
  },
  {
    "lemma": "fъrkam",
    "cyr": "фъркам",
    "translation": "let loose"
  },
  {
    "lemma": "fъrlja",
    "cyr": "фърля",
    "translation": "throw"
  },
  {
    "lemma": "Gad",
    "cyr": "Гад",
    "translation": "Gad"
  },
  {
    "lemma": "gad",
    "cyr": "гад",
    "translation": "vermin"
  },
  {
    "lemma": "gasja",
    "cyr": "гася",
    "translation": "extinguish"
  },
  {
    "lemma": "Gavriil",
    "cyr": "Гавриил",
    "translation": "Gabriel"
  },
  {
    "lemma": "gde",
    "cyr": "где",
    "translation": "where"
  },
  {
    "lemma": "gdeto",
    "cyr": "гдето",
    "translation": "where"
  },
  {
    "lemma": "gemija",
    "cyr": "гемия",
    "translation": "ship (with sails)"
  },
  {
    "lemma": "Geon",
    "cyr": "Геон",
    "translation": "Gihon"
  },
  {
    "lemma": "Gesem",
    "cyr": "Гесем",
    "translation": "Goshen"
  },
  {
    "lemma": "glad",
    "cyr": "глад",
    "translation": "hunger, famine"
  },
  {
    "lemma": "gladen",
    "cyr": "гладен",
    "translation": "hungered"
  },
  {
    "lemma": "glagolati",
    "cyr": "глаголати",
    "translation": "speak"
  },
  {
    "lemma": "glas",
    "cyr": "глас",
    "translation": "voice"
  },
  {
    "lemma": "glava",
    "cyr": "глава",
    "translation": "head"
  },
  {
    "lemma": "glaven",
    "cyr": "главен",
    "translation": "main"
  },
  {
    "lemma": "gledam",
    "cyr": "гледам",
    "translation": "watch"
  },
  {
    "lemma": "glupav",
    "cyr": "глупав",
    "translation": "foolish"
  },
  {
    "lemma": "glъtna",
    "cyr": "глътна",
    "translation": "swallow"
  },
  {
    "lemma": "gnezdo",
    "cyr": "гнездо",
    "translation": "nest"
  },
  {
    "lemma": "gnoi",
    "cyr": "гной",
    "translation": "pus"
  },
  {
    "lemma": "gnusen",
    "cyr": "гнусен",
    "translation": "disgusting"
  },
  {
    "lemma": "gode",
    "cyr": "годе",
    "translation": "whatever"
  },
  {
    "lemma": "godina",
    "cyr": "година",
    "translation": "year"
  },
  {
    "lemma": "gol",
    "cyr": "гол",
    "translation": "naked"
  },
  {
    "lemma": "golěm",
    "cyr": "голям",
    "translation": "big"
  },
  {
    "lemma": "golemja",
    "cyr": "големя",
    "translation": "be haughty"
  },
  {
    "lemma": "golemkinja",
    "cyr": "големкиня",
    "translation": "elder wife of husband's brother"
  },
  {
    "lemma": "golota",
    "cyr": "голота",
    "translation": "nakedness"
  },
  {
    "lemma": "gonja",
    "cyr": "гоня",
    "translation": "chase"
  },
  {
    "lemma": "gora",
    "cyr": "гора",
    "translation": "forest"
  },
  {
    "lemma": "gorča",
    "cyr": "горча",
    "translation": "make bitter"
  },
  {
    "lemma": "gordeliv",
    "cyr": "горделив",
    "translation": "haughty"
  },
  {
    "lemma": "gore",
    "cyr": "горе",
    "translation": "upward"
  },
  {
    "lemma": "gorě",
    "cyr": "горя",
    "translation": "woe"
  },
  {
    "lemma": "goren",
    "cyr": "горен",
    "translation": "upper"
  },
  {
    "lemma": "gorest",
    "cyr": "горест",
    "translation": "heat"
  },
  {
    "lemma": "goreštava",
    "cyr": "горещава",
    "translation": "heat"
  },
  {
    "lemma": "gorja",
    "cyr": "горя",
    "translation": "burn"
  },
  {
    "lemma": "gorko",
    "cyr": "горко",
    "translation": "bitterly"
  },
  {
    "lemma": "gorъk",
    "cyr": "горък",
    "translation": "bitter"
  },
  {
    "lemma": "Gospod",
    "cyr": "Господ",
    "translation": "Lord"
  },
  {
    "lemma": "gospodar",
    "cyr": "господар",
    "translation": "lord, ruler"
  },
  {
    "lemma": "gospodarka",
    "cyr": "господарка",
    "translation": "ruling woman"
  },
  {
    "lemma": "Gospoden",
    "cyr": "Господен",
    "translation": "Lord's"
  },
  {
    "lemma": "gospodin",
    "cyr": "господин",
    "translation": "lord"
  },
  {
    "lemma": "gospodstvo",
    "cyr": "господство",
    "translation": "lordship"
  },
  {
    "lemma": "gost",
    "cyr": "гост",
    "translation": "guest"
  },
  {
    "lemma": "gostoljuben",
    "cyr": "гостолюбен",
    "translation": "hospitable"
  },
  {
    "lemma": "goštavam",
    "cyr": "гощавам",
    "translation": "treat as a guest"
  },
  {
    "lemma": "gotov",
    "cyr": "готов",
    "translation": "ready"
  },
  {
    "lemma": "gotvja",
    "cyr": "готвя",
    "translation": "prepare, cook"
  },
  {
    "lemma": "govedo",
    "cyr": "говедо",
    "translation": "cattle"
  },
  {
    "lemma": "govorja",
    "cyr": "говоря",
    "translation": "talk, discuss"
  },
  {
    "lemma": "gozba",
    "cyr": "гозба",
    "translation": "feast"
  },
  {
    "lemma": "grabja",
    "cyr": "грабя",
    "translation": "rob"
  },
  {
    "lemma": "grad",
    "cyr": "град",
    "translation": "city"
  },
  {
    "lemma": "gradina",
    "cyr": "градина",
    "translation": "garden"
  },
  {
    "lemma": "gradja",
    "cyr": "градя",
    "translation": "fence"
  },
  {
    "lemma": "gramatnik",
    "cyr": "граматник",
    "translation": "grammarian"
  },
  {
    "lemma": "gręsti",
    "cyr": "грясти",
    "translation": "walk"
  },
  {
    "lemma": "grěšen",
    "cyr": "грешен",
    "translation": "sinful, erring"
  },
  {
    "lemma": "grěx",
    "cyr": "грях",
    "translation": "sin"
  },
  {
    "lemma": "griža",
    "cyr": "грижа",
    "translation": "worry"
  },
  {
    "lemma": "grižen",
    "cyr": "грижен",
    "translation": "worrisome"
  },
  {
    "lemma": "grižja",
    "cyr": "грижя",
    "translation": "worry"
  },
  {
    "lemma": "grob",
    "cyr": "гроб",
    "translation": "grave"
  },
  {
    "lemma": "grom",
    "cyr": "гром",
    "translation": "thunder"
  },
  {
    "lemma": "groš",
    "cyr": "грош",
    "translation": "groat"
  },
  {
    "lemma": "grozde",
    "cyr": "грозде",
    "translation": "grapes"
  },
  {
    "lemma": "grozen",
    "cyr": "грозен",
    "translation": "ugly, terrible"
  },
  {
    "lemma": "grъcki",
    "cyr": "гръцки",
    "translation": "of Greeks"
  },
  {
    "lemma": "grъk",
    "cyr": "грък",
    "translation": "Greek"
  },
  {
    "lemma": "gumno",
    "cyr": "гумно",
    "translation": "threshing floor"
  },
  {
    "lemma": "gъlъb",
    "cyr": "гълъб",
    "translation": "pidgeon"
  },
  {
    "lemma": "gъrbina",
    "cyr": "гърбина",
    "translation": "hump"
  },
  {
    "lemma": "gъrlo",
    "cyr": "гърло",
    "translation": "throat"
  },
  {
    "lemma": "gъrtan",
    "cyr": "гъртан",
    "translation": "throat"
  },
  {
    "lemma": "gъsenica",
    "cyr": "гъсеница",
    "translation": "caterpillar"
  },
  {
    "lemma": "i",
    "cyr": "и",
    "translation": "and"
  },
  {
    "lemma": "ianuari",
    "cyr": "януари",
    "translation": "January"
  },
  {
    "lemma": "Iared",
    "cyr": "Яред",
    "translation": "Jared"
  },
  {
    "lemma": "Iaredov",
    "cyr": "Яредов",
    "translation": "Jared's"
  },
  {
    "lemma": "ida",
    "cyr": "ида",
    "translation": "go"
  },
  {
    "lemma": "idol",
    "cyr": "идол",
    "translation": "idol"
  },
  {
    "lemma": "idolski",
    "cyr": "идолски",
    "translation": "of idols"
  },
  {
    "lemma": "Ierusalim",
    "cyr": "Йерусалим",
    "translation": "Jerusalem"
  },
  {
    "lemma": "Ierusalimov",
    "cyr": "Йерусалимов",
    "translation": "of Jerusalem"
  },
  {
    "lemma": "igraja",
    "cyr": "играя",
    "translation": "dance, play"
  },
  {
    "lemma": "igumen",
    "cyr": "игумен",
    "translation": "abbot"
  },
  {
    "lemma": "ikona",
    "cyr": "икона",
    "translation": "icon"
  },
  {
    "lemma": "ili",
    "cyr": "или",
    "translation": "or"
  },
  {
    "lemma": "imam",
    "cyr": "имам",
    "translation": "have"
  },
  {
    "lemma": "imane",
    "cyr": "имане",
    "translation": "wealth"
  },
  {
    "lemma": "ime",
    "cyr": "име",
    "translation": "name"
  },
  {
    "lemma": "imenit",
    "cyr": "именит",
    "translation": "of worthy name"
  },
  {
    "lemma": "imoten",
    "cyr": "имотен",
    "translation": "wealthy"
  },
  {
    "lemma": "inogda",
    "cyr": "иногда",
    "translation": "another time"
  },
  {
    "lemma": "Ioan",
    "cyr": "Йоан",
    "translation": "John"
  },
  {
    "lemma": "Ioanov",
    "cyr": "Йоанов",
    "translation": "John's"
  },
  {
    "lemma": "Ioav",
    "cyr": "Йоав",
    "translation": "Joab"
  },
  {
    "lemma": "Ioilov",
    "cyr": "Йоилов",
    "translation": "Joel's"
  },
  {
    "lemma": "Iordan",
    "cyr": "Йордан",
    "translation": "Jordan"
  },
  {
    "lemma": "Iosif",
    "cyr": "Йосиф",
    "translation": "Joseph"
  },
  {
    "lemma": "Iov",
    "cyr": "Йов",
    "translation": "Job"
  },
  {
    "lemma": "Iovin",
    "cyr": "Йовин",
    "translation": "Job's"
  },
  {
    "lemma": "Irod",
    "cyr": "Ирод",
    "translation": "Herod"
  },
  {
    "lemma": "Isaak",
    "cyr": "Исаак",
    "translation": "Isaac"
  },
  {
    "lemma": "Isaia",
    "cyr": "Исая",
    "translation": "Isaiah"
  },
  {
    "lemma": "iskam",
    "cyr": "искам",
    "translation": "want"
  },
  {
    "lemma": "isprъva",
    "cyr": "испръва",
    "translation": "at first"
  },
  {
    "lemma": "istina",
    "cyr": "истина",
    "translation": "truth"
  },
  {
    "lemma": "istinen",
    "cyr": "истинен",
    "translation": "TRUE"
  },
  {
    "lemma": "istorija",
    "cyr": "история",
    "translation": "history"
  },
  {
    "lemma": "Isus",
    "cyr": "Исус",
    "translation": "Jesus"
  },
  {
    "lemma": "Isusov",
    "cyr": "Исусов",
    "translation": "Jesus'"
  },
  {
    "lemma": "iz",
    "cyr": "из",
    "translation": "from"
  },
  {
    "lemma": "izbavitel",
    "cyr": "избавител",
    "translation": "savior"
  },
  {
    "lemma": "izbavja",
    "cyr": "избавя",
    "translation": "free, let off"
  },
  {
    "lemma": "izbavlenie",
    "cyr": "избавление",
    "translation": "redemption"
  },
  {
    "lemma": "izběgna",
    "cyr": "избягна",
    "translation": "run away"
  },
  {
    "lemma": "izbera",
    "cyr": "избера",
    "translation": "choose"
  },
  {
    "lemma": "izbija",
    "cyr": "избия",
    "translation": "slaughter"
  },
  {
    "lemma": "izbroja",
    "cyr": "изброя",
    "translation": "count"
  },
  {
    "lemma": "izcelenie",
    "cyr": "изцеление",
    "translation": "healing"
  },
  {
    "lemma": "izcelitel",
    "cyr": "изцелител",
    "translation": "healer"
  },
  {
    "lemma": "izcelja",
    "cyr": "изцеля",
    "translation": "heal"
  },
  {
    "lemma": "izceljavam",
    "cyr": "изцелявам",
    "translation": "heal"
  },
  {
    "lemma": "izdumam",
    "cyr": "издумам",
    "translation": "speak out"
  },
  {
    "lemma": "izdъxna",
    "cyr": "издъхна",
    "translation": "sigh out"
  },
  {
    "lemma": "izfrъlja",
    "cyr": "изфръля",
    "translation": "throw away"
  },
  {
    "lemma": "izgaram",
    "cyr": "изгарам",
    "translation": "burn"
  },
  {
    "lemma": "izgledam",
    "cyr": "изгледам",
    "translation": "see all"
  },
  {
    "lemma": "izgnija",
    "cyr": "изгния",
    "translation": "become rotten"
  },
  {
    "lemma": "izgonja",
    "cyr": "изгоня",
    "translation": "chase away"
  },
  {
    "lemma": "izgorja",
    "cyr": "изгоря",
    "translation": "burn"
  },
  {
    "lemma": "izgubja",
    "cyr": "изгубя",
    "translation": "lose"
  },
  {
    "lemma": "izjam",
    "cyr": "изям",
    "translation": "eat out"
  },
  {
    "lemma": "izkaram",
    "cyr": "изкарам",
    "translation": "expel"
  },
  {
    "lemma": "izkaža",
    "cyr": "изкажа",
    "translation": "tell"
  },
  {
    "lemma": "izkolja",
    "cyr": "изколя",
    "translation": "slaughter"
  },
  {
    "lemma": "izkusen",
    "cyr": "изкусен",
    "translation": "experienced"
  },
  {
    "lemma": "izkušenie",
    "cyr": "изкушение",
    "translation": "experience, temptation"
  },
  {
    "lemma": "izleja",
    "cyr": "излея",
    "translation": "pour out"
  },
  {
    "lemma": "izlěza",
    "cyr": "изляза",
    "translation": "go out"
  },
  {
    "lemma": "izlězna",
    "cyr": "излязна",
    "translation": "go out"
  },
  {
    "lemma": "izlivam",
    "cyr": "изливам",
    "translation": "pour out"
  },
  {
    "lemma": "izlixa",
    "cyr": "излиха",
    "translation": "insufficiently"
  },
  {
    "lemma": "izlъža",
    "cyr": "излъжа",
    "translation": "deceive"
  },
  {
    "lemma": "Izmail",
    "cyr": "Измайл",
    "translation": "Ishmael"
  },
  {
    "lemma": "izmamja",
    "cyr": "измамя",
    "translation": "deceive"
  },
  {
    "lemma": "izmeša",
    "cyr": "измеша",
    "translation": "mix"
  },
  {
    "lemma": "izmislja",
    "cyr": "измисля",
    "translation": "invent"
  },
  {
    "lemma": "izmorja",
    "cyr": "изморя",
    "translation": "murder"
  },
  {
    "lemma": "izmra",
    "cyr": "измра",
    "translation": "perish"
  },
  {
    "lemma": "iznesa",
    "cyr": "изнеса",
    "translation": "carry out"
  },
  {
    "lemma": "iznǫtr",
    "cyr": "изнътр",
    "translation": "from inside"
  },
  {
    "lemma": "izobreštati",
    "cyr": "изобрещати",
    "translation": "find"
  },
  {
    "lemma": "izpadna",
    "cyr": "изпадна",
    "translation": "fall out"
  },
  {
    "lemma": "izpit",
    "cyr": "изпит",
    "translation": "trial"
  },
  {
    "lemma": "izpitam",
    "cyr": "изпитам",
    "translation": "try"
  },
  {
    "lemma": "izpitvam",
    "cyr": "изпитвам",
    "translation": "try"
  },
  {
    "lemma": "izplъzvam",
    "cyr": "изплъзвам",
    "translation": "crawl out"
  },
  {
    "lemma": "izpovědam",
    "cyr": "изповядам",
    "translation": "confess"
  },
  {
    "lemma": "izpratja",
    "cyr": "изпратя",
    "translation": "send off"
  },
  {
    "lemma": "izpravja",
    "cyr": "изправя",
    "translation": "make straight"
  },
  {
    "lemma": "izprosja",
    "cyr": "изпрося",
    "translation": "beg, ask"
  },
  {
    "lemma": "izpuskam",
    "cyr": "изпускам",
    "translation": "let loose"
  },
  {
    "lemma": "izpustja",
    "cyr": "изпустя",
    "translation": "let loose"
  },
  {
    "lemma": "izpъdja",
    "cyr": "изпъдя",
    "translation": "expel"
  },
  {
    "lemma": "izpъdnik",
    "cyr": "изпъдник",
    "translation": "expelled one"
  },
  {
    "lemma": "izpъlnja",
    "cyr": "изпълня",
    "translation": "fill"
  },
  {
    "lemma": "izrastja",
    "cyr": "израстя",
    "translation": "grow"
  },
  {
    "lemma": "izreka",
    "cyr": "изрека",
    "translation": "say"
  },
  {
    "lemma": "izrina",
    "cyr": "изрина",
    "translation": "push out"
  },
  {
    "lemma": "izseka",
    "cyr": "изсека",
    "translation": "mow down"
  },
  {
    "lemma": "izsъxna",
    "cyr": "изсъхна",
    "translation": "dry"
  },
  {
    "lemma": "izteka",
    "cyr": "изтека",
    "translation": "pour out"
  },
  {
    "lemma": "iztičam",
    "cyr": "изтичам",
    "translation": "pour out"
  },
  {
    "lemma": "iztočen",
    "cyr": "източен",
    "translation": "Eastern"
  },
  {
    "lemma": "iztok",
    "cyr": "изток",
    "translation": "East"
  },
  {
    "lemma": "izuča",
    "cyr": "изуча",
    "translation": "learn"
  },
  {
    "lemma": "izvadja",
    "cyr": "извадя",
    "translation": "bring out"
  },
  {
    "lemma": "izveda",
    "cyr": "изведа",
    "translation": "lead out"
  },
  {
    "lemma": "izvesten",
    "cyr": "известен",
    "translation": "famous"
  },
  {
    "lemma": "izvestja",
    "cyr": "известя",
    "translation": "announce"
  },
  {
    "lemma": "izvod",
    "cyr": "извод",
    "translation": "source (of text)"
  },
  {
    "lemma": "izvolja",
    "cyr": "изволя",
    "translation": "choose"
  },
  {
    "lemma": "izvor",
    "cyr": "извор",
    "translation": "source"
  },
  {
    "lemma": "izvъrna",
    "cyr": "извърна",
    "translation": "turn"
  },
  {
    "lemma": "ja",
    "cyr": "я",
    "translation": "I"
  },
  {
    "lemma": "ja (2)",
    "cyr": "я (2)",
    "translation": "behold!"
  },
  {
    "lemma": "jabъlka",
    "cyr": "ябълка",
    "translation": "apple"
  },
  {
    "lemma": "jad",
    "cyr": "яд",
    "translation": "anger"
  },
  {
    "lemma": "jadene",
    "cyr": "ядене",
    "translation": "food"
  },
  {
    "lemma": "jaduja",
    "cyr": "ядуя",
    "translation": "anger"
  },
  {
    "lemma": "Jafet",
    "cyr": "Яфет",
    "translation": "Japheth"
  },
  {
    "lemma": "jaice",
    "cyr": "яице",
    "translation": "egg"
  },
  {
    "lemma": "jak",
    "cyr": "як",
    "translation": "strong, pretty"
  },
  {
    "lemma": "jako",
    "cyr": "яко",
    "translation": "very much"
  },
  {
    "lemma": "jako (2)",
    "cyr": "яко (2)",
    "translation": "as"
  },
  {
    "lemma": "jakože",
    "cyr": "якоже",
    "translation": "as well as"
  },
  {
    "lemma": "jam",
    "cyr": "ям",
    "translation": "eat"
  },
  {
    "lemma": "jama",
    "cyr": "яма",
    "translation": "cave"
  },
  {
    "lemma": "jarem",
    "cyr": "ярем",
    "translation": "yoke"
  },
  {
    "lemma": "jastie",
    "cyr": "ястие",
    "translation": "dish"
  },
  {
    "lemma": "javja",
    "cyr": "явя",
    "translation": "appear"
  },
  {
    "lemma": "je",
    "cyr": "е",
    "translation": "it"
  },
  {
    "lemma": "Juda",
    "cyr": "Юда",
    "translation": "Judah, Judas"
  },
  {
    "lemma": "judei",
    "cyr": "юдей",
    "translation": "Jew, Judaean"
  },
  {
    "lemma": "judeiski",
    "cyr": "юдейски",
    "translation": "Judaean, Jewish"
  },
  {
    "lemma": "Judeja",
    "cyr": "Юдея",
    "translation": "Judaea"
  },
  {
    "lemma": "junak",
    "cyr": "юнак",
    "translation": "hero"
  },
  {
    "lemma": "junec",
    "cyr": "юнец",
    "translation": "calf"
  },
  {
    "lemma": "juni",
    "cyr": "юни",
    "translation": "June"
  },
  {
    "lemma": "jutre",
    "cyr": "ютре",
    "translation": "morning"
  },
  {
    "lemma": "k",
    "cyr": "к",
    "translation": "to"
  },
  {
    "lemma": "kabaxat",
    "cyr": "кабахат",
    "translation": "sin, misdeed"
  },
  {
    "lemma": "kadija",
    "cyr": "кадия",
    "translation": "qadi, judge"
  },
  {
    "lemma": "kadъr",
    "cyr": "кадър",
    "translation": "capable"
  },
  {
    "lemma": "Kain",
    "cyr": "Каин",
    "translation": "Cain"
  },
  {
    "lemma": "Kainan",
    "cyr": "Каинан",
    "translation": "Kenan"
  },
  {
    "lemma": "Kainanov",
    "cyr": "Каинанов",
    "translation": "Kenan's"
  },
  {
    "lemma": "Kajaf",
    "cyr": "Каяф",
    "translation": "Caiaphas"
  },
  {
    "lemma": "kako",
    "cyr": "како",
    "translation": "how"
  },
  {
    "lemma": "kakvo",
    "cyr": "какво",
    "translation": "what"
  },
  {
    "lemma": "kakvoto",
    "cyr": "каквото",
    "translation": "what"
  },
  {
    "lemma": "kakъv",
    "cyr": "какъв",
    "translation": "what kind of"
  },
  {
    "lemma": "kakъvto",
    "cyr": "какъвто",
    "translation": "which"
  },
  {
    "lemma": "kal",
    "cyr": "кал",
    "translation": "mud"
  },
  {
    "lemma": "kaluger",
    "cyr": "калугер",
    "translation": "monk"
  },
  {
    "lemma": "kamen",
    "cyr": "камен",
    "translation": "stone"
  },
  {
    "lemma": "kamenie",
    "cyr": "камение",
    "translation": "stone"
  },
  {
    "lemma": "kamila",
    "cyr": "камила",
    "translation": "camel"
  },
  {
    "lemma": "kamilski",
    "cyr": "камилски",
    "translation": "of camel"
  },
  {
    "lemma": "kamo",
    "cyr": "камо",
    "translation": "where"
  },
  {
    "lemma": "kamъk",
    "cyr": "камък",
    "translation": "stone"
  },
  {
    "lemma": "kandilar",
    "cyr": "кандилар",
    "translation": "candlebearer"
  },
  {
    "lemma": "kandilo",
    "cyr": "кандило",
    "translation": "candlestick"
  },
  {
    "lemma": "kapište",
    "cyr": "капище",
    "translation": "heathen shrine"
  },
  {
    "lemma": "kapja",
    "cyr": "капя",
    "translation": "drop"
  },
  {
    "lemma": "Kapsof",
    "cyr": "Капсоф",
    "translation": "Kapsof"
  },
  {
    "lemma": "Karin",
    "cyr": "Карин",
    "translation": "Carinus"
  },
  {
    "lemma": "kata",
    "cyr": "ката",
    "translation": "every"
  },
  {
    "lemma": "kato",
    "cyr": "като",
    "translation": "as"
  },
  {
    "lemma": "kaža",
    "cyr": "кажа",
    "translation": "tell"
  },
  {
    "lemma": "kazvam",
    "cyr": "казвам",
    "translation": "tell"
  },
  {
    "lemma": "Kesar",
    "cyr": "Кесар",
    "translation": "Caesar"
  },
  {
    "lemma": "kile",
    "cyr": "киле",
    "translation": "bushel"
  },
  {
    "lemma": "kilija",
    "cyr": "килия",
    "translation": "cell"
  },
  {
    "lemma": "Kir",
    "cyr": "Кир",
    "translation": "Cyrus"
  },
  {
    "lemma": "Kirov",
    "cyr": "Киров",
    "translation": "Cyrus'"
  },
  {
    "lemma": "kladenec",
    "cyr": "кладенец",
    "translation": "well"
  },
  {
    "lemma": "klane",
    "cyr": "клане",
    "translation": "slaughter"
  },
  {
    "lemma": "klirik",
    "cyr": "клирик",
    "translation": "cleric"
  },
  {
    "lemma": "ključ",
    "cyr": "ключ",
    "translation": "key"
  },
  {
    "lemma": "knęz",
    "cyr": "княз",
    "translation": "prince"
  },
  {
    "lemma": "kniga",
    "cyr": "книга",
    "translation": "book"
  },
  {
    "lemma": "knigoljubie",
    "cyr": "книголюбие",
    "translation": "love of books"
  },
  {
    "lemma": "knižnik",
    "cyr": "книжник",
    "translation": "scribe"
  },
  {
    "lemma": "koga",
    "cyr": "кога",
    "translation": "when"
  },
  {
    "lemma": "kogi",
    "cyr": "коги",
    "translation": "when"
  },
  {
    "lemma": "kogito",
    "cyr": "когито",
    "translation": "when"
  },
  {
    "lemma": "koi",
    "cyr": "кой",
    "translation": "who"
  },
  {
    "lemma": "koito",
    "cyr": "който",
    "translation": "who"
  },
  {
    "lemma": "Koka",
    "cyr": "Кока",
    "translation": "Koka"
  },
  {
    "lemma": "kokal",
    "cyr": "кокал",
    "translation": "bone"
  },
  {
    "lemma": "kola",
    "cyr": "кола",
    "translation": "wagon"
  },
  {
    "lemma": "kolěno",
    "cyr": "коляно",
    "translation": "knee"
  },
  {
    "lemma": "kolko",
    "cyr": "колко",
    "translation": "how much"
  },
  {
    "lemma": "kolkoto",
    "cyr": "колкото",
    "translation": "as much"
  },
  {
    "lemma": "kon",
    "cyr": "кон",
    "translation": "horse"
  },
  {
    "lemma": "konec",
    "cyr": "конец",
    "translation": "end"
  },
  {
    "lemma": "kopaja",
    "cyr": "копая",
    "translation": "dig"
  },
  {
    "lemma": "korem",
    "cyr": "корем",
    "translation": "belly"
  },
  {
    "lemma": "koren",
    "cyr": "корен",
    "translation": "root"
  },
  {
    "lemma": "kosa",
    "cyr": "коса",
    "translation": "scythe"
  },
  {
    "lemma": "kotel",
    "cyr": "котел",
    "translation": "kettle"
  },
  {
    "lemma": "kovčeg",
    "cyr": "ковчег",
    "translation": "coffin"
  },
  {
    "lemma": "koza",
    "cyr": "коза",
    "translation": "goat"
  },
  {
    "lemma": "kozina",
    "cyr": "козина",
    "translation": "fur"
  },
  {
    "lemma": "Kozma",
    "cyr": "Козма",
    "translation": "Cosmas"
  },
  {
    "lemma": "kraen",
    "cyr": "краен",
    "translation": "last"
  },
  {
    "lemma": "krai",
    "cyr": "край",
    "translation": "end"
  },
  {
    "lemma": "kral",
    "cyr": "крал",
    "translation": "king"
  },
  {
    "lemma": "krasa",
    "cyr": "краса",
    "translation": "snake"
  },
  {
    "lemma": "krava",
    "cyr": "крава",
    "translation": "cow"
  },
  {
    "lemma": "krepja",
    "cyr": "крепя",
    "translation": "support"
  },
  {
    "lemma": "krepost",
    "cyr": "крепост",
    "translation": "strength"
  },
  {
    "lemma": "krepъk",
    "cyr": "крепък",
    "translation": "strong"
  },
  {
    "lemma": "krilo",
    "cyr": "крило",
    "translation": "wing"
  },
  {
    "lemma": "krivačka",
    "cyr": "кривачка",
    "translation": "handful"
  },
  {
    "lemma": "krivdina",
    "cyr": "кривдина",
    "translation": "injustice"
  },
  {
    "lemma": "kromešen",
    "cyr": "кромешен",
    "translation": "outer"
  },
  {
    "lemma": "krotko",
    "cyr": "кротко",
    "translation": "peacefully"
  },
  {
    "lemma": "krotъk",
    "cyr": "кротък",
    "translation": "peaceful"
  },
  {
    "lemma": "krov",
    "cyr": "кров",
    "translation": "cover"
  },
  {
    "lemma": "krъst",
    "cyr": "кръст",
    "translation": "cross"
  },
  {
    "lemma": "krъšten",
    "cyr": "кръщен",
    "translation": "baptized"
  },
  {
    "lemma": "krъštevam",
    "cyr": "кръщевам",
    "translation": "baptize"
  },
  {
    "lemma": "krъstitel",
    "cyr": "кръстител",
    "translation": "Baptist"
  },
  {
    "lemma": "krъstja",
    "cyr": "кръстя",
    "translation": "baptize"
  },
  {
    "lemma": "krъv",
    "cyr": "кръв",
    "translation": "blood"
  },
  {
    "lemma": "krъvnik",
    "cyr": "кръвник",
    "translation": "cutthroat"
  },
  {
    "lemma": "Kufa",
    "cyr": "Куфа",
    "translation": "Kufa"
  },
  {
    "lemma": "kupec",
    "cyr": "купец",
    "translation": "merchant"
  },
  {
    "lemma": "kupja",
    "cyr": "купя",
    "translation": "buy"
  },
  {
    "lemma": "kupuvam",
    "cyr": "купувам",
    "translation": "buy"
  },
  {
    "lemma": "kurva",
    "cyr": "курва",
    "translation": "whore"
  },
  {
    "lemma": "kurvarstvo",
    "cyr": "курварство",
    "translation": "adultery"
  },
  {
    "lemma": "kъde",
    "cyr": "къде",
    "translation": "where"
  },
  {
    "lemma": "kъdeto",
    "cyr": "където",
    "translation": "where"
  },
  {
    "lemma": "kъlna",
    "cyr": "кълна",
    "translation": "curse"
  },
  {
    "lemma": "kъm",
    "cyr": "към",
    "translation": "toward"
  },
  {
    "lemma": "kъmto",
    "cyr": "къмто",
    "translation": "toward"
  },
  {
    "lemma": "kъrčag",
    "cyr": "кърчаг",
    "translation": "pitcher"
  },
  {
    "lemma": "kъrpa",
    "cyr": "кърпа",
    "translation": "scarf, rag"
  },
  {
    "lemma": "kъrša",
    "cyr": "кърша",
    "translation": "cross"
  },
  {
    "lemma": "lakom",
    "cyr": "лаком",
    "translation": "greedy"
  },
  {
    "lemma": "lakomja",
    "cyr": "лакомя",
    "translation": "greed"
  },
  {
    "lemma": "lakъt",
    "cyr": "лакът",
    "translation": "elbow"
  },
  {
    "lemma": "latinin",
    "cyr": "латинин",
    "translation": "Roman, Latin"
  },
  {
    "lemma": "lavica",
    "cyr": "лавица",
    "translation": "shelf"
  },
  {
    "lemma": "Lazar",
    "cyr": "Лазар",
    "translation": "Lazarus"
  },
  {
    "lemma": "Lazarov",
    "cyr": "Лазаров",
    "translation": "Lazarus'"
  },
  {
    "lemma": "leden",
    "cyr": "леден",
    "translation": "icy"
  },
  {
    "lemma": "legalo",
    "cyr": "легало",
    "translation": "bed"
  },
  {
    "lemma": "legna",
    "cyr": "легна",
    "translation": "lay"
  },
  {
    "lemma": "legoma",
    "cyr": "легома",
    "translation": "as if, because"
  },
  {
    "lemma": "leko",
    "cyr": "леко",
    "translation": "lightly"
  },
  {
    "lemma": "lekuvanie",
    "cyr": "лекувание",
    "translation": "healing"
  },
  {
    "lemma": "lele",
    "cyr": "леле",
    "translation": "behold!"
  },
  {
    "lemma": "lesno",
    "cyr": "лесно",
    "translation": "easily"
  },
  {
    "lemma": "lešta",
    "cyr": "леща",
    "translation": "lentils"
  },
  {
    "lemma": "letja",
    "cyr": "летя",
    "translation": "fly"
  },
  {
    "lemma": "lěto",
    "cyr": "лято",
    "translation": "summer, year"
  },
  {
    "lemma": "lěv",
    "cyr": "ляв",
    "translation": "left"
  },
  {
    "lemma": "leža",
    "cyr": "лежа",
    "translation": "lay"
  },
  {
    "lemma": "li",
    "cyr": "ли",
    "translation": "(question particle)"
  },
  {
    "lemma": "lice",
    "cyr": "лице",
    "translation": "face"
  },
  {
    "lemma": "ličen",
    "cyr": "личен",
    "translation": "notable"
  },
  {
    "lemma": "lisica",
    "cyr": "лисица",
    "translation": "fox"
  },
  {
    "lemma": "ljubja",
    "cyr": "любя",
    "translation": "love"
  },
  {
    "lemma": "ljubov",
    "cyr": "любов",
    "translation": "love"
  },
  {
    "lemma": "ljudie",
    "cyr": "людие",
    "translation": "people"
  },
  {
    "lemma": "ljut",
    "cyr": "лют",
    "translation": "fierce"
  },
  {
    "lemma": "Log",
    "cyr": "Лог",
    "translation": "Logos"
  },
  {
    "lemma": "Login",
    "cyr": "Логин",
    "translation": "Longinus"
  },
  {
    "lemma": "loi",
    "cyr": "лой",
    "translation": "fat"
  },
  {
    "lemma": "lošinja",
    "cyr": "лошиня",
    "translation": "evil, deceit"
  },
  {
    "lemma": "lov",
    "cyr": "лов",
    "translation": "hunt"
  },
  {
    "lemma": "lozie",
    "cyr": "лозие",
    "translation": "vineyard"
  },
  {
    "lemma": "lud",
    "cyr": "луд",
    "translation": "mad"
  },
  {
    "lemma": "luge",
    "cyr": "луге",
    "translation": "people"
  },
  {
    "lemma": "Luka",
    "cyr": "Лука",
    "translation": "Luke"
  },
  {
    "lemma": "lukav",
    "cyr": "лукав",
    "translation": "evil, cunning"
  },
  {
    "lemma": "lukavština",
    "cyr": "лукавщина",
    "translation": "evil, deceit"
  },
  {
    "lemma": "lъča",
    "cyr": "лъча",
    "translation": "part ways"
  },
  {
    "lemma": "lъstja",
    "cyr": "лъстя",
    "translation": "deceive"
  },
  {
    "lemma": "lъv",
    "cyr": "лъв",
    "translation": "lion"
  },
  {
    "lemma": "lъža",
    "cyr": "лъжа",
    "translation": "lie"
  },
  {
    "lemma": "lъživ",
    "cyr": "лъжив",
    "translation": "deceitful"
  },
  {
    "lemma": "lъžoven",
    "cyr": "лъжовен",
    "translation": "FALSE"
  },
  {
    "lemma": "madiamski",
    "cyr": "мадямски",
    "translation": "of Madiam"
  },
  {
    "lemma": "magesnik",
    "cyr": "магесник",
    "translation": "mage, sorcerer"
  },
  {
    "lemma": "magia",
    "cyr": "магя",
    "translation": "magic"
  },
  {
    "lemma": "Maleleil",
    "cyr": "Малелейл",
    "translation": "Mahalalel"
  },
  {
    "lemma": "maika",
    "cyr": "майка",
    "translation": "mother"
  },
  {
    "lemma": "maikin",
    "cyr": "майкин",
    "translation": "mother's"
  },
  {
    "lemma": "makar",
    "cyr": "макар",
    "translation": "although"
  },
  {
    "lemma": "mal",
    "cyr": "мал",
    "translation": "small"
  },
  {
    "lemma": "malko",
    "cyr": "малко",
    "translation": "very little"
  },
  {
    "lemma": "malo",
    "cyr": "мало",
    "translation": "a little"
  },
  {
    "lemma": "malъk",
    "cyr": "малък",
    "translation": "little"
  },
  {
    "lemma": "manastir",
    "cyr": "манастир",
    "translation": "monastery"
  },
  {
    "lemma": "manastirski",
    "cyr": "манастирски",
    "translation": "of a monastery"
  },
  {
    "lemma": "margarit",
    "cyr": "маргарит",
    "translation": "pearls"
  },
  {
    "lemma": "Maria",
    "cyr": "Маря",
    "translation": "Mary"
  },
  {
    "lemma": "Marko",
    "cyr": "Марко",
    "translation": "Mark"
  },
  {
    "lemma": "Marta",
    "cyr": "Марта",
    "translation": "Martha"
  },
  {
    "lemma": "marturisati",
    "cyr": "мартурисати",
    "translation": "testify"
  },
  {
    "lemma": "mati",
    "cyr": "мати",
    "translation": "mother"
  },
  {
    "lemma": "Matei",
    "cyr": "Матей",
    "translation": "Matthew"
  },
  {
    "lemma": "Matusal",
    "cyr": "Матусал",
    "translation": "Methuselah"
  },
  {
    "lemma": "maxana",
    "cyr": "махана",
    "translation": "lack"
  },
  {
    "lemma": "meč",
    "cyr": "меч",
    "translation": "sword"
  },
  {
    "lemma": "med",
    "cyr": "мед",
    "translation": "honey"
  },
  {
    "lemma": "měd",
    "cyr": "мед",
    "translation": "copper"
  },
  {
    "lemma": "měden",
    "cyr": "меден",
    "translation": "of copper"
  },
  {
    "lemma": "měra",
    "cyr": "мяра",
    "translation": "measure"
  },
  {
    "lemma": "mesec",
    "cyr": "месец",
    "translation": "moon, month"
  },
  {
    "lemma": "město",
    "cyr": "място",
    "translation": "place"
  },
  {
    "lemma": "metna",
    "cyr": "метна",
    "translation": "throw"
  },
  {
    "lemma": "metnuvam",
    "cyr": "метнувам",
    "translation": "throw"
  },
  {
    "lemma": "metox",
    "cyr": "метох",
    "translation": "monastery ground"
  },
  {
    "lemma": "měx",
    "cyr": "мях",
    "translation": "sack"
  },
  {
    "lemma": "meždu",
    "cyr": "между",
    "translation": "between"
  },
  {
    "lemma": "mie",
    "cyr": "мие",
    "translation": "we"
  },
  {
    "lemma": "mignovenie",
    "cyr": "мигновение",
    "translation": "moment"
  },
  {
    "lemma": "mil",
    "cyr": "мил",
    "translation": "nice"
  },
  {
    "lemma": "milost",
    "cyr": "милост",
    "translation": "mercy"
  },
  {
    "lemma": "milostinja",
    "cyr": "милостиня",
    "translation": "alms"
  },
  {
    "lemma": "milostiv",
    "cyr": "милостив",
    "translation": "merciful"
  },
  {
    "lemma": "milosъrdie",
    "cyr": "милосърдие",
    "translation": "mercy"
  },
  {
    "lemma": "miluvam",
    "cyr": "милувам",
    "translation": "love"
  },
  {
    "lemma": "mina",
    "cyr": "мина",
    "translation": "pass"
  },
  {
    "lemma": "minuvam",
    "cyr": "минувам",
    "translation": "pass"
  },
  {
    "lemma": "mir",
    "cyr": "мир",
    "translation": "world, peace"
  },
  {
    "lemma": "mirnen",
    "cyr": "мирнен",
    "translation": "scented"
  },
  {
    "lemma": "mislja",
    "cyr": "мисля",
    "translation": "think"
  },
  {
    "lemma": "misъl",
    "cyr": "мисъл",
    "translation": "thought, mind"
  },
  {
    "lemma": "mitar",
    "cyr": "митар",
    "translation": "tax collector"
  },
  {
    "lemma": "mito",
    "cyr": "мито",
    "translation": "tax, fare"
  },
  {
    "lemma": "Mixail",
    "cyr": "Михайл",
    "translation": "Michael"
  },
  {
    "lemma": "Mixailov",
    "cyr": "Михайлов",
    "translation": "Michael's"
  },
  {
    "lemma": "mlad",
    "cyr": "млад",
    "translation": "young"
  },
  {
    "lemma": "mladenec",
    "cyr": "младенец",
    "translation": "baby"
  },
  {
    "lemma": "mladica",
    "cyr": "младица",
    "translation": "girl"
  },
  {
    "lemma": "mlogo",
    "cyr": "млого",
    "translation": "much"
  },
  {
    "lemma": "mlogocenen",
    "cyr": "млогоценен",
    "translation": "precious"
  },
  {
    "lemma": "mnog",
    "cyr": "мног",
    "translation": "numerous"
  },
  {
    "lemma": "mnogo",
    "cyr": "много",
    "translation": "much"
  },
  {
    "lemma": "mnozina",
    "cyr": "мнозина",
    "translation": "many"
  },
  {
    "lemma": "moga",
    "cyr": "мога",
    "translation": "can"
  },
  {
    "lemma": "moi",
    "cyr": "мой",
    "translation": "my"
  },
  {
    "lemma": "Mokreš",
    "cyr": "Мокреш",
    "translation": "Mokreš"
  },
  {
    "lemma": "molenie",
    "cyr": "моление",
    "translation": "praying"
  },
  {
    "lemma": "molitva",
    "cyr": "молитва",
    "translation": "prayer"
  },
  {
    "lemma": "molitvenik",
    "cyr": "молитвеник",
    "translation": "prayer book"
  },
  {
    "lemma": "molja",
    "cyr": "моля",
    "translation": "pray"
  },
  {
    "lemma": "moma",
    "cyr": "мома",
    "translation": "girl"
  },
  {
    "lemma": "momče",
    "cyr": "момче",
    "translation": "boy"
  },
  {
    "lemma": "momъk",
    "cyr": "момък",
    "translation": "boy"
  },
  {
    "lemma": "monax",
    "cyr": "монах",
    "translation": "monk"
  },
  {
    "lemma": "mor",
    "cyr": "мор",
    "translation": "plague"
  },
  {
    "lemma": "more",
    "cyr": "море",
    "translation": "sea"
  },
  {
    "lemma": "morski",
    "cyr": "морски",
    "translation": "of sea"
  },
  {
    "lemma": "mračen",
    "cyr": "мрачен",
    "translation": "cloudy, dark"
  },
  {
    "lemma": "mrak",
    "cyr": "мрак",
    "translation": "cloud"
  },
  {
    "lemma": "mramor",
    "cyr": "мрамор",
    "translation": "mortar (stone)"
  },
  {
    "lemma": "mrъsen",
    "cyr": "мръсен",
    "translation": "filthy"
  },
  {
    "lemma": "mužski",
    "cyr": "мужски",
    "translation": "male"
  },
  {
    "lemma": "mъča",
    "cyr": "мъча",
    "translation": "torture"
  },
  {
    "lemma": "mъčenie",
    "cyr": "мъчение",
    "translation": "torture"
  },
  {
    "lemma": "mъčenik",
    "cyr": "мъченик",
    "translation": "martyr"
  },
  {
    "lemma": "mъčitel",
    "cyr": "мъчител",
    "translation": "tormentor"
  },
  {
    "lemma": "mъdrost",
    "cyr": "мъдрост",
    "translation": "wisdom"
  },
  {
    "lemma": "mъdъr",
    "cyr": "мъдър",
    "translation": "wise"
  },
  {
    "lemma": "mъgla",
    "cyr": "мъгла",
    "translation": "mist"
  },
  {
    "lemma": "mъka",
    "cyr": "мъка",
    "translation": "torment"
  },
  {
    "lemma": "mъrtvec",
    "cyr": "мъртвец",
    "translation": "corpse"
  },
  {
    "lemma": "mъrtъv",
    "cyr": "мъртъв",
    "translation": "dead"
  },
  {
    "lemma": "mъska",
    "cyr": "мъска",
    "translation": "mule"
  },
  {
    "lemma": "mъž",
    "cyr": "мъж",
    "translation": "man"
  },
  {
    "lemma": "mъžki",
    "cyr": "мъжки",
    "translation": "male"
  },
  {
    "lemma": "mьnečki",
    "cyr": "мьнечки",
    "translation": "very small"
  },
  {
    "lemma": "na",
    "cyr": "на",
    "translation": "on, to, for"
  },
  {
    "lemma": "načalen",
    "cyr": "начален",
    "translation": "foremost"
  },
  {
    "lemma": "načalo",
    "cyr": "начало",
    "translation": "beginning"
  },
  {
    "lemma": "načelnik",
    "cyr": "начелник",
    "translation": "chieftain"
  },
  {
    "lemma": "načna",
    "cyr": "начна",
    "translation": "begin"
  },
  {
    "lemma": "nad",
    "cyr": "над",
    "translation": "over"
  },
  {
    "lemma": "nadeja",
    "cyr": "надея",
    "translation": "hope"
  },
  {
    "lemma": "nadežda",
    "cyr": "надежда",
    "translation": "hope"
  },
  {
    "lemma": "nadolu",
    "cyr": "надолу",
    "translation": "downward"
  },
  {
    "lemma": "nadvija",
    "cyr": "надвия",
    "translation": "defeat"
  },
  {
    "lemma": "nadvivam",
    "cyr": "надвивам",
    "translation": "defeat"
  },
  {
    "lemma": "nadvor",
    "cyr": "надвор",
    "translation": "outside"
  },
  {
    "lemma": "naedno",
    "cyr": "наедно",
    "translation": "together"
  },
  {
    "lemma": "nagore",
    "cyr": "нагоре",
    "translation": "upward"
  },
  {
    "lemma": "nagovorja",
    "cyr": "наговоря",
    "translation": "convince"
  },
  {
    "lemma": "nai",
    "cyr": "най",
    "translation": "(superlative particle)"
  },
  {
    "lemma": "naida",
    "cyr": "найда",
    "translation": "find"
  },
  {
    "lemma": "nakaža",
    "cyr": "накажа",
    "translation": "convict"
  },
  {
    "lemma": "naklevetja",
    "cyr": "наклеветя",
    "translation": "slander"
  },
  {
    "lemma": "naleja",
    "cyr": "налея",
    "translation": "pour in"
  },
  {
    "lemma": "nali",
    "cyr": "нали",
    "translation": "(question particle)"
  },
  {
    "lemma": "namerja",
    "cyr": "намеря",
    "translation": "find"
  },
  {
    "lemma": "naměsto",
    "cyr": "намясто",
    "translation": "instead"
  },
  {
    "lemma": "namislja",
    "cyr": "намисля",
    "translation": "conceive a plan"
  },
  {
    "lemma": "naorъžja",
    "cyr": "наоръжя",
    "translation": "take arms"
  },
  {
    "lemma": "napadam",
    "cyr": "нападам",
    "translation": "attack"
  },
  {
    "lemma": "napast",
    "cyr": "напаст",
    "translation": "misfortune"
  },
  {
    "lemma": "napečatam",
    "cyr": "напечатам",
    "translation": "print"
  },
  {
    "lemma": "napija",
    "cyr": "напия",
    "translation": "drink"
  },
  {
    "lemma": "napiša",
    "cyr": "напиша",
    "translation": "write"
  },
  {
    "lemma": "napoja",
    "cyr": "напоя",
    "translation": "give drink"
  },
  {
    "lemma": "naprasno",
    "cyr": "напрасно",
    "translation": "suddenly"
  },
  {
    "lemma": "naprava",
    "cyr": "направа",
    "translation": "work, product"
  },
  {
    "lemma": "napravja",
    "cyr": "направя",
    "translation": "make"
  },
  {
    "lemma": "napravljati",
    "cyr": "направляти",
    "translation": "direct"
  },
  {
    "lemma": "napred",
    "cyr": "напред",
    "translation": "forward"
  },
  {
    "lemma": "napъlnja",
    "cyr": "напълня",
    "translation": "fill"
  },
  {
    "lemma": "naraždam",
    "cyr": "нараждам",
    "translation": "give birth"
  },
  {
    "lemma": "nareka",
    "cyr": "нарека",
    "translation": "call"
  },
  {
    "lemma": "naričam",
    "cyr": "наричам",
    "translation": "call"
  },
  {
    "lemma": "narod",
    "cyr": "народ",
    "translation": "nation"
  },
  {
    "lemma": "naš",
    "cyr": "наш",
    "translation": "our"
  },
  {
    "lemma": "nasadja",
    "cyr": "насадя",
    "translation": "put on"
  },
  {
    "lemma": "naselja",
    "cyr": "населя",
    "translation": "settle"
  },
  {
    "lemma": "nasilstvo",
    "cyr": "насилство",
    "translation": "violence"
  },
  {
    "lemma": "nasipa",
    "cyr": "насипа",
    "translation": "pour"
  },
  {
    "lemma": "nasitja",
    "cyr": "наситя",
    "translation": "satiate"
  },
  {
    "lemma": "nasrešta",
    "cyr": "насреща",
    "translation": "towards, against"
  },
  {
    "lemma": "nastavja",
    "cyr": "наставя",
    "translation": "set up"
  },
  {
    "lemma": "nastoinik",
    "cyr": "настойник",
    "translation": "sponsor, guardian"
  },
  {
    "lemma": "nastojatel",
    "cyr": "настоятел",
    "translation": "overseer"
  },
  {
    "lemma": "nastriža",
    "cyr": "настрижа",
    "translation": "cut hair"
  },
  {
    "lemma": "natovarja",
    "cyr": "натоваря",
    "translation": "put a burden"
  },
  {
    "lemma": "natъkmja",
    "cyr": "натъкмя",
    "translation": "strengthen"
  },
  {
    "lemma": "nauča",
    "cyr": "науча",
    "translation": "teach, learn"
  },
  {
    "lemma": "navrъx",
    "cyr": "навръх",
    "translation": "to the top"
  },
  {
    "lemma": "navъrša",
    "cyr": "навърша",
    "translation": "reach"
  },
  {
    "lemma": "nazad",
    "cyr": "назад",
    "translation": "backward"
  },
  {
    "lemma": "ne",
    "cyr": "не",
    "translation": "no, not"
  },
  {
    "lemma": "nebe",
    "cyr": "небе",
    "translation": "heaven, sky"
  },
  {
    "lemma": "nebesen",
    "cyr": "небесен",
    "translation": "of heaven, sky"
  },
  {
    "lemma": "nedelja",
    "cyr": "неделя",
    "translation": "Sunday"
  },
  {
    "lemma": "nedostoinstvo",
    "cyr": "недостойнство",
    "translation": "unworthiness"
  },
  {
    "lemma": "něgde",
    "cyr": "нягде",
    "translation": "somewhere"
  },
  {
    "lemma": "negov",
    "cyr": "негов",
    "translation": "his"
  },
  {
    "lemma": "nein",
    "cyr": "нейн",
    "translation": "her"
  },
  {
    "lemma": "někak",
    "cyr": "някак",
    "translation": "somehow"
  },
  {
    "lemma": "někakvo",
    "cyr": "някакво",
    "translation": "something"
  },
  {
    "lemma": "někoga",
    "cyr": "някога",
    "translation": "sometimes"
  },
  {
    "lemma": "někoi",
    "cyr": "някой",
    "translation": "someone"
  },
  {
    "lemma": "několko",
    "cyr": "няколко",
    "translation": "some"
  },
  {
    "lemma": "někъde",
    "cyr": "някъде",
    "translation": "somewhere"
  },
  {
    "lemma": "nelo",
    "cyr": "нело",
    "translation": "because, but"
  },
  {
    "lemma": "nenavidja",
    "cyr": "ненавидя",
    "translation": "hate, dislike"
  },
  {
    "lemma": "nenavistnik",
    "cyr": "ненавистник",
    "translation": "hater"
  },
  {
    "lemma": "Neofit",
    "cyr": "Неофит",
    "translation": "Neophyte"
  },
  {
    "lemma": "Neropol",
    "cyr": "Неропол",
    "translation": "Neropolis"
  },
  {
    "lemma": "nešto",
    "cyr": "нещо",
    "translation": "something"
  },
  {
    "lemma": "nevernik",
    "cyr": "неверник",
    "translation": "unbeliever"
  },
  {
    "lemma": "nevesta",
    "cyr": "невеста",
    "translation": "bride"
  },
  {
    "lemma": "nevolja",
    "cyr": "неволя",
    "translation": "misfortune"
  },
  {
    "lemma": "nevъzderžanie",
    "cyr": "невъздержание",
    "translation": "intemperance"
  },
  {
    "lemma": "nexel",
    "cyr": "нехел",
    "translation": "malady"
  },
  {
    "lemma": "neželi",
    "cyr": "нежели",
    "translation": "than"
  },
  {
    "lemma": "nezlobie",
    "cyr": "незлобие",
    "translation": "innocence"
  },
  {
    "lemma": "ni",
    "cyr": "ни",
    "translation": "nor"
  },
  {
    "lemma": "ničto",
    "cyr": "ничто",
    "translation": "nothing"
  },
  {
    "lemma": "nie",
    "cyr": "ние",
    "translation": "we"
  },
  {
    "lemma": "nigde",
    "cyr": "нигде",
    "translation": "nowhere"
  },
  {
    "lemma": "nikak",
    "cyr": "никак",
    "translation": "in no way"
  },
  {
    "lemma": "nikakvo",
    "cyr": "никакво",
    "translation": "nothing"
  },
  {
    "lemma": "nikakъv",
    "cyr": "никакъв",
    "translation": "none"
  },
  {
    "lemma": "Nikodim",
    "cyr": "Никодим",
    "translation": "Nicodemus"
  },
  {
    "lemma": "nikogda",
    "cyr": "никогда",
    "translation": "never"
  },
  {
    "lemma": "nikoi",
    "cyr": "никой",
    "translation": "nobody, none"
  },
  {
    "lemma": "Nikolai",
    "cyr": "Николай",
    "translation": "Nicholas"
  },
  {
    "lemma": "ništo",
    "cyr": "нищо",
    "translation": "nothing"
  },
  {
    "lemma": "niti",
    "cyr": "нити",
    "translation": "neither"
  },
  {
    "lemma": "niva",
    "cyr": "нива",
    "translation": "field, acre"
  },
  {
    "lemma": "nixen",
    "cyr": "нихен",
    "translation": "their"
  },
  {
    "lemma": "niz",
    "cyr": "низ",
    "translation": "under"
  },
  {
    "lemma": "niže",
    "cyr": "ниже",
    "translation": "nor"
  },
  {
    "lemma": "no",
    "cyr": "но",
    "translation": "but"
  },
  {
    "lemma": "noemvri",
    "cyr": "ноември",
    "translation": "November"
  },
  {
    "lemma": "noga",
    "cyr": "нога",
    "translation": "leg"
  },
  {
    "lemma": "nos",
    "cyr": "нос",
    "translation": "nose"
  },
  {
    "lemma": "nosja",
    "cyr": "нося",
    "translation": "carry"
  },
  {
    "lemma": "nošt",
    "cyr": "нощ",
    "translation": "night"
  },
  {
    "lemma": "nošteska",
    "cyr": "нощеска",
    "translation": "by night"
  },
  {
    "lemma": "noštuvam",
    "cyr": "нощувам",
    "translation": "spend night"
  },
  {
    "lemma": "nov",
    "cyr": "нов",
    "translation": "new"
  },
  {
    "lemma": "nož",
    "cyr": "нож",
    "translation": "knife"
  },
  {
    "lemma": "nožle",
    "cyr": "ножле",
    "translation": "small knife"
  },
  {
    "lemma": "nožlence",
    "cyr": "ножленце",
    "translation": "small knife"
  },
  {
    "lemma": "nudja",
    "cyr": "нудя",
    "translation": "prepare"
  },
  {
    "lemma": "nužda",
    "cyr": "нужда",
    "translation": "need"
  },
  {
    "lemma": "nyně",
    "cyr": "ныня",
    "translation": "now"
  },
  {
    "lemma": "o",
    "cyr": "o",
    "translation": "oh"
  },
  {
    "lemma": "o (2)",
    "cyr": "о (2)",
    "translation": "about"
  },
  {
    "lemma": "obadja",
    "cyr": "обадя",
    "translation": "call"
  },
  {
    "lemma": "oběd",
    "cyr": "обяд",
    "translation": "lunch, noon"
  },
  {
    "lemma": "obera",
    "cyr": "обера",
    "translation": "rob"
  },
  {
    "lemma": "obesja",
    "cyr": "обеся",
    "translation": "hang (execute)"
  },
  {
    "lemma": "obiden",
    "cyr": "обиден",
    "translation": "poor"
  },
  {
    "lemma": "obidnica",
    "cyr": "обидница",
    "translation": "miserable woman"
  },
  {
    "lemma": "obidnik",
    "cyr": "обидник",
    "translation": "miserable man"
  },
  {
    "lemma": "obitičam",
    "cyr": "обитичам",
    "translation": "flow around"
  },
  {
    "lemma": "objavja",
    "cyr": "обявя",
    "translation": "announce"
  },
  {
    "lemma": "oblak",
    "cyr": "облак",
    "translation": "cloud"
  },
  {
    "lemma": "obleka",
    "cyr": "облека",
    "translation": "put on (clothes)"
  },
  {
    "lemma": "obleža",
    "cyr": "облежа",
    "translation": "rape"
  },
  {
    "lemma": "obraštam",
    "cyr": "обращам",
    "translation": "turn"
  },
  {
    "lemma": "obraz",
    "cyr": "образ",
    "translation": "picture"
  },
  {
    "lemma": "obvija",
    "cyr": "обвия",
    "translation": "wrap"
  },
  {
    "lemma": "obvladati",
    "cyr": "обвладати",
    "translation": "rule"
  },
  {
    "lemma": "obzaloža",
    "cyr": "обзаложа",
    "translation": "lay a bet"
  },
  {
    "lemma": "obъrna",
    "cyr": "обърна",
    "translation": "turn"
  },
  {
    "lemma": "očistja",
    "cyr": "очистя",
    "translation": "clean"
  },
  {
    "lemma": "odaja",
    "cyr": "одая",
    "translation": "chamber"
  },
  {
    "lemma": "odъr",
    "cyr": "одър",
    "translation": "(wooden) bed"
  },
  {
    "lemma": "odъždja",
    "cyr": "одъждя",
    "translation": "make rainy"
  },
  {
    "lemma": "ogladneja",
    "cyr": "огладнея",
    "translation": "become hungry"
  },
  {
    "lemma": "oglavlenie",
    "cyr": "оглавление",
    "translation": "title"
  },
  {
    "lemma": "ognen",
    "cyr": "огнен",
    "translation": "fiery"
  },
  {
    "lemma": "ogolja",
    "cyr": "оголя",
    "translation": "shave"
  },
  {
    "lemma": "ogrižja",
    "cyr": "огрижя",
    "translation": "become worry"
  },
  {
    "lemma": "ogъn",
    "cyr": "огън",
    "translation": "fire"
  },
  {
    "lemma": "okaja",
    "cyr": "окая",
    "translation": "complain, become worry"
  },
  {
    "lemma": "okajanik",
    "cyr": "окаяник",
    "translation": "poor one"
  },
  {
    "lemma": "oko",
    "cyr": "око",
    "translation": "eye"
  },
  {
    "lemma": "okolo",
    "cyr": "около",
    "translation": "around"
  },
  {
    "lemma": "okova",
    "cyr": "окова",
    "translation": "wrap in metal"
  },
  {
    "lemma": "okrъža",
    "cyr": "окръжа",
    "translation": "attack from all sides"
  },
  {
    "lemma": "okъpja",
    "cyr": "окъпя",
    "translation": "bathe"
  },
  {
    "lemma": "oltar",
    "cyr": "олтар",
    "translation": "altar"
  },
  {
    "lemma": "omesja",
    "cyr": "омеся",
    "translation": "knead"
  },
  {
    "lemma": "omija",
    "cyr": "омия",
    "translation": "wash"
  },
  {
    "lemma": "omoča",
    "cyr": "омоча",
    "translation": "dip"
  },
  {
    "lemma": "on",
    "cyr": "он",
    "translation": "he"
  },
  {
    "lemma": "ona",
    "cyr": "она",
    "translation": "she"
  },
  {
    "lemma": "oni",
    "cyr": "они",
    "translation": "they"
  },
  {
    "lemma": "onja",
    "cyr": "оня",
    "translation": "that"
  },
  {
    "lemma": "ono",
    "cyr": "оно",
    "translation": "it"
  },
  {
    "lemma": "onova",
    "cyr": "онова",
    "translation": "that"
  },
  {
    "lemma": "opaša",
    "cyr": "опаша",
    "translation": "put a belt on"
  },
  {
    "lemma": "opera",
    "cyr": "опера",
    "translation": "lean, fight"
  },
  {
    "lemma": "opiram",
    "cyr": "опирам",
    "translation": "lean, fight"
  },
  {
    "lemma": "opiša",
    "cyr": "опиша",
    "translation": "describe"
  },
  {
    "lemma": "oplenja",
    "cyr": "опленя",
    "translation": "loot"
  },
  {
    "lemma": "opovivam",
    "cyr": "оповивам",
    "translation": "wrap"
  },
  {
    "lemma": "opravja",
    "cyr": "оправя",
    "translation": "make clear, put in order"
  },
  {
    "lemma": "oprostja",
    "cyr": "опростя",
    "translation": "forgive"
  },
  {
    "lemma": "oranie",
    "cyr": "орание",
    "translation": "ploughing"
  },
  {
    "lemma": "orel",
    "cyr": "орел",
    "translation": "eagle"
  },
  {
    "lemma": "Orna",
    "cyr": "Орна",
    "translation": "Araunah"
  },
  {
    "lemma": "ortografija",
    "cyr": "ортография",
    "translation": "orthography"
  },
  {
    "lemma": "orъžie",
    "cyr": "оръжие",
    "translation": "weapon"
  },
  {
    "lemma": "oskubja",
    "cyr": "оскубя",
    "translation": "pluck off"
  },
  {
    "lemma": "oskъden",
    "cyr": "оскъден",
    "translation": "lacking"
  },
  {
    "lemma": "oskъrbja",
    "cyr": "оскърбя",
    "translation": "make sad"
  },
  {
    "lemma": "oslěpuvam",
    "cyr": "осляпувам",
    "translation": "make blind"
  },
  {
    "lemma": "ostana",
    "cyr": "остана",
    "translation": "remain"
  },
  {
    "lemma": "ostanok",
    "cyr": "останок",
    "translation": "remainder, lot"
  },
  {
    "lemma": "ostavja",
    "cyr": "оставя",
    "translation": "leave"
  },
  {
    "lemma": "ostavjam",
    "cyr": "оставям",
    "translation": "leave"
  },
  {
    "lemma": "ošte",
    "cyr": "още",
    "translation": "yet"
  },
  {
    "lemma": "ostrja",
    "cyr": "остря",
    "translation": "sharpen"
  },
  {
    "lemma": "ostrov",
    "cyr": "остров",
    "translation": "island"
  },
  {
    "lemma": "ostruža",
    "cyr": "остружа",
    "translation": "scrub"
  },
  {
    "lemma": "ostъr",
    "cyr": "остър",
    "translation": "sharp"
  },
  {
    "lemma": "osvętja",
    "cyr": "осветя",
    "translation": "sanctify"
  },
  {
    "lemma": "osъdnik",
    "cyr": "осъдник",
    "translation": "convict"
  },
  {
    "lemma": "osъdja",
    "cyr": "осъдя",
    "translation": "convict"
  },
  {
    "lemma": "osъm",
    "cyr": "осъм",
    "translation": "eight"
  },
  {
    "lemma": "ot",
    "cyr": "от",
    "translation": "from"
  },
  {
    "lemma": "otběgna",
    "cyr": "отбягна",
    "translation": "run away"
  },
  {
    "lemma": "otbija",
    "cyr": "отбия",
    "translation": "repel"
  },
  {
    "lemma": "otdam",
    "cyr": "отдам",
    "translation": "give in return"
  },
  {
    "lemma": "otdъxna",
    "cyr": "отдъхна",
    "translation": "rest"
  },
  {
    "lemma": "otec",
    "cyr": "отец",
    "translation": "father"
  },
  {
    "lemma": "otečestvo",
    "cyr": "отечество",
    "translation": "fatherland"
  },
  {
    "lemma": "otfъrgam",
    "cyr": "отфъргам",
    "translation": "take off"
  },
  {
    "lemma": "otfъrlja",
    "cyr": "отфърля",
    "translation": "throw away"
  },
  {
    "lemma": "otgovorja",
    "cyr": "отговоря",
    "translation": "answer"
  },
  {
    "lemma": "oti",
    "cyr": "оти",
    "translation": "because"
  },
  {
    "lemma": "otida",
    "cyr": "отида",
    "translation": "leave, go away"
  },
  {
    "lemma": "otkina",
    "cyr": "откина",
    "translation": "tear off"
  },
  {
    "lemma": "otkradna",
    "cyr": "открадна",
    "translation": "steal"
  },
  {
    "lemma": "otkrija",
    "cyr": "открия",
    "translation": "discover, uncover"
  },
  {
    "lemma": "otkrivam",
    "cyr": "откривам",
    "translation": "discover, uncover"
  },
  {
    "lemma": "otloža",
    "cyr": "отложа",
    "translation": "put away"
  },
  {
    "lemma": "otlъča",
    "cyr": "отлъча",
    "translation": "separate"
  },
  {
    "lemma": "otnema",
    "cyr": "отнема",
    "translation": "take away"
  },
  {
    "lemma": "otnesa",
    "cyr": "отнеса",
    "translation": "carry out"
  },
  {
    "lemma": "otpadna",
    "cyr": "отпадна",
    "translation": "fall away, go astray"
  },
  {
    "lemma": "otpeja",
    "cyr": "отпея",
    "translation": "sing through"
  },
  {
    "lemma": "otpustja",
    "cyr": "отпустя",
    "translation": "forgive"
  },
  {
    "lemma": "otpъdja",
    "cyr": "отпъдя",
    "translation": "chase away"
  },
  {
    "lemma": "otreka",
    "cyr": "отрека",
    "translation": "renounce"
  },
  {
    "lemma": "otrina",
    "cyr": "отрина",
    "translation": "vanquish"
  },
  {
    "lemma": "otroče",
    "cyr": "отроче",
    "translation": "child, baby"
  },
  {
    "lemma": "otsečenie",
    "cyr": "отсечение",
    "translation": "cruelty, massacre"
  },
  {
    "lemma": "otseka",
    "cyr": "отсека",
    "translation": "cut off"
  },
  {
    "lemma": "otsluža",
    "cyr": "отслужа",
    "translation": "perform a service"
  },
  {
    "lemma": "otstъpja",
    "cyr": "отстъпя",
    "translation": "step away"
  },
  {
    "lemma": "otsъdja",
    "cyr": "отсъдя",
    "translation": "convict"
  },
  {
    "lemma": "ottъrčam",
    "cyr": "оттърчам",
    "translation": "run away"
  },
  {
    "lemma": "otvarjam",
    "cyr": "отварям",
    "translation": "open"
  },
  {
    "lemma": "otvět",
    "cyr": "отвят",
    "translation": "answer"
  },
  {
    "lemma": "otvodja",
    "cyr": "отводя",
    "translation": "walk away"
  },
  {
    "lemma": "otvorja",
    "cyr": "отворя",
    "translation": "open"
  },
  {
    "lemma": "otvъrvam",
    "cyr": "отвървам",
    "translation": "walk away"
  },
  {
    "lemma": "otvъrža",
    "cyr": "отвържа",
    "translation": "unbind"
  },
  {
    "lemma": "otxapna",
    "cyr": "отхапна",
    "translation": "bite off"
  },
  {
    "lemma": "otxranja",
    "cyr": "отхраня",
    "translation": "raise"
  },
  {
    "lemma": "otъvna",
    "cyr": "отъвна",
    "translation": "take away"
  },
  {
    "lemma": "ovca",
    "cyr": "овца",
    "translation": "sheep"
  },
  {
    "lemma": "oven",
    "cyr": "овен",
    "translation": "ram"
  },
  {
    "lemma": "ovija",
    "cyr": "овия",
    "translation": "wrap around"
  },
  {
    "lemma": "ox",
    "cyr": "ох",
    "translation": "o"
  },
  {
    "lemma": "ozdravja",
    "cyr": "оздравя",
    "translation": "become healthy"
  },
  {
    "lemma": "oženja",
    "cyr": "оженя",
    "translation": "marry"
  },
  {
    "lemma": "oživeja",
    "cyr": "оживея",
    "translation": "become alive"
  },
  {
    "lemma": "oživeniča",
    "cyr": "оживенича",
    "translation": "become ill of scrofula"
  },
  {
    "lemma": "oživja",
    "cyr": "оживя",
    "translation": "resurrect"
  },
  {
    "lemma": "pa",
    "cyr": "па",
    "translation": "and then"
  },
  {
    "lemma": "padam",
    "cyr": "падам",
    "translation": "fall"
  },
  {
    "lemma": "Padia",
    "cyr": "Падия",
    "translation": "Padia"
  },
  {
    "lemma": "padna",
    "cyr": "падна",
    "translation": "fall"
  },
  {
    "lemma": "pak",
    "cyr": "пак",
    "translation": "again"
  },
  {
    "lemma": "paki",
    "cyr": "паки",
    "translation": "again"
  },
  {
    "lemma": "pakost",
    "cyr": "пакост",
    "translation": "disturbance, injury"
  },
  {
    "lemma": "palja",
    "cyr": "паля",
    "translation": "burn"
  },
  {
    "lemma": "pamet",
    "cyr": "памет",
    "translation": "memory, mind"
  },
  {
    "lemma": "para",
    "cyr": "пара",
    "translation": "coin"
  },
  {
    "lemma": "Paraskeva",
    "cyr": "Параскева",
    "translation": "Parascheva"
  },
  {
    "lemma": "pastir",
    "cyr": "пастир",
    "translation": "shepherd"
  },
  {
    "lemma": "paterica",
    "cyr": "патерица",
    "translation": "crutch"
  },
  {
    "lemma": "patja",
    "cyr": "патя",
    "translation": "fare"
  },
  {
    "lemma": "patriarx",
    "cyr": "патрярх",
    "translation": "patriarch"
  },
  {
    "lemma": "pazar",
    "cyr": "пазар",
    "translation": "market"
  },
  {
    "lemma": "pazja",
    "cyr": "пазя",
    "translation": "guard"
  },
  {
    "lemma": "pazuxa",
    "cyr": "пазуха",
    "translation": "armpit"
  },
  {
    "lemma": "pečalba",
    "cyr": "печалба",
    "translation": "revenue"
  },
  {
    "lemma": "pečalja",
    "cyr": "печаля",
    "translation": "worry"
  },
  {
    "lemma": "pečat",
    "cyr": "печат",
    "translation": "seal"
  },
  {
    "lemma": "peja",
    "cyr": "пея",
    "translation": "sing"
  },
  {
    "lemma": "pek",
    "cyr": "пек",
    "translation": "sun heat"
  },
  {
    "lemma": "peka",
    "cyr": "пека",
    "translation": "bake"
  },
  {
    "lemma": "pelena",
    "cyr": "пелена",
    "translation": "diaper"
  },
  {
    "lemma": "pelin",
    "cyr": "пелин",
    "translation": "wormwood"
  },
  {
    "lemma": "pernat",
    "cyr": "пернат",
    "translation": "feathery"
  },
  {
    "lemma": "pepel",
    "cyr": "пепел",
    "translation": "ash"
  },
  {
    "lemma": "pesen",
    "cyr": "песен",
    "translation": "song"
  },
  {
    "lemma": "peštera",
    "cyr": "пещера",
    "translation": "cave"
  },
  {
    "lemma": "pěsъk",
    "cyr": "пясък",
    "translation": "sand"
  },
  {
    "lemma": "pet",
    "cyr": "пет",
    "translation": "five"
  },
  {
    "lemma": "peta",
    "cyr": "пета",
    "translation": "heel"
  },
  {
    "lemma": "Petka",
    "cyr": "Петка",
    "translation": "Petka"
  },
  {
    "lemma": "Petъr",
    "cyr": "Петър",
    "translation": "Peter"
  },
  {
    "lemma": "petina",
    "cyr": "петина",
    "translation": "group of five"
  },
  {
    "lemma": "pija",
    "cyr": "пия",
    "translation": "drink"
  },
  {
    "lemma": "pijan",
    "cyr": "пиян",
    "translation": "drunk"
  },
  {
    "lemma": "pijanica",
    "cyr": "пияница",
    "translation": "drunkard"
  },
  {
    "lemma": "pijanstvo",
    "cyr": "пиянство",
    "translation": "(excessive) drinking"
  },
  {
    "lemma": "Pilat",
    "cyr": "Пилат",
    "translation": "Pilate"
  },
  {
    "lemma": "Pilatov",
    "cyr": "Пилатов",
    "translation": "Pilate's"
  },
  {
    "lemma": "pipam",
    "cyr": "пипам",
    "translation": "touch"
  },
  {
    "lemma": "piron",
    "cyr": "пирон",
    "translation": "nail"
  },
  {
    "lemma": "piša",
    "cyr": "пиша",
    "translation": "write"
  },
  {
    "lemma": "pisanie",
    "cyr": "писание",
    "translation": "letter, scripture"
  },
  {
    "lemma": "pisatel",
    "cyr": "писател",
    "translation": "writer"
  },
  {
    "lemma": "pismo",
    "cyr": "писмо",
    "translation": "letter"
  },
  {
    "lemma": "pisna",
    "cyr": "писна",
    "translation": "cease to care"
  },
  {
    "lemma": "pitam",
    "cyr": "питам",
    "translation": "ask"
  },
  {
    "lemma": "pitie",
    "cyr": "питие",
    "translation": "drink"
  },
  {
    "lemma": "plač",
    "cyr": "плач",
    "translation": "cry"
  },
  {
    "lemma": "plača",
    "cyr": "плача",
    "translation": "cry, weep"
  },
  {
    "lemma": "pladne",
    "cyr": "пладне",
    "translation": "noon"
  },
  {
    "lemma": "plamen",
    "cyr": "пламен",
    "translation": "flame"
  },
  {
    "lemma": "planina",
    "cyr": "планина",
    "translation": "mountains"
  },
  {
    "lemma": "plaša",
    "cyr": "плаша",
    "translation": "scare off"
  },
  {
    "lemma": "platno",
    "cyr": "платно",
    "translation": "cloth"
  },
  {
    "lemma": "plenja",
    "cyr": "пленя",
    "translation": "loot"
  },
  {
    "lemma": "plešti",
    "cyr": "плещи",
    "translation": "shoulders"
  },
  {
    "lemma": "pleta",
    "cyr": "плета",
    "translation": "weave"
  },
  {
    "lemma": "ploča",
    "cyr": "плоча",
    "translation": "slab"
  },
  {
    "lemma": "plod",
    "cyr": "плод",
    "translation": "fruit"
  },
  {
    "lemma": "ploden",
    "cyr": "плоден",
    "translation": "fruitful"
  },
  {
    "lemma": "pluvam",
    "cyr": "плувам",
    "translation": "swim"
  },
  {
    "lemma": "plъt",
    "cyr": "плът",
    "translation": "flesh"
  },
  {
    "lemma": "po",
    "cyr": "по",
    "translation": "after, along, according to"
  },
  {
    "lemma": "po (2)",
    "cyr": "по (2)",
    "translation": "(comparative particle)"
  },
  {
    "lemma": "pobeda",
    "cyr": "победа",
    "translation": "victory"
  },
  {
    "lemma": "pobeditel",
    "cyr": "победител",
    "translation": "victor"
  },
  {
    "lemma": "pobedja",
    "cyr": "победя",
    "translation": "defeat"
  },
  {
    "lemma": "poběgna",
    "cyr": "побягна",
    "translation": "run away"
  },
  {
    "lemma": "pobesneja",
    "cyr": "побеснея",
    "translation": "become mad"
  },
  {
    "lemma": "pobesněva",
    "cyr": "побеснява",
    "translation": "become mad"
  },
  {
    "lemma": "počekna",
    "cyr": "почекна",
    "translation": "injure"
  },
  {
    "lemma": "počest",
    "cyr": "почест",
    "translation": "honor (act of honoring)"
  },
  {
    "lemma": "početa",
    "cyr": "почета",
    "translation": "honor, celebrate"
  },
  {
    "lemma": "počina",
    "cyr": "почина",
    "translation": "lay to rest (die)"
  },
  {
    "lemma": "počitam",
    "cyr": "почитам",
    "translation": "honor, celebrate"
  },
  {
    "lemma": "počna",
    "cyr": "почна",
    "translation": "begin"
  },
  {
    "lemma": "počto",
    "cyr": "почто",
    "translation": "why"
  },
  {
    "lemma": "počudja",
    "cyr": "почудя",
    "translation": "wonder"
  },
  {
    "lemma": "pod",
    "cyr": "под",
    "translation": "under"
  },
  {
    "lemma": "podam",
    "cyr": "подам",
    "translation": "render"
  },
  {
    "lemma": "podaruvam",
    "cyr": "подарувам",
    "translation": "give a gift"
  },
  {
    "lemma": "podekvam",
    "cyr": "подеквам",
    "translation": "quarrel"
  },
  {
    "lemma": "podkanja",
    "cyr": "подканя",
    "translation": "decide"
  },
  {
    "lemma": "podmestja",
    "cyr": "подместя",
    "translation": "sublate"
  },
  {
    "lemma": "podnosja",
    "cyr": "поднося",
    "translation": "wear new clothes daily"
  },
  {
    "lemma": "podobati",
    "cyr": "подобати",
    "translation": "have to, be appropriate"
  },
  {
    "lemma": "podoben",
    "cyr": "подобен",
    "translation": "appropriate"
  },
  {
    "lemma": "podosadja",
    "cyr": "подосадя",
    "translation": "become annoying"
  },
  {
    "lemma": "podpiša",
    "cyr": "подпиша",
    "translation": "subscribe, signature"
  },
  {
    "lemma": "podslonja",
    "cyr": "подслоня",
    "translation": "take cover"
  },
  {
    "lemma": "podsměja",
    "cyr": "подсмея",
    "translation": "laugh off"
  },
  {
    "lemma": "pofala",
    "cyr": "пофала",
    "translation": "praise"
  },
  {
    "lemma": "pofana",
    "cyr": "пофана",
    "translation": "hold"
  },
  {
    "lemma": "poganen",
    "cyr": "поганен",
    "translation": "heathen"
  },
  {
    "lemma": "pogazja",
    "cyr": "погазя",
    "translation": "stomp"
  },
  {
    "lemma": "pogibnǫti",
    "cyr": "погибнути",
    "translation": "perish"
  },
  {
    "lemma": "pogina",
    "cyr": "погина",
    "translation": "perish"
  },
  {
    "lemma": "pogled",
    "cyr": "поглед",
    "translation": "view, stare"
  },
  {
    "lemma": "pogledam",
    "cyr": "погледам",
    "translation": "watch"
  },
  {
    "lemma": "pogledna",
    "cyr": "погледна",
    "translation": "look"
  },
  {
    "lemma": "pogreba",
    "cyr": "погреба",
    "translation": "bury"
  },
  {
    "lemma": "pogubja",
    "cyr": "погубя",
    "translation": "destroy, lose"
  },
  {
    "lemma": "pogubvam",
    "cyr": "погубвам",
    "translation": "destroy, lose"
  },
  {
    "lemma": "poglъna",
    "cyr": "погълна",
    "translation": "devour"
  },
  {
    "lemma": "poida",
    "cyr": "пойда",
    "translation": "go, leave"
  },
  {
    "lemma": "poigraja",
    "cyr": "пойграя",
    "translation": "play a little"
  },
  {
    "lemma": "poja",
    "cyr": "поя",
    "translation": "give a drink"
  },
  {
    "lemma": "pojam",
    "cyr": "поям",
    "translation": "eat a little"
  },
  {
    "lemma": "pojas",
    "cyr": "пояс",
    "translation": "belt"
  },
  {
    "lemma": "pokaja",
    "cyr": "покая",
    "translation": "repent"
  },
  {
    "lemma": "pokajanie",
    "cyr": "покаяние",
    "translation": "repentance"
  },
  {
    "lemma": "pokaža",
    "cyr": "покажа",
    "translation": "show"
  },
  {
    "lemma": "poklanjam",
    "cyr": "покланям",
    "translation": "bow down"
  },
  {
    "lemma": "poklonenie",
    "cyr": "поклонение",
    "translation": "worship"
  },
  {
    "lemma": "poklonja",
    "cyr": "поклоня",
    "translation": "worship, bow"
  },
  {
    "lemma": "pokrija",
    "cyr": "покрия",
    "translation": "cover"
  },
  {
    "lemma": "pokrovitel",
    "cyr": "покровител",
    "translation": "protector"
  },
  {
    "lemma": "pokrъstja",
    "cyr": "покръстя",
    "translation": "baptize"
  },
  {
    "lemma": "pokъpja",
    "cyr": "покъпя",
    "translation": "bathe"
  },
  {
    "lemma": "pola",
    "cyr": "пола",
    "translation": "skirt"
  },
  {
    "lemma": "polata",
    "cyr": "полата",
    "translation": "palace"
  },
  {
    "lemma": "pole",
    "cyr": "поле",
    "translation": "field"
  },
  {
    "lemma": "poleža",
    "cyr": "полежа",
    "translation": "lay a little"
  },
  {
    "lemma": "politika",
    "cyr": "политика",
    "translation": "politics"
  },
  {
    "lemma": "poljana",
    "cyr": "поляна",
    "translation": "glade"
  },
  {
    "lemma": "položa",
    "cyr": "положа",
    "translation": "place"
  },
  {
    "lemma": "polski",
    "cyr": "полски",
    "translation": "of field"
  },
  {
    "lemma": "polunošt",
    "cyr": "полунощ",
    "translation": "midnight"
  },
  {
    "lemma": "poluča",
    "cyr": "получа",
    "translation": "receive"
  },
  {
    "lemma": "polza",
    "cyr": "полза",
    "translation": "use, good"
  },
  {
    "lemma": "pomen",
    "cyr": "помен",
    "translation": "rememberance"
  },
  {
    "lemma": "pomena",
    "cyr": "помена",
    "translation": "remember (by a specific rite)"
  },
  {
    "lemma": "pomilvam",
    "cyr": "помилвам",
    "translation": "have mercy"
  },
  {
    "lemma": "pomina",
    "cyr": "помина",
    "translation": "perish"
  },
  {
    "lemma": "pomislja",
    "cyr": "помисля",
    "translation": "think"
  },
  {
    "lemma": "pomisъl",
    "cyr": "помисъл",
    "translation": "thought"
  },
  {
    "lemma": "pomnja",
    "cyr": "помня",
    "translation": "remember"
  },
  {
    "lemma": "pomogna",
    "cyr": "помогна",
    "translation": "help"
  },
  {
    "lemma": "pomolja",
    "cyr": "помоля",
    "translation": "pray"
  },
  {
    "lemma": "pomor",
    "cyr": "помор",
    "translation": "plague"
  },
  {
    "lemma": "pomošt",
    "cyr": "помощ",
    "translation": "help"
  },
  {
    "lemma": "pomoštnica",
    "cyr": "помощница",
    "translation": "helper (fem.)"
  },
  {
    "lemma": "pomoštnik",
    "cyr": "помощник",
    "translation": "helper"
  },
  {
    "lemma": "pomrěti",
    "cyr": "помряти",
    "translation": "perish"
  },
  {
    "lemma": "pomrъkna",
    "cyr": "помръкна",
    "translation": "become dark"
  },
  {
    "lemma": "ponesa",
    "cyr": "понеса",
    "translation": "carry"
  },
  {
    "lemma": "poneže",
    "cyr": "понеже",
    "translation": "because"
  },
  {
    "lemma": "pootdъxna",
    "cyr": "поотдъхна",
    "translation": "have a little rest"
  },
  {
    "lemma": "pop",
    "cyr": "поп",
    "translation": "priest"
  },
  {
    "lemma": "popadam",
    "cyr": "попадам",
    "translation": "fall (a number of things)"
  },
  {
    "lemma": "popalja",
    "cyr": "попаля",
    "translation": "burn (a number of things)"
  },
  {
    "lemma": "popasa",
    "cyr": "попаса",
    "translation": "graze a little"
  },
  {
    "lemma": "popitam",
    "cyr": "попитам",
    "translation": "ask"
  },
  {
    "lemma": "poplača",
    "cyr": "поплача",
    "translation": "cry a little"
  },
  {
    "lemma": "popov",
    "cyr": "попов",
    "translation": "priest's"
  },
  {
    "lemma": "popraznuvam",
    "cyr": "попразнувам",
    "translation": "celebrate"
  },
  {
    "lemma": "porastja",
    "cyr": "порастя",
    "translation": "grow a little"
  },
  {
    "lemma": "porazja",
    "cyr": "поразя",
    "translation": "kill, defeat"
  },
  {
    "lemma": "porevnovati",
    "cyr": "поревновати",
    "translation": "zealously wish"
  },
  {
    "lemma": "poročen",
    "cyr": "порочен",
    "translation": "tainted"
  },
  {
    "lemma": "porodja",
    "cyr": "породя",
    "translation": "give birth"
  },
  {
    "lemma": "porъčam",
    "cyr": "поръчам",
    "translation": "give order"
  },
  {
    "lemma": "posakam",
    "cyr": "посакам",
    "translation": "ask for something"
  },
  {
    "lemma": "posedja",
    "cyr": "поседя",
    "translation": "sit a little"
  },
  {
    "lemma": "posegna",
    "cyr": "посегна",
    "translation": "reach, touch"
  },
  {
    "lemma": "pošeguvam",
    "cyr": "пошегувам",
    "translation": "have fun"
  },
  {
    "lemma": "poseja",
    "cyr": "посея",
    "translation": "sow"
  },
  {
    "lemma": "poseka",
    "cyr": "посека",
    "translation": "cut down"
  },
  {
    "lemma": "poslati",
    "cyr": "послати",
    "translation": "send"
  },
  {
    "lemma": "posle",
    "cyr": "после",
    "translation": "afterwards"
  },
  {
    "lemma": "posleden",
    "cyr": "последен",
    "translation": "last"
  },
  {
    "lemma": "posluguvam",
    "cyr": "послугувам",
    "translation": "serve"
  },
  {
    "lemma": "poslušam",
    "cyr": "послушам",
    "translation": "obey"
  },
  {
    "lemma": "poslušliv",
    "cyr": "послушлив",
    "translation": "obeying"
  },
  {
    "lemma": "pospa",
    "cyr": "поспа",
    "translation": "sleep a little"
  },
  {
    "lemma": "posramja",
    "cyr": "посрамя",
    "translation": "put a shame"
  },
  {
    "lemma": "posred",
    "cyr": "посред",
    "translation": "in the middle"
  },
  {
    "lemma": "posredstven",
    "cyr": "посредствен",
    "translation": "mediated"
  },
  {
    "lemma": "posreštna",
    "cyr": "посрещна",
    "translation": "meet"
  },
  {
    "lemma": "postavja",
    "cyr": "поставя",
    "translation": "place, build"
  },
  {
    "lemma": "postavjam",
    "cyr": "поставям",
    "translation": "place, build"
  },
  {
    "lemma": "postelja",
    "cyr": "постеля",
    "translation": "couch"
  },
  {
    "lemma": "postigna",
    "cyr": "постигна",
    "translation": "reach, attain"
  },
  {
    "lemma": "postnik",
    "cyr": "постник",
    "translation": "hermit"
  },
  {
    "lemma": "postradam",
    "cyr": "пострадам",
    "translation": "suffer"
  },
  {
    "lemma": "posvestja",
    "cyr": "посвестя",
    "translation": "come to senses"
  },
  {
    "lemma": "posvojuvam",
    "cyr": "посвоювам",
    "translation": "appropriate"
  },
  {
    "lemma": "posъrna",
    "cyr": "посърна",
    "translation": "become dull"
  },
  {
    "lemma": "pot",
    "cyr": "пот",
    "translation": "sweat"
  },
  {
    "lemma": "pǫt",
    "cyr": "път",
    "translation": "way"
  },
  {
    "lemma": "potaen",
    "cyr": "потаен",
    "translation": "secret"
  },
  {
    "lemma": "poteglja",
    "cyr": "потегля",
    "translation": "suffer"
  },
  {
    "lemma": "potegna",
    "cyr": "потегна",
    "translation": "stretch"
  },
  {
    "lemma": "poten",
    "cyr": "потен",
    "translation": "sweaty"
  },
  {
    "lemma": "potopja",
    "cyr": "потопя",
    "translation": "drown"
  },
  {
    "lemma": "potražja",
    "cyr": "потражя",
    "translation": "search a little"
  },
  {
    "lemma": "potrěba",
    "cyr": "потреба",
    "translation": "need"
  },
  {
    "lemma": "potrěben",
    "cyr": "потребен",
    "translation": "needed"
  },
  {
    "lemma": "potrěbja",
    "cyr": "потребя",
    "translation": "annihilate, consume"
  },
  {
    "lemma": "potreperja",
    "cyr": "потреперя",
    "translation": "tremble a little"
  },
  {
    "lemma": "potresa",
    "cyr": "потреса",
    "translation": "shake a little"
  },
  {
    "lemma": "potъmneja",
    "cyr": "потъмнея",
    "translation": "become dark"
  },
  {
    "lemma": "potъrsja",
    "cyr": "потърся",
    "translation": "search a little"
  },
  {
    "lemma": "potъštati",
    "cyr": "потъщати",
    "translation": "struggle"
  },
  {
    "lemma": "poveče",
    "cyr": "повече",
    "translation": "more"
  },
  {
    "lemma": "povečerjam",
    "cyr": "повечерям",
    "translation": "have a dinner"
  },
  {
    "lemma": "poveda",
    "cyr": "поведа",
    "translation": "lead"
  },
  {
    "lemma": "povelja",
    "cyr": "повеля",
    "translation": "give an order"
  },
  {
    "lemma": "povelenie",
    "cyr": "повеление",
    "translation": "order"
  },
  {
    "lemma": "pověrvam",
    "cyr": "повярвам",
    "translation": "become a believer"
  },
  {
    "lemma": "povikam",
    "cyr": "повикам",
    "translation": "call"
  },
  {
    "lemma": "povora",
    "cyr": "повора",
    "translation": "string"
  },
  {
    "lemma": "povredja",
    "cyr": "повредя",
    "translation": "harm"
  },
  {
    "lemma": "povъrna",
    "cyr": "повърна",
    "translation": "return"
  },
  {
    "lemma": "poxrakati",
    "cyr": "похракати",
    "translation": "clear throat"
  },
  {
    "lemma": "poxulja",
    "cyr": "похуля",
    "translation": "curse"
  },
  {
    "lemma": "požalja",
    "cyr": "пожаля",
    "translation": "feel sorry"
  },
  {
    "lemma": "pozastareja",
    "cyr": "позастарея",
    "translation": "become old"
  },
  {
    "lemma": "pozden",
    "cyr": "позден",
    "translation": "late"
  },
  {
    "lemma": "poznavam",
    "cyr": "познавам",
    "translation": "know"
  },
  {
    "lemma": "poživeja",
    "cyr": "поживея",
    "translation": "live for some time"
  },
  {
    "lemma": "poznaja",
    "cyr": "позная",
    "translation": "know, understand"
  },
  {
    "lemma": "pozova",
    "cyr": "позова",
    "translation": "call"
  },
  {
    "lemma": "praotec",
    "cyr": "праотец",
    "translation": "forefather"
  },
  {
    "lemma": "pratja",
    "cyr": "пратя",
    "translation": "send"
  },
  {
    "lemma": "pravda",
    "cyr": "правда",
    "translation": "truth, justice"
  },
  {
    "lemma": "praveden",
    "cyr": "праведен",
    "translation": "righteous"
  },
  {
    "lemma": "pravednik",
    "cyr": "праведник",
    "translation": "righteous"
  },
  {
    "lemma": "pravilo",
    "cyr": "правило",
    "translation": "prayer manual"
  },
  {
    "lemma": "pravitel",
    "cyr": "правител",
    "translation": "maker"
  },
  {
    "lemma": "pravja",
    "cyr": "правя",
    "translation": "make"
  },
  {
    "lemma": "pravo",
    "cyr": "право",
    "translation": "rightly"
  },
  {
    "lemma": "pravoslaven",
    "cyr": "православен",
    "translation": "orthodox"
  },
  {
    "lemma": "prax",
    "cyr": "прах",
    "translation": "dust"
  },
  {
    "lemma": "praznik",
    "cyr": "празник",
    "translation": "feast, holiday"
  },
  {
    "lemma": "praznuvam",
    "cyr": "празнувам",
    "translation": "have a feast"
  },
  {
    "lemma": "pre",
    "cyr": "пре",
    "translation": "for"
  },
  {
    "lemma": "prebivam",
    "cyr": "пребивам",
    "translation": "dwell"
  },
  {
    "lemma": "prebroja",
    "cyr": "преброя",
    "translation": "count through"
  },
  {
    "lemma": "prebъda",
    "cyr": "пребъда",
    "translation": "spend time"
  },
  {
    "lemma": "pričestja",
    "cyr": "причестя",
    "translation": "communicate, take part in Eucharist"
  },
  {
    "lemma": "prečist",
    "cyr": "пречист",
    "translation": "most pure"
  },
  {
    "lemma": "prečistja",
    "cyr": "пречистя",
    "translation": "purify"
  },
  {
    "lemma": "pred",
    "cyr": "пред",
    "translation": "in front"
  },
  {
    "lemma": "predam",
    "cyr": "предам",
    "translation": "give over, betray"
  },
  {
    "lemma": "predatel",
    "cyr": "предател",
    "translation": "betrayer"
  },
  {
    "lemma": "predavam",
    "cyr": "предавам",
    "translation": "give over, betray"
  },
  {
    "lemma": "predislovie",
    "cyr": "предисловие",
    "translation": "introduction"
  },
  {
    "lemma": "prediven",
    "cyr": "предивен",
    "translation": "most wondrous"
  },
  {
    "lemma": "predstatelstvovati",
    "cyr": "предстателствовати",
    "translation": "stand in front"
  },
  {
    "lemma": "predstoja",
    "cyr": "предстоя",
    "translation": "stand in front"
  },
  {
    "lemma": "predstojatel",
    "cyr": "предстоятел",
    "translation": "representative"
  },
  {
    "lemma": "Predteča",
    "cyr": "Предтеча",
    "translation": "Forerunner"
  },
  {
    "lemma": "predumam",
    "cyr": "предумам",
    "translation": "persuade"
  },
  {
    "lemma": "predumvam",
    "cyr": "предумвам",
    "translation": "persuade"
  },
  {
    "lemma": "preklonja",
    "cyr": "преклоня",
    "translation": "bend"
  },
  {
    "lemma": "prěko",
    "cyr": "пряко",
    "translation": "directly"
  },
  {
    "lemma": "prekrasen",
    "cyr": "прекрасен",
    "translation": "most beautiful"
  },
  {
    "lemma": "prekrija",
    "cyr": "прекрия",
    "translation": "cover"
  },
  {
    "lemma": "prekrъstja",
    "cyr": "прекръстя",
    "translation": "cross (gesture)"
  },
  {
    "lemma": "preljubodeinica",
    "cyr": "прелюбодейница",
    "translation": "adulterous woman"
  },
  {
    "lemma": "prelukav",
    "cyr": "прелукав",
    "translation": "most evil"
  },
  {
    "lemma": "prelъštam",
    "cyr": "прелъщам",
    "translation": "deceive, seduce"
  },
  {
    "lemma": "prelъštenie",
    "cyr": "прелъщение",
    "translation": "deception, seduction"
  },
  {
    "lemma": "prelъstja",
    "cyr": "прелъстя",
    "translation": "deceive, seduce"
  },
  {
    "lemma": "prelъstjavam",
    "cyr": "прелъстявам",
    "translation": "deceive, seduce"
  },
  {
    "lemma": "preměna",
    "cyr": "премяна",
    "translation": "clothes"
  },
  {
    "lemma": "preměnja",
    "cyr": "премяня",
    "translation": "change clothes"
  },
  {
    "lemma": "premilostiv",
    "cyr": "премилостив",
    "translation": "most merciful"
  },
  {
    "lemma": "premnog",
    "cyr": "премног",
    "translation": "most numerous"
  },
  {
    "lemma": "premъdrost",
    "cyr": "премъдрост",
    "translation": "superior wisdom"
  },
  {
    "lemma": "prenoštevam",
    "cyr": "пренощевам",
    "translation": "spend night"
  },
  {
    "lemma": "preobъrna",
    "cyr": "преобърна",
    "translation": "turn over"
  },
  {
    "lemma": "prepiša",
    "cyr": "препиша",
    "translation": "rewrite"
  },
  {
    "lemma": "prepisuvam",
    "cyr": "преписувам",
    "translation": "rewrite"
  },
  {
    "lemma": "prepodoben",
    "cyr": "преподобен",
    "translation": "Reverend"
  },
  {
    "lemma": "prěpojasanie",
    "cyr": "препоясание",
    "translation": "loincloth"
  },
  {
    "lemma": "presilja",
    "cyr": "пресиля",
    "translation": "force"
  },
  {
    "lemma": "preslaven",
    "cyr": "преславен",
    "translation": "most glorious"
  },
  {
    "lemma": "prestana",
    "cyr": "престана",
    "translation": "cease"
  },
  {
    "lemma": "prestanno",
    "cyr": "престанно",
    "translation": "ceasing"
  },
  {
    "lemma": "prestavja",
    "cyr": "преставя",
    "translation": "adjust, die"
  },
  {
    "lemma": "prestol",
    "cyr": "престол",
    "translation": "throne"
  },
  {
    "lemma": "prestъpja",
    "cyr": "престъпя",
    "translation": "step over"
  },
  {
    "lemma": "presuša",
    "cyr": "пресуша",
    "translation": "dry through"
  },
  {
    "lemma": "presvęt",
    "cyr": "пресвят",
    "translation": "most holy"
  },
  {
    "lemma": "presvětъl",
    "cyr": "пресвятъл",
    "translation": "most shiny"
  },
  {
    "lemma": "pretъrpja",
    "cyr": "претърпя",
    "translation": "suffer through"
  },
  {
    "lemma": "prevelik",
    "cyr": "превелик",
    "translation": "most great"
  },
  {
    "lemma": "prevzema",
    "cyr": "превзема",
    "translation": "overtake"
  },
  {
    "lemma": "prevъrža",
    "cyr": "превържа",
    "translation": "bind over"
  },
  {
    "lemma": "prexapja",
    "cyr": "прехапя",
    "translation": "bite through"
  },
  {
    "lemma": "prexvalno",
    "cyr": "прехвално",
    "translation": "praiseworthily"
  },
  {
    "lemma": "prez",
    "cyr": "през",
    "translation": "through"
  },
  {
    "lemma": "prěžden",
    "cyr": "прежден",
    "translation": "previous"
  },
  {
    "lemma": "prezviter",
    "cyr": "презвитер",
    "translation": "presbyter"
  },
  {
    "lemma": "pri",
    "cyr": "при",
    "translation": "by"
  },
  {
    "lemma": "priběgna",
    "cyr": "прибягна",
    "translation": "run to"
  },
  {
    "lemma": "približa",
    "cyr": "приближа",
    "translation": "come closer"
  },
  {
    "lemma": "približavam",
    "cyr": "приближавам",
    "translation": "come closer"
  },
  {
    "lemma": "pričeta",
    "cyr": "причета",
    "translation": "count among"
  },
  {
    "lemma": "priema",
    "cyr": "приема",
    "translation": "accept, receive"
  },
  {
    "lemma": "prifana",
    "cyr": "прифана",
    "translation": "hold closely"
  },
  {
    "lemma": "prigledam",
    "cyr": "пригледам",
    "translation": "watch"
  },
  {
    "lemma": "prigotvja",
    "cyr": "приготвя",
    "translation": "prepare"
  },
  {
    "lemma": "prigotvjam",
    "cyr": "приготвям",
    "translation": "prepare"
  },
  {
    "lemma": "prigreja",
    "cyr": "пригрея",
    "translation": "heat up"
  },
  {
    "lemma": "prigъrna",
    "cyr": "пригърна",
    "translation": "embrace"
  },
  {
    "lemma": "priida",
    "cyr": "приида",
    "translation": "come"
  },
  {
    "lemma": "prikaža",
    "cyr": "прикажа",
    "translation": "tell"
  },
  {
    "lemma": "prikloniti",
    "cyr": "приклонити",
    "translation": "cline"
  },
  {
    "lemma": "prilěgam",
    "cyr": "прилягам",
    "translation": "be possible"
  },
  {
    "lemma": "prilegna",
    "cyr": "прилегна",
    "translation": "be possible"
  },
  {
    "lemma": "prilepja",
    "cyr": "прилепя",
    "translation": "stick"
  },
  {
    "lemma": "priličam",
    "cyr": "приличам",
    "translation": "be appropriate"
  },
  {
    "lemma": "priličen",
    "cyr": "приличен",
    "translation": "appropriate"
  },
  {
    "lemma": "prilika",
    "cyr": "прилика",
    "translation": "looks"
  },
  {
    "lemma": "priloža",
    "cyr": "приложа",
    "translation": "lay"
  },
  {
    "lemma": "primъčna",
    "cyr": "примъчна",
    "translation": "become torturing"
  },
  {
    "lemma": "prinesa",
    "cyr": "принеса",
    "translation": "bring"
  },
  {
    "lemma": "prinosja",
    "cyr": "принося",
    "translation": "bring"
  },
  {
    "lemma": "pripadam",
    "cyr": "припадам",
    "translation": "fall to"
  },
  {
    "lemma": "pripadna",
    "cyr": "припадна",
    "translation": "fall to"
  },
  {
    "lemma": "pripeka",
    "cyr": "припека",
    "translation": "heat up"
  },
  {
    "lemma": "priplakam",
    "cyr": "приплакам",
    "translation": "cry"
  },
  {
    "lemma": "priplaša",
    "cyr": "приплаша",
    "translation": "scare off"
  },
  {
    "lemma": "pripsuvam",
    "cyr": "припсувам",
    "translation": "curse"
  },
  {
    "lemma": "priroden",
    "cyr": "природен",
    "translation": "additionally born"
  },
  {
    "lemma": "prišestvie",
    "cyr": "пришествие",
    "translation": "advent, coming"
  },
  {
    "lemma": "priskrъben",
    "cyr": "прискръбен",
    "translation": "sad"
  },
  {
    "lemma": "prisměja",
    "cyr": "присмея",
    "translation": "laugh at"
  },
  {
    "lemma": "prismexulka",
    "cyr": "присмехулка",
    "translation": "mocking woman"
  },
  {
    "lemma": "prisno",
    "cyr": "присно",
    "translation": "always"
  },
  {
    "lemma": "pristavin",
    "cyr": "приставин",
    "translation": "servant"
  },
  {
    "lemma": "pristupja",
    "cyr": "приступя",
    "translation": "step closer"
  },
  {
    "lemma": "prišъlec",
    "cyr": "пришълец",
    "translation": "newcomer"
  },
  {
    "lemma": "priveda",
    "cyr": "приведа",
    "translation": "lead in"
  },
  {
    "lemma": "priveza",
    "cyr": "привеза",
    "translation": "bind on"
  },
  {
    "lemma": "privikam",
    "cyr": "привикам",
    "translation": "yell, moan"
  },
  {
    "lemma": "privikuvam",
    "cyr": "привикувам",
    "translation": "yell, moan"
  },
  {
    "lemma": "privlačam",
    "cyr": "привлачам",
    "translation": "bring (by pulling)"
  },
  {
    "lemma": "privleka",
    "cyr": "привлека",
    "translation": "bring (by pulling)"
  },
  {
    "lemma": "prixodja",
    "cyr": "приходя",
    "translation": "come"
  },
  {
    "lemma": "prizova",
    "cyr": "призова",
    "translation": "call, invite"
  },
  {
    "lemma": "prizra",
    "cyr": "призра",
    "translation": "look with favor"
  },
  {
    "lemma": "proboda",
    "cyr": "пробода",
    "translation": "pierce"
  },
  {
    "lemma": "pročesti",
    "cyr": "прочести",
    "translation": "read"
  },
  {
    "lemma": "pročeta",
    "cyr": "прочета",
    "translation": "read"
  },
  {
    "lemma": "prodam",
    "cyr": "продам",
    "translation": "sell"
  },
  {
    "lemma": "prodavam",
    "cyr": "продавам",
    "translation": "sell"
  },
  {
    "lemma": "prodavane",
    "cyr": "продаване",
    "translation": "selling"
  },
  {
    "lemma": "produmam",
    "cyr": "продумам",
    "translation": "start to speak"
  },
  {
    "lemma": "produmam",
    "cyr": "продумам",
    "translation": "start to speak"
  },
  {
    "lemma": "prǫg",
    "cyr": "пруг",
    "translation": "locust"
  },
  {
    "lemma": "progledvam",
    "cyr": "прогледвам",
    "translation": "start to see"
  },
  {
    "lemma": "progněvati",
    "cyr": "прогнявати",
    "translation": "anger"
  },
  {
    "lemma": "proida",
    "cyr": "проида",
    "translation": "pass"
  },
  {
    "lemma": "proizveda",
    "cyr": "произведа",
    "translation": "produce"
  },
  {
    "lemma": "projavja",
    "cyr": "проявя",
    "translation": "show"
  },
  {
    "lemma": "proklętie",
    "cyr": "проклятие",
    "translation": "curse"
  },
  {
    "lemma": "prokъlna",
    "cyr": "прокълна",
    "translation": "curse"
  },
  {
    "lemma": "proleja",
    "cyr": "пролея",
    "translation": "spend, pour"
  },
  {
    "lemma": "prolivam",
    "cyr": "проливам",
    "translation": "spend, pour"
  },
  {
    "lemma": "prolog",
    "cyr": "пролог",
    "translation": "foreword"
  },
  {
    "lemma": "promina",
    "cyr": "промина",
    "translation": "pass"
  },
  {
    "lemma": "propast",
    "cyr": "пропаст",
    "translation": "abyss"
  },
  {
    "lemma": "propovědam",
    "cyr": "проповядам",
    "translation": "announce"
  },
  {
    "lemma": "propъdja",
    "cyr": "пропъдя",
    "translation": "expel"
  },
  {
    "lemma": "prorastja",
    "cyr": "прорастя",
    "translation": "abundantly grow"
  },
  {
    "lemma": "proreka",
    "cyr": "прорека",
    "translation": "tell a prophecy"
  },
  {
    "lemma": "proročestvo",
    "cyr": "пророчество",
    "translation": "prophecy"
  },
  {
    "lemma": "prorok",
    "cyr": "пророк",
    "translation": "prophet"
  },
  {
    "lemma": "prorokoubiica",
    "cyr": "пророкоубиица",
    "translation": "murderer of prophets"
  },
  {
    "lemma": "prosijaja",
    "cyr": "просияя",
    "translation": "shine"
  },
  {
    "lemma": "prosja",
    "cyr": "прося",
    "translation": "beg"
  },
  {
    "lemma": "proslavja",
    "cyr": "прославя",
    "translation": "make famous"
  },
  {
    "lemma": "prost",
    "cyr": "прост",
    "translation": "simple"
  },
  {
    "lemma": "proštenie",
    "cyr": "прощение",
    "translation": "forgiveness"
  },
  {
    "lemma": "prostja",
    "cyr": "простя",
    "translation": "forgive"
  },
  {
    "lemma": "prostota",
    "cyr": "простота",
    "translation": "simplicity"
  },
  {
    "lemma": "prostra",
    "cyr": "простра",
    "translation": "stretch"
  },
  {
    "lemma": "prosvětja",
    "cyr": "просветя",
    "translation": "enlighten"
  },
  {
    "lemma": "prosvetvam",
    "cyr": "просветвам",
    "translation": "enlighten"
  },
  {
    "lemma": "proteglja",
    "cyr": "протегля",
    "translation": "receive, suffer"
  },
  {
    "lemma": "protiven",
    "cyr": "противен",
    "translation": "hostile"
  },
  {
    "lemma": "protrъbja",
    "cyr": "протръбя",
    "translation": "blow a trumpet"
  },
  {
    "lemma": "provalja",
    "cyr": "проваля",
    "translation": "break"
  },
  {
    "lemma": "provaždam",
    "cyr": "проваждам",
    "translation": "spend"
  },
  {
    "lemma": "provodja",
    "cyr": "проводя",
    "translation": "spend"
  },
  {
    "lemma": "proxladja",
    "cyr": "прохладя",
    "translation": "cool"
  },
  {
    "lemma": "proxodja",
    "cyr": "проходя",
    "translation": "have a walk"
  },
  {
    "lemma": "pružа",
    "cyr": "пружа",
    "translation": "stretch"
  },
  {
    "lemma": "prъst",
    "cyr": "пръст",
    "translation": "finger"
  },
  {
    "lemma": "prъvě",
    "cyr": "пръвя",
    "translation": "first"
  },
  {
    "lemma": "pšenica",
    "cyr": "пшеница",
    "translation": "wheat"
  },
  {
    "lemma": "ptica",
    "cyr": "птица",
    "translation": "bird"
  },
  {
    "lemma": "pukam",
    "cyr": "пукам",
    "translation": "break up"
  },
  {
    "lemma": "pukna",
    "cyr": "пукна",
    "translation": "break up"
  },
  {
    "lemma": "Punčo",
    "cyr": "Пунчо",
    "translation": "Punčo"
  },
  {
    "lemma": "Puno",
    "cyr": "Пуно",
    "translation": "Puno"
  },
  {
    "lemma": "puskam",
    "cyr": "пускам",
    "translation": "let"
  },
  {
    "lemma": "pust",
    "cyr": "пуст",
    "translation": "deserted"
  },
  {
    "lemma": "pustinja",
    "cyr": "пустиня",
    "translation": "desert"
  },
  {
    "lemma": "pustja",
    "cyr": "пустя",
    "translation": "let"
  },
  {
    "lemma": "pъlen",
    "cyr": "пълен",
    "translation": "full"
  },
  {
    "lemma": "pъlzja",
    "cyr": "пълзя",
    "translation": "crawl"
  },
  {
    "lemma": "pъrvi",
    "cyr": "първи",
    "translation": "first"
  },
  {
    "lemma": "pъrvo",
    "cyr": "първо",
    "translation": "first"
  },
  {
    "lemma": "pъrvoroden",
    "cyr": "първороден",
    "translation": "first-born"
  },
  {
    "lemma": "pъt",
    "cyr": "път",
    "translation": "(marker of repetition)"
  },
  {
    "lemma": "rab",
    "cyr": "раб",
    "translation": "servant, slave"
  },
  {
    "lemma": "rabota",
    "cyr": "работа",
    "translation": "work, thing, matter"
  },
  {
    "lemma": "rabotja",
    "cyr": "работя",
    "translation": "work"
  },
  {
    "lemma": "rabotnik",
    "cyr": "работник",
    "translation": "worker"
  },
  {
    "lemma": "radi",
    "cyr": "ради",
    "translation": "for the sake of"
  },
  {
    "lemma": "radja",
    "cyr": "радя",
    "translation": "care"
  },
  {
    "lemma": "radost",
    "cyr": "радост",
    "translation": "joy"
  },
  {
    "lemma": "radosten",
    "cyr": "радостен",
    "translation": "joyful"
  },
  {
    "lemma": "radvam",
    "cyr": "радвам",
    "translation": "be happy"
  },
  {
    "lemma": "Rafael",
    "cyr": "Рафаел",
    "translation": "Raphael"
  },
  {
    "lemma": "rai",
    "cyr": "рай",
    "translation": "Paradise"
  },
  {
    "lemma": "raiski",
    "cyr": "райски",
    "translation": "of Paradise"
  },
  {
    "lemma": "rakija",
    "cyr": "ракия",
    "translation": "rakia"
  },
  {
    "lemma": "ralo",
    "cyr": "рало",
    "translation": "plough"
  },
  {
    "lemma": "ramo",
    "cyr": "рамо",
    "translation": "arm"
  },
  {
    "lemma": "rana",
    "cyr": "рана",
    "translation": "wound"
  },
  {
    "lemma": "ranen",
    "cyr": "ранен",
    "translation": "early"
  },
  {
    "lemma": "rano",
    "cyr": "рано",
    "translation": "early"
  },
  {
    "lemma": "raslan",
    "cyr": "раслан",
    "translation": "lion"
  },
  {
    "lemma": "rastja",
    "cyr": "растя",
    "translation": "grow"
  },
  {
    "lemma": "rastrъgnǫti",
    "cyr": "растръгнути",
    "translation": "tear"
  },
  {
    "lemma": "ratai",
    "cyr": "ратай",
    "translation": "field helper"
  },
  {
    "lemma": "Raxila",
    "cyr": "Рахила",
    "translation": "Rachel"
  },
  {
    "lemma": "Raxilin",
    "cyr": "Рахилин",
    "translation": "Rachel's"
  },
  {
    "lemma": "razbera",
    "cyr": "разбера",
    "translation": "understand"
  },
  {
    "lemma": "razboinik",
    "cyr": "разбойник",
    "translation": "robber"
  },
  {
    "lemma": "razbudja",
    "cyr": "разбудя",
    "translation": "wake up"
  },
  {
    "lemma": "raždam",
    "cyr": "раждам",
    "translation": "give birth"
  },
  {
    "lemma": "razdelja",
    "cyr": "разделя",
    "translation": "separate"
  },
  {
    "lemma": "razdera",
    "cyr": "раздера",
    "translation": "tear"
  },
  {
    "lemma": "razgrabja",
    "cyr": "разграбя",
    "translation": "plunder"
  },
  {
    "lemma": "različen",
    "cyr": "различен",
    "translation": "different"
  },
  {
    "lemma": "razpadam",
    "cyr": "разпадам",
    "translation": "fall apart"
  },
  {
    "lemma": "razpalja",
    "cyr": "разпаля",
    "translation": "ignite"
  },
  {
    "lemma": "razpętie",
    "cyr": "разпятие",
    "translation": "crucifixion"
  },
  {
    "lemma": "razpratja",
    "cyr": "разпратя",
    "translation": "distribute"
  },
  {
    "lemma": "razpъdja",
    "cyr": "разпъдя",
    "translation": "expel"
  },
  {
    "lemma": "razpъna",
    "cyr": "разпъна",
    "translation": "crucify"
  },
  {
    "lemma": "razreša",
    "cyr": "разреша",
    "translation": "decide"
  },
  {
    "lemma": "razsipja",
    "cyr": "разсипя",
    "translation": "spill"
  },
  {
    "lemma": "razstupja",
    "cyr": "разступя",
    "translation": "step aside"
  },
  {
    "lemma": "razsъrdja",
    "cyr": "разсърдя",
    "translation": "make angry"
  },
  {
    "lemma": "raztreperja",
    "cyr": "разтреперя",
    "translation": "start shaking"
  },
  {
    "lemma": "raztъrsja",
    "cyr": "разтърся",
    "translation": "shake, clench"
  },
  {
    "lemma": "raztъžja",
    "cyr": "разтъжя",
    "translation": "become sad"
  },
  {
    "lemma": "razum",
    "cyr": "разум",
    "translation": "mind"
  },
  {
    "lemma": "razumeja",
    "cyr": "разумея",
    "translation": "understand"
  },
  {
    "lemma": "razumen",
    "cyr": "разумен",
    "translation": "wise"
  },
  {
    "lemma": "razuměvam",
    "cyr": "разумявам",
    "translation": "make wise"
  },
  {
    "lemma": "razumno",
    "cyr": "разумно",
    "translation": "wisely"
  },
  {
    "lemma": "razvalja",
    "cyr": "разваля",
    "translation": "destroy"
  },
  {
    "lemma": "razvaljam",
    "cyr": "развалям",
    "translation": "destroy"
  },
  {
    "lemma": "razvъrža",
    "cyr": "развържа",
    "translation": "untie"
  },
  {
    "lemma": "razžegna",
    "cyr": "разжегна",
    "translation": "ignite"
  },
  {
    "lemma": "rebro",
    "cyr": "ребро",
    "translation": "rib"
  },
  {
    "lemma": "reč",
    "cyr": "реч",
    "translation": "word"
  },
  {
    "lemma": "red",
    "cyr": "ред",
    "translation": "order, line"
  },
  {
    "lemma": "rednik",
    "cyr": "редник",
    "translation": "regularily"
  },
  {
    "lemma": "reka",
    "cyr": "река",
    "translation": "say"
  },
  {
    "lemma": "rěka",
    "cyr": "река",
    "translation": "river"
  },
  {
    "lemma": "rešeto",
    "cyr": "решето",
    "translation": "sieve"
  },
  {
    "lemma": "revnost",
    "cyr": "ревност",
    "translation": "fervor"
  },
  {
    "lemma": "revnuvam",
    "cyr": "ревнувам",
    "translation": "crave"
  },
  {
    "lemma": "riba",
    "cyr": "риба",
    "translation": "fish"
  },
  {
    "lemma": "ridaja",
    "cyr": "ридая",
    "translation": "cry"
  },
  {
    "lemma": "Rim",
    "cyr": "Рим",
    "translation": "Rome"
  },
  {
    "lemma": "rimljanin",
    "cyr": "римлянин",
    "translation": "Roman"
  },
  {
    "lemma": "rimski",
    "cyr": "римски",
    "translation": "Roman"
  },
  {
    "lemma": "ritam",
    "cyr": "ритам",
    "translation": "kick"
  },
  {
    "lemma": "ritna",
    "cyr": "ритна",
    "translation": "kick"
  },
  {
    "lemma": "riza",
    "cyr": "риза",
    "translation": "shirt"
  },
  {
    "lemma": "rob",
    "cyr": "роб",
    "translation": "servant, slave"
  },
  {
    "lemma": "robinja",
    "cyr": "робиня",
    "translation": "female servant, slave"
  },
  {
    "lemma": "robstvo",
    "cyr": "робство",
    "translation": "servitude"
  },
  {
    "lemma": "rod",
    "cyr": "род",
    "translation": "kin"
  },
  {
    "lemma": "rodja",
    "cyr": "родя",
    "translation": "give birth"
  },
  {
    "lemma": "rog",
    "cyr": "рог",
    "translation": "horn"
  },
  {
    "lemma": "rogač",
    "cyr": "рогач",
    "translation": "deer"
  },
  {
    "lemma": "rožba",
    "cyr": "рожба",
    "translation": "crops"
  },
  {
    "lemma": "roždestvo",
    "cyr": "рождество",
    "translation": "birth"
  },
  {
    "lemma": "rukidělie",
    "cyr": "рукидялие",
    "translation": "handwork"
  },
  {
    "lemma": "rъka",
    "cyr": "ръка",
    "translation": "hand"
  },
  {
    "lemma": "rъžda",
    "cyr": "ръжда",
    "translation": "rust"
  },
  {
    "lemma": "s",
    "cyr": "с",
    "translation": "with"
  },
  {
    "lemma": "sabja",
    "cyr": "сабя",
    "translation": "sabre, sword"
  },
  {
    "lemma": "sakam",
    "cyr": "сакам",
    "translation": "want, search"
  },
  {
    "lemma": "sakulja",
    "cyr": "сакуля",
    "translation": "bag"
  },
  {
    "lemma": "sam",
    "cyr": "сам",
    "translation": "alone"
  },
  {
    "lemma": "sapikasuvam",
    "cyr": "сапикасувам",
    "translation": "observe"
  },
  {
    "lemma": "Sara",
    "cyr": "Сара",
    "translation": "Sarah"
  },
  {
    "lemma": "Sarin",
    "cyr": "Сарин",
    "translation": "Sarah's"
  },
  {
    "lemma": "saštisam",
    "cyr": "сащисам",
    "translation": "be astonished"
  },
  {
    "lemma": "sasve",
    "cyr": "сасве",
    "translation": "entirely"
  },
  {
    "lemma": "Satanail",
    "cyr": "Сатанайл",
    "translation": "Satanael"
  },
  {
    "lemma": "Savaot",
    "cyr": "Саваот",
    "translation": "Sabaoth"
  },
  {
    "lemma": "saxat",
    "cyr": "сахат",
    "translation": "hour"
  },
  {
    "lemma": "se",
    "cyr": "се",
    "translation": "self"
  },
  {
    "lemma": "seč",
    "cyr": "сеч",
    "translation": "massacre"
  },
  {
    "lemma": "sedem",
    "cyr": "седем",
    "translation": "seven"
  },
  {
    "lemma": "sedja",
    "cyr": "седя",
    "translation": "sit"
  },
  {
    "lemma": "sedmi",
    "cyr": "седми",
    "translation": "seventh"
  },
  {
    "lemma": "sedna",
    "cyr": "седна",
    "translation": "sit"
  },
  {
    "lemma": "sega",
    "cyr": "сега",
    "translation": "now"
  },
  {
    "lemma": "segam",
    "cyr": "сегам",
    "translation": "reach"
  },
  {
    "lemma": "seja",
    "cyr": "сея",
    "translation": "sow"
  },
  {
    "lemma": "seka",
    "cyr": "сека",
    "translation": "cut"
  },
  {
    "lemma": "sele",
    "cyr": "селе",
    "translation": "nowadays"
  },
  {
    "lemma": "selen",
    "cyr": "селен",
    "translation": "of a field"
  },
  {
    "lemma": "selo",
    "cyr": "село",
    "translation": "village"
  },
  {
    "lemma": "seme",
    "cyr": "семе",
    "translation": "seed"
  },
  {
    "lemma": "sěnka",
    "cyr": "сянка",
    "translation": "shadow"
  },
  {
    "lemma": "senova",
    "cyr": "сенова",
    "translation": "afterwards"
  },
  {
    "lemma": "šest",
    "cyr": "шест",
    "translation": "six"
  },
  {
    "lemma": "seštam",
    "cyr": "сещам",
    "translation": "understand"
  },
  {
    "lemma": "šestokrilat",
    "cyr": "шестокрилат",
    "translation": "six-winged"
  },
  {
    "lemma": "sestra",
    "cyr": "сестра",
    "translation": "sister"
  },
  {
    "lemma": "setja",
    "cyr": "сетя",
    "translation": "understand"
  },
  {
    "lemma": "Sevastija",
    "cyr": "Севастия",
    "translation": "Sebastia"
  },
  {
    "lemma": "sgъrča",
    "cyr": "сгърча",
    "translation": "fold"
  },
  {
    "lemma": "sicev",
    "cyr": "сицев",
    "translation": "such"
  },
  {
    "lemma": "sii",
    "cyr": "сии",
    "translation": "this"
  },
  {
    "lemma": "šija",
    "cyr": "шия",
    "translation": "neck"
  },
  {
    "lemma": "sijanie",
    "cyr": "сияние",
    "translation": "shine"
  },
  {
    "lemma": "sik",
    "cyr": "сик",
    "translation": "-"
  },
  {
    "lemma": "sila",
    "cyr": "сила",
    "translation": "power"
  },
  {
    "lemma": "silen",
    "cyr": "силен",
    "translation": "strong"
  },
  {
    "lemma": "silno",
    "cyr": "силно",
    "translation": "strongly"
  },
  {
    "lemma": "Sim",
    "cyr": "Сим",
    "translation": "Shem"
  },
  {
    "lemma": "Simeon",
    "cyr": "Симеон",
    "translation": "Simeon"
  },
  {
    "lemma": "sin",
    "cyr": "син",
    "translation": "son"
  },
  {
    "lemma": "sindžir",
    "cyr": "синджир",
    "translation": "chains"
  },
  {
    "lemma": "Sionov",
    "cyr": "Сионов",
    "translation": "of Zion"
  },
  {
    "lemma": "sireč",
    "cyr": "сиреч",
    "translation": "that is"
  },
  {
    "lemma": "širina",
    "cyr": "ширина",
    "translation": "latitude"
  },
  {
    "lemma": "širok",
    "cyr": "широк",
    "translation": "broad"
  },
  {
    "lemma": "siromašija",
    "cyr": "сиромашия",
    "translation": "poverty"
  },
  {
    "lemma": "siromax",
    "cyr": "сиромах",
    "translation": "poor one"
  },
  {
    "lemma": "sirota",
    "cyr": "сирота",
    "translation": "poor one"
  },
  {
    "lemma": "sirotica",
    "cyr": "сиротица",
    "translation": "poor woman"
  },
  {
    "lemma": "Sit",
    "cyr": "Сит",
    "translation": "Seth"
  },
  {
    "lemma": "sitost",
    "cyr": "ситост",
    "translation": "satisfaction"
  },
  {
    "lemma": "Sitov",
    "cyr": "Ситов",
    "translation": "Seth's"
  },
  {
    "lemma": "skaža",
    "cyr": "скажа",
    "translation": "tell"
  },
  {
    "lemma": "skazanie",
    "cyr": "сказание",
    "translation": "story"
  },
  {
    "lemma": "skazvam",
    "cyr": "сказвам",
    "translation": "tell"
  },
  {
    "lemma": "skele",
    "cyr": "скеле",
    "translation": "scaffolding"
  },
  {
    "lemma": "skiptъr",
    "cyr": "скиптър",
    "translation": "scepter"
  },
  {
    "lemma": "skoča",
    "cyr": "скоча",
    "translation": "jump"
  },
  {
    "lemma": "skoro",
    "cyr": "скоро",
    "translation": "quickly, shortly afterwards"
  },
  {
    "lemma": "skot",
    "cyr": "скот",
    "translation": "cattle"
  },
  {
    "lemma": "skrija",
    "cyr": "скрия",
    "translation": "hide"
  },
  {
    "lemma": "skrъb",
    "cyr": "скръб",
    "translation": "sorrow"
  },
  {
    "lemma": "skrъben",
    "cyr": "скръбен",
    "translation": "sad"
  },
  {
    "lemma": "skutam",
    "cyr": "скутам",
    "translation": "hide"
  },
  {
    "lemma": "skъrbja",
    "cyr": "скърбя",
    "translation": "be sad"
  },
  {
    "lemma": "sladko",
    "cyr": "сладко",
    "translation": "sweetly"
  },
  {
    "lemma": "sladosten",
    "cyr": "сладостен",
    "translation": "sweet"
  },
  {
    "lemma": "slastoljubica",
    "cyr": "сластолюбица",
    "translation": "voluptuous woman"
  },
  {
    "lemma": "slastoljubiv",
    "cyr": "сластолюбив",
    "translation": "voluptuous"
  },
  {
    "lemma": "slava",
    "cyr": "слава",
    "translation": "glory"
  },
  {
    "lemma": "slaven",
    "cyr": "славен",
    "translation": "glorious"
  },
  {
    "lemma": "slavja",
    "cyr": "славя",
    "translation": "celebrate"
  },
  {
    "lemma": "sled",
    "cyr": "след",
    "translation": "afterwards"
  },
  {
    "lemma": "slěp",
    "cyr": "сляп",
    "translation": "blind"
  },
  {
    "lemma": "slěza",
    "cyr": "сляза",
    "translation": "descend"
  },
  {
    "lemma": "slezna",
    "cyr": "слезна",
    "translation": "descend"
  },
  {
    "lemma": "šljanec",
    "cyr": "шлянец",
    "translation": "a bit"
  },
  {
    "lemma": "slomja",
    "cyr": "сломя",
    "translation": "break"
  },
  {
    "lemma": "slovo",
    "cyr": "слово",
    "translation": "word"
  },
  {
    "lemma": "složa",
    "cyr": "сложа",
    "translation": "put"
  },
  {
    "lemma": "sluga",
    "cyr": "слуга",
    "translation": "servant"
  },
  {
    "lemma": "sluguvam",
    "cyr": "слугувам",
    "translation": "serve"
  },
  {
    "lemma": "sluguvane",
    "cyr": "слугуване",
    "translation": "service"
  },
  {
    "lemma": "slušam",
    "cyr": "слушам",
    "translation": "listen"
  },
  {
    "lemma": "slušatel",
    "cyr": "слушател",
    "translation": "hearer"
  },
  {
    "lemma": "slux",
    "cyr": "слух",
    "translation": "hearing (capacity)"
  },
  {
    "lemma": "služa",
    "cyr": "служа",
    "translation": "perform a service"
  },
  {
    "lemma": "služba",
    "cyr": "служба",
    "translation": "service, liturgy"
  },
  {
    "lemma": "služitel",
    "cyr": "служител",
    "translation": "servant"
  },
  {
    "lemma": "slъnce",
    "cyr": "слънце",
    "translation": "sun"
  },
  {
    "lemma": "slъža",
    "cyr": "слъжа",
    "translation": "fool, deceive"
  },
  {
    "lemma": "slъnečen",
    "cyr": "слънечен",
    "translation": "of the sun"
  },
  {
    "lemma": "smeja",
    "cyr": "смея",
    "translation": "dare"
  },
  {
    "lemma": "směja",
    "cyr": "смея",
    "translation": "laugh"
  },
  {
    "lemma": "směx",
    "cyr": "смях",
    "translation": "laugh"
  },
  {
    "lemma": "smiren",
    "cyr": "смирен",
    "translation": "peaceful"
  },
  {
    "lemma": "smireno",
    "cyr": "смирено",
    "translation": "peacefully"
  },
  {
    "lemma": "smirja",
    "cyr": "смиря",
    "translation": "attain peace"
  },
  {
    "lemma": "smislen",
    "cyr": "смислен",
    "translation": "prudent"
  },
  {
    "lemma": "smokinja",
    "cyr": "смокиня",
    "translation": "fig"
  },
  {
    "lemma": "smokovnica",
    "cyr": "смоковница",
    "translation": "fig tree"
  },
  {
    "lemma": "smola",
    "cyr": "смола",
    "translation": "tar"
  },
  {
    "lemma": "smrad",
    "cyr": "смрад",
    "translation": "stench"
  },
  {
    "lemma": "smraden",
    "cyr": "смраден",
    "translation": "stinking"
  },
  {
    "lemma": "smъrt",
    "cyr": "смърт",
    "translation": "death"
  },
  {
    "lemma": "smъrten",
    "cyr": "смъртен",
    "translation": "mortal"
  },
  {
    "lemma": "smъrtonosen",
    "cyr": "смъртоносен",
    "translation": "deadly"
  },
  {
    "lemma": "snaga",
    "cyr": "снага",
    "translation": "body"
  },
  {
    "lemma": "snesa",
    "cyr": "снеса",
    "translation": "carry forth"
  },
  {
    "lemma": "sǫd",
    "cyr": "съд",
    "translation": "judgement"
  },
  {
    "lemma": "solilo",
    "cyr": "солило",
    "translation": "brine"
  },
  {
    "lemma": "sosam",
    "cyr": "сосам",
    "translation": "suffice"
  },
  {
    "lemma": "spasenie",
    "cyr": "спасение",
    "translation": "salvation"
  },
  {
    "lemma": "spasitel",
    "cyr": "спасител",
    "translation": "Savior"
  },
  {
    "lemma": "spasja",
    "cyr": "спася",
    "translation": "save"
  },
  {
    "lemma": "spečelja",
    "cyr": "спечеля",
    "translation": "gain"
  },
  {
    "lemma": "spja",
    "cyr": "спя",
    "translation": "sleep"
  },
  {
    "lemma": "spleta",
    "cyr": "сплета",
    "translation": "bind, interweave"
  },
  {
    "lemma": "spodobja",
    "cyr": "сподобя",
    "translation": "become worthy"
  },
  {
    "lemma": "sproti",
    "cyr": "спроти",
    "translation": "against"
  },
  {
    "lemma": "spъvam",
    "cyr": "спъвам",
    "translation": "stumble"
  },
  {
    "lemma": "sram",
    "cyr": "срам",
    "translation": "shame"
  },
  {
    "lemma": "sramen",
    "cyr": "срамен",
    "translation": "shameful"
  },
  {
    "lemma": "sramja",
    "cyr": "срамя",
    "translation": "feel shame"
  },
  {
    "lemma": "sramuvam",
    "cyr": "срамувам",
    "translation": "feel shame"
  },
  {
    "lemma": "srebren",
    "cyr": "сребрен",
    "translation": "silver"
  },
  {
    "lemma": "srebrenik",
    "cyr": "сребреник",
    "translation": "silver coin"
  },
  {
    "lemma": "srebro",
    "cyr": "сребро",
    "translation": "silver"
  },
  {
    "lemma": "srebroljubec",
    "cyr": "сребролюбец",
    "translation": "silver-lover"
  },
  {
    "lemma": "sred",
    "cyr": "сред",
    "translation": "middle"
  },
  {
    "lemma": "srešta",
    "cyr": "среща",
    "translation": "meeting"
  },
  {
    "lemma": "sreštna",
    "cyr": "срещна",
    "translation": "meet"
  },
  {
    "lemma": "srъdba",
    "cyr": "сръдба",
    "translation": "anger"
  },
  {
    "lemma": "šta",
    "cyr": "ща",
    "translation": "want"
  },
  {
    "lemma": "stado",
    "cyr": "стадо",
    "translation": "herd"
  },
  {
    "lemma": "stana",
    "cyr": "стана",
    "translation": "become, stand up"
  },
  {
    "lemma": "star",
    "cyr": "стар",
    "translation": "old"
  },
  {
    "lemma": "starec",
    "cyr": "старец",
    "translation": "old man"
  },
  {
    "lemma": "stareišina",
    "cyr": "старейшина",
    "translation": "elder"
  },
  {
    "lemma": "starica",
    "cyr": "старица",
    "translation": "old woman"
  },
  {
    "lemma": "starost",
    "cyr": "старост",
    "translation": "old age"
  },
  {
    "lemma": "stava",
    "cyr": "става",
    "translation": "bone joint"
  },
  {
    "lemma": "štedъr",
    "cyr": "щедър",
    "translation": "generous"
  },
  {
    "lemma": "stena",
    "cyr": "стена",
    "translation": "moan"
  },
  {
    "lemma": "stepen",
    "cyr": "степен",
    "translation": "step, trace, grade"
  },
  {
    "lemma": "stigam",
    "cyr": "стигам",
    "translation": "reach"
  },
  {
    "lemma": "stigna",
    "cyr": "стигна",
    "translation": "reach"
  },
  {
    "lemma": "stixija",
    "cyr": "стихия",
    "translation": "element"
  },
  {
    "lemma": "sto",
    "cyr": "сто",
    "translation": "hundred"
  },
  {
    "lemma": "što",
    "cyr": "що",
    "translation": "what"
  },
  {
    "lemma": "stoja",
    "cyr": "стоя",
    "translation": "stand"
  },
  {
    "lemma": "stoka",
    "cyr": "стока",
    "translation": "goods"
  },
  {
    "lemma": "stol",
    "cyr": "стол",
    "translation": "chair"
  },
  {
    "lemma": "stopanica",
    "cyr": "стопаница",
    "translation": "wife"
  },
  {
    "lemma": "stopanin",
    "cyr": "стопанин",
    "translation": "husband"
  },
  {
    "lemma": "storja",
    "cyr": "сторя",
    "translation": "cause"
  },
  {
    "lemma": "stotina",
    "cyr": "стотина",
    "translation": "a group of hundred"
  },
  {
    "lemma": "stotnik",
    "cyr": "стотник",
    "translation": "centurion, captain"
  },
  {
    "lemma": "štoto",
    "cyr": "щото",
    "translation": "which"
  },
  {
    "lemma": "strana",
    "cyr": "страна",
    "translation": "side, land"
  },
  {
    "lemma": "strašen",
    "cyr": "страшен",
    "translation": "terrible"
  },
  {
    "lemma": "strašno",
    "cyr": "страшно",
    "translation": "terribly"
  },
  {
    "lemma": "strax",
    "cyr": "страх",
    "translation": "fear"
  },
  {
    "lemma": "straž",
    "cyr": "страж",
    "translation": "guard"
  },
  {
    "lemma": "strela",
    "cyr": "стрела",
    "translation": "arrow"
  },
  {
    "lemma": "streljam",
    "cyr": "стрелям",
    "translation": "shoot"
  },
  {
    "lemma": "streljane",
    "cyr": "стреляне",
    "translation": "shooting"
  },
  {
    "lemma": "strelna",
    "cyr": "стрелна",
    "translation": "shoot"
  },
  {
    "lemma": "stroitel",
    "cyr": "стройтел",
    "translation": "manager, builder"
  },
  {
    "lemma": "stroša",
    "cyr": "строша",
    "translation": "break into pieces"
  },
  {
    "lemma": "studen",
    "cyr": "студен",
    "translation": "cold"
  },
  {
    "lemma": "stъlp",
    "cyr": "стълп",
    "translation": "pillar"
  },
  {
    "lemma": "stъpalo",
    "cyr": "стъпало",
    "translation": "foot"
  },
  {
    "lemma": "šuma",
    "cyr": "шума",
    "translation": "leaves"
  },
  {
    "lemma": "sux",
    "cyr": "сух",
    "translation": "dry"
  },
  {
    "lemma": "svaki",
    "cyr": "сваки",
    "translation": "every"
  },
  {
    "lemma": "svalja",
    "cyr": "сваля",
    "translation": "put down"
  },
  {
    "lemma": "svarja",
    "cyr": "сваря",
    "translation": "cook"
  },
  {
    "lemma": "sve",
    "cyr": "све",
    "translation": "all"
  },
  {
    "lemma": "svekakvo",
    "cyr": "свекакво",
    "translation": "anything"
  },
  {
    "lemma": "svekakъv",
    "cyr": "свекакъв",
    "translation": "any"
  },
  {
    "lemma": "sveki",
    "cyr": "свеки",
    "translation": "every"
  },
  {
    "lemma": "svęštenik",
    "cyr": "свещеник",
    "translation": "priest"
  },
  {
    "lemma": "svět",
    "cyr": "свят",
    "translation": "world, light"
  },
  {
    "lemma": "svęt",
    "cyr": "свят",
    "translation": "saint"
  },
  {
    "lemma": "světilnik",
    "cyr": "светилник",
    "translation": "candlestick, lamp"
  },
  {
    "lemma": "svętitel",
    "cyr": "святител",
    "translation": "apostle, saint"
  },
  {
    "lemma": "světja",
    "cyr": "светя",
    "translation": "shine"
  },
  {
    "lemma": "svętja",
    "cyr": "светя",
    "translation": "sanctify"
  },
  {
    "lemma": "světliv",
    "cyr": "светлив",
    "translation": "shiny"
  },
  {
    "lemma": "svetuvam",
    "cyr": "светувам",
    "translation": "live"
  },
  {
    "lemma": "světъl",
    "cyr": "светъл",
    "translation": "bright"
  },
  {
    "lemma": "sъvęzati",
    "cyr": "съвязати",
    "translation": "bind"
  },
  {
    "lemma": "svički",
    "cyr": "свички",
    "translation": "every"
  },
  {
    "lemma": "svidetelstvo",
    "cyr": "свидетелство",
    "translation": "testimony"
  },
  {
    "lemma": "svilen",
    "cyr": "свилен",
    "translation": "nice"
  },
  {
    "lemma": "svinca",
    "cyr": "свинца",
    "translation": "together"
  },
  {
    "lemma": "svoi",
    "cyr": "свой",
    "translation": "of oneself"
  },
  {
    "lemma": "svude",
    "cyr": "свуде",
    "translation": "everywhere"
  },
  {
    "lemma": "svъrža",
    "cyr": "свържа",
    "translation": "bind"
  },
  {
    "lemma": "sxodja",
    "cyr": "сходя",
    "translation": "fall down (into bed)"
  },
  {
    "lemma": "sъbera",
    "cyr": "събера",
    "translation": "collect"
  },
  {
    "lemma": "sъbiram",
    "cyr": "събирам",
    "translation": "collect"
  },
  {
    "lemma": "sъblaznik",
    "cyr": "съблазник",
    "translation": "seducer"
  },
  {
    "lemma": "sъblaznь",
    "cyr": "съблазнь",
    "translation": "deceit"
  },
  {
    "lemma": "sъbleka",
    "cyr": "съблека",
    "translation": "put off clothes"
  },
  {
    "lemma": "sъbljusti",
    "cyr": "съблюсти",
    "translation": "preserve"
  },
  {
    "lemma": "sъbor",
    "cyr": "събор",
    "translation": "feast, assembly"
  },
  {
    "lemma": "sъborja",
    "cyr": "съборя",
    "translation": "tear down"
  },
  {
    "lemma": "sъbosti",
    "cyr": "събости",
    "translation": "injure"
  },
  {
    "lemma": "sъbudja",
    "cyr": "събудя",
    "translation": "wake up"
  },
  {
    "lemma": "sъbyti",
    "cyr": "събыти",
    "translation": "fulfill (prophecy)"
  },
  {
    "lemma": "sъdeja",
    "cyr": "съдея",
    "translation": "perform a service"
  },
  {
    "lemma": "sъdja",
    "cyr": "съдя",
    "translation": "judge"
  },
  {
    "lemma": "sъdnica",
    "cyr": "съдница",
    "translation": "judgement seat"
  },
  {
    "lemma": "sъgodenica",
    "cyr": "съгоденица",
    "translation": "fiancee"
  },
  {
    "lemma": "sgovarjam",
    "cyr": "сговарям",
    "translation": "discuss, make a plan"
  },
  {
    "lemma": "sъgovor",
    "cyr": "съговор",
    "translation": "agreement"
  },
  {
    "lemma": "sgovorja",
    "cyr": "сговоря",
    "translation": "discuss, make a plan"
  },
  {
    "lemma": "sъgreša",
    "cyr": "съгреша",
    "translation": "sin"
  },
  {
    "lemma": "sъgrešenie",
    "cyr": "съгрешение",
    "translation": "sin"
  },
  {
    "lemma": "sъkonča",
    "cyr": "съконча",
    "translation": "end"
  },
  {
    "lemma": "sъkončanie",
    "cyr": "съкончание",
    "translation": "end"
  },
  {
    "lemma": "sъkrovište",
    "cyr": "съкровище",
    "translation": "treasure"
  },
  {
    "lemma": "sъkruša",
    "cyr": "съкруша",
    "translation": "break"
  },
  {
    "lemma": "sъlza",
    "cyr": "сълза",
    "translation": "tear"
  },
  {
    "lemma": "sъm",
    "cyr": "съм",
    "translation": "be"
  },
  {
    "lemma": "sъmna",
    "cyr": "съмна",
    "translation": "break dawn"
  },
  {
    "lemma": "sъmotritel",
    "cyr": "съмотрител",
    "translation": "overseer"
  },
  {
    "lemma": "sъn",
    "cyr": "сън",
    "translation": "slumber, dream"
  },
  {
    "lemma": "sъniti",
    "cyr": "сънити",
    "translation": "descend"
  },
  {
    "lemma": "sъnuvam",
    "cyr": "сънувам",
    "translation": "have a dream"
  },
  {
    "lemma": "sъpęti",
    "cyr": "съпяти",
    "translation": "bind"
  },
  {
    "lemma": "sъprotivnik",
    "cyr": "съпротивник",
    "translation": "adversary"
  },
  {
    "lemma": "sъpružestvo",
    "cyr": "съпружество",
    "translation": "marriage"
  },
  {
    "lemma": "supružnica",
    "cyr": "супружница",
    "translation": "wife"
  },
  {
    "lemma": "sъrazuměti",
    "cyr": "съразумяти",
    "translation": "recognize"
  },
  {
    "lemma": "sъrbin",
    "cyr": "сърбин",
    "translation": "Serb"
  },
  {
    "lemma": "sъrdce",
    "cyr": "сърдце",
    "translation": "heart"
  },
  {
    "lemma": "sъrdja",
    "cyr": "сърдя",
    "translation": "anger"
  },
  {
    "lemma": "sъseka",
    "cyr": "съсека",
    "translation": "cut in pieces"
  },
  {
    "lemma": "sъšija",
    "cyr": "съшия",
    "translation": "sew together"
  },
  {
    "lemma": "sъsipa",
    "cyr": "съсипа",
    "translation": "destroy by falling"
  },
  {
    "lemma": "sъtvorenie",
    "cyr": "сътворение",
    "translation": "creation"
  },
  {
    "lemma": "sъtvorja",
    "cyr": "сътворя",
    "translation": "create, do"
  },
  {
    "lemma": "sъveza",
    "cyr": "съвеза",
    "translation": "bind"
  },
  {
    "lemma": "sъvkupja",
    "cyr": "съвкупя",
    "translation": "collect"
  },
  {
    "lemma": "sъvъrša",
    "cyr": "съвърша",
    "translation": "finish"
  },
  {
    "lemma": "sъxranja",
    "cyr": "съхраня",
    "translation": "protect"
  },
  {
    "lemma": "sъžalja",
    "cyr": "съжаля",
    "translation": "regret"
  },
  {
    "lemma": "sъzdam",
    "cyr": "създам",
    "translation": "create, found"
  },
  {
    "lemma": "sъzdanie",
    "cyr": "създание",
    "translation": "creation"
  },
  {
    "lemma": "sъzdatel",
    "cyr": "създател",
    "translation": "creator, founder"
  },
  {
    "lemma": "sъzidam",
    "cyr": "съзидам",
    "translation": "build"
  },
  {
    "lemma": "ta",
    "cyr": "та",
    "translation": "and, thus"
  },
  {
    "lemma": "taž",
    "cyr": "таж",
    "translation": "in the same way"
  },
  {
    "lemma": "taina",
    "cyr": "тайна",
    "translation": "secret"
  },
  {
    "lemma": "taka",
    "cyr": "така",
    "translation": "thus"
  },
  {
    "lemma": "takъv",
    "cyr": "такъв",
    "translation": "such"
  },
  {
    "lemma": "tam",
    "cyr": "там",
    "translation": "there"
  },
  {
    "lemma": "tamazlъk",
    "cyr": "тамазлък",
    "translation": "cattle"
  },
  {
    "lemma": "tamjan",
    "cyr": "тамян",
    "translation": "thyme"
  },
  {
    "lemma": "tě",
    "cyr": "те",
    "translation": "they"
  },
  {
    "lemma": "teglja",
    "cyr": "тегля",
    "translation": "draw"
  },
  {
    "lemma": "tegota",
    "cyr": "тегота",
    "translation": "hardship, weight"
  },
  {
    "lemma": "teka",
    "cyr": "тека",
    "translation": "flow"
  },
  {
    "lemma": "tělo",
    "cyr": "тяло",
    "translation": "body"
  },
  {
    "lemma": "Teodota",
    "cyr": "Теодота",
    "translation": "Theodota"
  },
  {
    "lemma": "težko",
    "cyr": "тежко",
    "translation": "heavily"
  },
  {
    "lemma": "težъk",
    "cyr": "тежък",
    "translation": "heavy"
  },
  {
    "lemma": "ti",
    "cyr": "ти",
    "translation": "you"
  },
  {
    "lemma": "tipografen",
    "cyr": "типографен",
    "translation": "printed"
  },
  {
    "lemma": "tja",
    "cyr": "тя",
    "translation": "she"
  },
  {
    "lemma": "to",
    "cyr": "то",
    "translation": "that, then"
  },
  {
    "lemma": "točilo",
    "cyr": "точило",
    "translation": "wine press"
  },
  {
    "lemma": "togiva",
    "cyr": "тогива",
    "translation": "then"
  },
  {
    "lemma": "toi",
    "cyr": "той",
    "translation": "he"
  },
  {
    "lemma": "toja",
    "cyr": "тоя",
    "translation": "that"
  },
  {
    "lemma": "toko",
    "cyr": "токо",
    "translation": "only"
  },
  {
    "lemma": "tolko",
    "cyr": "толко",
    "translation": "so much"
  },
  {
    "lemma": "tolkova",
    "cyr": "толкова",
    "translation": "as much"
  },
  {
    "lemma": "tova",
    "cyr": "това",
    "translation": "that"
  },
  {
    "lemma": "trap",
    "cyr": "трап",
    "translation": "hole"
  },
  {
    "lemma": "trapeza",
    "cyr": "трапеза",
    "translation": "table"
  },
  {
    "lemma": "traža",
    "cyr": "тража",
    "translation": "search"
  },
  {
    "lemma": "trěbva",
    "cyr": "трябва",
    "translation": "need"
  },
  {
    "lemma": "trepеrene",
    "cyr": "треперене",
    "translation": "trembling"
  },
  {
    "lemma": "treperja",
    "cyr": "треперя",
    "translation": "tremble"
  },
  {
    "lemma": "trepna",
    "cyr": "трепна",
    "translation": "swoop"
  },
  {
    "lemma": "tresa",
    "cyr": "треса",
    "translation": "shake"
  },
  {
    "lemma": "treti",
    "cyr": "трети",
    "translation": "third"
  },
  {
    "lemma": "trěva",
    "cyr": "трява",
    "translation": "grass"
  },
  {
    "lemma": "tri",
    "cyr": "три",
    "translation": "three"
  },
  {
    "lemma": "triglavnik",
    "cyr": "триглавник",
    "translation": "three-headed one"
  },
  {
    "lemma": "trisiatelen",
    "cyr": "трисятелен",
    "translation": "thrice-shining"
  },
  {
    "lemma": "triskrъben",
    "cyr": "трискръбен",
    "translation": "thrice-sad"
  },
  {
    "lemma": "troica",
    "cyr": "тройца",
    "translation": "trinity"
  },
  {
    "lemma": "troičen",
    "cyr": "тройчен",
    "translation": "of trinity"
  },
  {
    "lemma": "tropar",
    "cyr": "тропар",
    "translation": "troparion"
  },
  {
    "lemma": "troxa",
    "cyr": "троха",
    "translation": "crumbs"
  },
  {
    "lemma": "trud",
    "cyr": "труд",
    "translation": "work"
  },
  {
    "lemma": "trudja",
    "cyr": "трудя",
    "translation": "work"
  },
  {
    "lemma": "trus",
    "cyr": "трус",
    "translation": "shaking"
  },
  {
    "lemma": "trъba",
    "cyr": "тръба",
    "translation": "trumpet"
  },
  {
    "lemma": "trъgna",
    "cyr": "тръгна",
    "translation": "leave"
  },
  {
    "lemma": "trъnie",
    "cyr": "тръние",
    "translation": "thorns"
  },
  {
    "lemma": "tu",
    "cyr": "ту",
    "translation": "here"
  },
  {
    "lemma": "tuka",
    "cyr": "тука",
    "translation": "here"
  },
  {
    "lemma": "turčin",
    "cyr": "турчин",
    "translation": "Turk"
  },
  {
    "lemma": "turja",
    "cyr": "туря",
    "translation": "throw, put"
  },
  {
    "lemma": "turski",
    "cyr": "турски",
    "translation": "Turkish"
  },
  {
    "lemma": "tvoi",
    "cyr": "твой",
    "translation": "your"
  },
  {
    "lemma": "tvorec",
    "cyr": "творец",
    "translation": "creator"
  },
  {
    "lemma": "tvorja",
    "cyr": "творя",
    "translation": "do, create"
  },
  {
    "lemma": "tvъrd",
    "cyr": "твърд",
    "translation": "hard"
  },
  {
    "lemma": "tvъrdo",
    "cyr": "твърдо",
    "translation": "hard"
  },
  {
    "lemma": "tъ",
    "cyr": "тъ",
    "translation": "the"
  },
  {
    "lemma": "tъguvam",
    "cyr": "тъгувам",
    "translation": "be sad"
  },
  {
    "lemma": "tъkmo",
    "cyr": "тъкмо",
    "translation": "just"
  },
  {
    "lemma": "tъma",
    "cyr": "тъма",
    "translation": "darkness"
  },
  {
    "lemma": "tъmen",
    "cyr": "тъмен",
    "translation": "dark"
  },
  {
    "lemma": "tъmnica",
    "cyr": "тъмница",
    "translation": "dungeon"
  },
  {
    "lemma": "tъrča",
    "cyr": "търча",
    "translation": "run"
  },
  {
    "lemma": "tъrgovec",
    "cyr": "търговец",
    "translation": "merchant"
  },
  {
    "lemma": "tъrgovina",
    "cyr": "търговина",
    "translation": "business"
  },
  {
    "lemma": "tъrguvam",
    "cyr": "търгувам",
    "translation": "do business"
  },
  {
    "lemma": "tъrpeliv",
    "cyr": "търпелив",
    "translation": "patient"
  },
  {
    "lemma": "tъrpja",
    "cyr": "търпя",
    "translation": "suffer"
  },
  {
    "lemma": "tъrsja",
    "cyr": "търся",
    "translation": "search"
  },
  {
    "lemma": "tъžde",
    "cyr": "тъжде",
    "translation": "the same"
  },
  {
    "lemma": "u",
    "cyr": "у",
    "translation": "at"
  },
  {
    "lemma": "ubiica",
    "cyr": "убийца",
    "translation": "murderer"
  },
  {
    "lemma": "ubiistvo",
    "cyr": "убииство",
    "translation": "murder"
  },
  {
    "lemma": "ubija",
    "cyr": "убия",
    "translation": "murder, kill"
  },
  {
    "lemma": "ubo",
    "cyr": "убо",
    "translation": "as, for"
  },
  {
    "lemma": "uboja",
    "cyr": "убоя",
    "translation": "be afraid"
  },
  {
    "lemma": "uča",
    "cyr": "уча",
    "translation": "learn"
  },
  {
    "lemma": "učenie",
    "cyr": "учение",
    "translation": "learning"
  },
  {
    "lemma": "učenik",
    "cyr": "ученик",
    "translation": "follower"
  },
  {
    "lemma": "ucěniti",
    "cyr": "уцянити",
    "translation": "hire"
  },
  {
    "lemma": "učitel",
    "cyr": "учител",
    "translation": "teacher"
  },
  {
    "lemma": "učinja",
    "cyr": "учиня",
    "translation": "do"
  },
  {
    "lemma": "učuvam",
    "cyr": "учувам",
    "translation": "guard"
  },
  {
    "lemma": "udarja",
    "cyr": "ударя",
    "translation": "strike"
  },
  {
    "lemma": "udivja",
    "cyr": "удивя",
    "translation": "become astonished"
  },
  {
    "lemma": "udъržja",
    "cyr": "удържя",
    "translation": "hold, control"
  },
  {
    "lemma": "ufatja",
    "cyr": "уфатя",
    "translation": "grasp"
  },
  {
    "lemma": "ugaždam",
    "cyr": "угаждам",
    "translation": "be pleasing, acceptable"
  },
  {
    "lemma": "ugoden",
    "cyr": "угоден",
    "translation": "pleasing, acceptable"
  },
  {
    "lemma": "ugodja",
    "cyr": "угодя",
    "translation": "be pleasing, acceptable"
  },
  {
    "lemma": "ugodnik",
    "cyr": "угодник",
    "translation": "follower"
  },
  {
    "lemma": "ugodno",
    "cyr": "угодно",
    "translation": "pleasing, acceptably"
  },
  {
    "lemma": "ugodvam",
    "cyr": "угодвам",
    "translation": "please, follow"
  },
  {
    "lemma": "ugotvja",
    "cyr": "уготвя",
    "translation": "prepare"
  },
  {
    "lemma": "ujazviti",
    "cyr": "уязвити",
    "translation": "hurt"
  },
  {
    "lemma": "ukačja",
    "cyr": "укачя",
    "translation": "mount, load"
  },
  {
    "lemma": "ukor",
    "cyr": "укор",
    "translation": "derision"
  },
  {
    "lemma": "ukorenie",
    "cyr": "укорение",
    "translation": "derision"
  },
  {
    "lemma": "ukorja",
    "cyr": "укоря",
    "translation": "deride"
  },
  {
    "lemma": "ukradna",
    "cyr": "украдна",
    "translation": "steal"
  },
  {
    "lemma": "ukrasja",
    "cyr": "украся",
    "translation": "make beautiful"
  },
  {
    "lemma": "ukrepja",
    "cyr": "укрепя",
    "translation": "make stronger"
  },
  {
    "lemma": "ukrepvam",
    "cyr": "укрепвам",
    "translation": "make stronger"
  },
  {
    "lemma": "ukrotja",
    "cyr": "укротя",
    "translation": "tame"
  },
  {
    "lemma": "ulěza",
    "cyr": "уляза",
    "translation": "enter"
  },
  {
    "lemma": "ulězna",
    "cyr": "улязна",
    "translation": "enter"
  },
  {
    "lemma": "um",
    "cyr": "ум",
    "translation": "intellect"
  },
  {
    "lemma": "umeja",
    "cyr": "умея",
    "translation": "can, know"
  },
  {
    "lemma": "umervam",
    "cyr": "умервам",
    "translation": "measure"
  },
  {
    "lemma": "umija",
    "cyr": "умия",
    "translation": "wash"
  },
  {
    "lemma": "umilen",
    "cyr": "умилен",
    "translation": "nice"
  },
  {
    "lemma": "umiram",
    "cyr": "умирам",
    "translation": "die"
  },
  {
    "lemma": "umirja",
    "cyr": "умиря",
    "translation": "soften"
  },
  {
    "lemma": "umloža",
    "cyr": "умложа",
    "translation": "become many"
  },
  {
    "lemma": "umlъkna",
    "cyr": "умлъкна",
    "translation": "become silent"
  },
  {
    "lemma": "umnoža",
    "cyr": "умножа",
    "translation": "become many"
  },
  {
    "lemma": "umorja",
    "cyr": "уморя",
    "translation": "kill"
  },
  {
    "lemma": "umra",
    "cyr": "умра",
    "translation": "die"
  },
  {
    "lemma": "unesa",
    "cyr": "унеса",
    "translation": "carry in"
  },
  {
    "lemma": "upiša",
    "cyr": "упиша",
    "translation": "describe"
  },
  {
    "lemma": "uplaša",
    "cyr": "уплаша",
    "translation": "scare"
  },
  {
    "lemma": "upregna",
    "cyr": "упрегна",
    "translation": "couple (a wagon)"
  },
  {
    "lemma": "urabotja",
    "cyr": "уработя",
    "translation": "work hard"
  },
  {
    "lemma": "uredja",
    "cyr": "уредя",
    "translation": "put to order"
  },
  {
    "lemma": "Uriil",
    "cyr": "Уриил",
    "translation": "Uriel"
  },
  {
    "lemma": "urod",
    "cyr": "урод",
    "translation": "fool"
  },
  {
    "lemma": "usedna",
    "cyr": "уседна",
    "translation": "mount"
  },
  {
    "lemma": "usěknovenie",
    "cyr": "усекновение",
    "translation": "beheading"
  },
  {
    "lemma": "usetja",
    "cyr": "усетя",
    "translation": "notice"
  },
  {
    "lemma": "usilen",
    "cyr": "усилен",
    "translation": "hard, demanding"
  },
  {
    "lemma": "usilja",
    "cyr": "усиля",
    "translation": "force"
  },
  {
    "lemma": "usladvam",
    "cyr": "усладвам",
    "translation": "sweeten"
  },
  {
    "lemma": "uslyšati",
    "cyr": "услышати",
    "translation": "hear"
  },
  {
    "lemma": "usmъ",
    "cyr": "усмъ",
    "translation": "leather stripes"
  },
  {
    "lemma": "usta",
    "cyr": "уста",
    "translation": "mouth"
  },
  {
    "lemma": "uštedriti",
    "cyr": "ущедрити",
    "translation": "spare, save"
  },
  {
    "lemma": "ustie",
    "cyr": "устие",
    "translation": "entrance, delta"
  },
  {
    "lemma": "ustrelja",
    "cyr": "устреля",
    "translation": "shoot"
  },
  {
    "lemma": "ustrelna",
    "cyr": "устрелна",
    "translation": "shoot"
  },
  {
    "lemma": "usuča",
    "cyr": "усуча",
    "translation": "twist"
  },
  {
    "lemma": "usrъdstvovati",
    "cyr": "усръдствовати",
    "translation": "struggle, desire"
  },
  {
    "lemma": "uteka",
    "cyr": "утека",
    "translation": "run away"
  },
  {
    "lemma": "uteša",
    "cyr": "утеша",
    "translation": "consolate"
  },
  {
    "lemma": "utre",
    "cyr": "утре",
    "translation": "morning"
  },
  {
    "lemma": "utrenja",
    "cyr": "утреня",
    "translation": "morning liturgy"
  },
  {
    "lemma": "utroba",
    "cyr": "утроба",
    "translation": "womb, bowels"
  },
  {
    "lemma": "utvъrdja",
    "cyr": "утвърдя",
    "translation": "harden"
  },
  {
    "lemma": "utъkmja",
    "cyr": "утъкмя",
    "translation": "harden"
  },
  {
    "lemma": "utъrpja",
    "cyr": "утърпя",
    "translation": "suffer"
  },
  {
    "lemma": "uvěrenie",
    "cyr": "увярение",
    "translation": "belief (in Christ)"
  },
  {
    "lemma": "uvidja",
    "cyr": "увидя",
    "translation": "see"
  },
  {
    "lemma": "uxapja",
    "cyr": "ухапя",
    "translation": "bite"
  },
  {
    "lemma": "užas",
    "cyr": "ужас",
    "translation": "terror"
  },
  {
    "lemma": "uzema",
    "cyr": "узема",
    "translation": "take"
  },
  {
    "lemma": "uzimam",
    "cyr": "узимам",
    "translation": "take"
  },
  {
    "lemma": "v",
    "cyr": "в",
    "translation": "in"
  },
  {
    "lemma": "vada",
    "cyr": "вада",
    "translation": "channel"
  },
  {
    "lemma": "varivo",
    "cyr": "вариво",
    "translation": "porridge"
  },
  {
    "lemma": "varja",
    "cyr": "варя",
    "translation": "cook"
  },
  {
    "lemma": "vaš",
    "cyr": "ваш",
    "translation": "your"
  },
  {
    "lemma": "Vavilon",
    "cyr": "Вавилон",
    "translation": "Babylon"
  },
  {
    "lemma": "vavilonjanin",
    "cyr": "вавилонянин",
    "translation": "Babylonian"
  },
  {
    "lemma": "včera",
    "cyr": "вчера",
    "translation": "yesterday"
  },
  {
    "lemma": "vdigna",
    "cyr": "вдигна",
    "translation": "raise"
  },
  {
    "lemma": "veče",
    "cyr": "вече",
    "translation": "already, anymore, more"
  },
  {
    "lemma": "večen",
    "cyr": "вечен",
    "translation": "eternal"
  },
  {
    "lemma": "večer",
    "cyr": "вечер",
    "translation": "evening"
  },
  {
    "lemma": "večera",
    "cyr": "вечера",
    "translation": "dinner"
  },
  {
    "lemma": "večerjam",
    "cyr": "вечерям",
    "translation": "have a dinner"
  },
  {
    "lemma": "večernja",
    "cyr": "вечерня",
    "translation": "evening liturgy"
  },
  {
    "lemma": "veja",
    "cyr": "вея",
    "translation": "wave"
  },
  {
    "lemma": "vek",
    "cyr": "век",
    "translation": "age"
  },
  {
    "lemma": "velik",
    "cyr": "велик",
    "translation": "great"
  },
  {
    "lemma": "Velzevul",
    "cyr": "Велзевул",
    "translation": "Beelzebub"
  },
  {
    "lemma": "venec",
    "cyr": "венец",
    "translation": "wreath"
  },
  {
    "lemma": "Veniamin",
    "cyr": "Вениамин",
    "translation": "Benjamin"
  },
  {
    "lemma": "věra",
    "cyr": "вяра",
    "translation": "faith, belief"
  },
  {
    "lemma": "veren",
    "cyr": "верен",
    "translation": "loyal, faithful"
  },
  {
    "lemma": "věrvam",
    "cyr": "вярвам",
    "translation": "believe"
  },
  {
    "lemma": "veselba",
    "cyr": "веселба",
    "translation": "happiness"
  },
  {
    "lemma": "veselie",
    "cyr": "веселие",
    "translation": "happiness"
  },
  {
    "lemma": "veselja",
    "cyr": "веселя",
    "translation": "rejoice"
  },
  {
    "lemma": "vest",
    "cyr": "вест",
    "translation": "news"
  },
  {
    "lemma": "větъr",
    "cyr": "вятър",
    "translation": "wind"
  },
  {
    "lemma": "vext",
    "cyr": "вехт",
    "translation": "rag"
  },
  {
    "lemma": "vezir",
    "cyr": "везир",
    "translation": "vizier"
  },
  {
    "lemma": "videnie",
    "cyr": "видение",
    "translation": "vision"
  },
  {
    "lemma": "vidja",
    "cyr": "видя",
    "translation": "see"
  },
  {
    "lemma": "vie",
    "cyr": "вие",
    "translation": "you"
  },
  {
    "lemma": "vikam",
    "cyr": "викам",
    "translation": "call, shout"
  },
  {
    "lemma": "vikna",
    "cyr": "викна",
    "translation": "call, shout"
  },
  {
    "lemma": "Vil",
    "cyr": "Вил",
    "translation": "Bel"
  },
  {
    "lemma": "vinar",
    "cyr": "винар",
    "translation": "wine maker"
  },
  {
    "lemma": "vino",
    "cyr": "вино",
    "translation": "wine"
  },
  {
    "lemma": "vinočerpatel",
    "cyr": "виночерпател",
    "translation": "cupbearer"
  },
  {
    "lemma": "Virsavija",
    "cyr": "Вирсавия",
    "translation": "Beersheba"
  },
  {
    "lemma": "više",
    "cyr": "више",
    "translation": "over"
  },
  {
    "lemma": "višen",
    "cyr": "вишен",
    "translation": "highest"
  },
  {
    "lemma": "visina",
    "cyr": "висина",
    "translation": "height"
  },
  {
    "lemma": "visja",
    "cyr": "вися",
    "translation": "hang"
  },
  {
    "lemma": "visok",
    "cyr": "висок",
    "translation": "high"
  },
  {
    "lemma": "vlača",
    "cyr": "влача",
    "translation": "pull"
  },
  {
    "lemma": "vladika",
    "cyr": "владика",
    "translation": "lord, bishop"
  },
  {
    "lemma": "vladičen",
    "cyr": "владичен",
    "translation": "lordly"
  },
  {
    "lemma": "vladičica",
    "cyr": "владичица",
    "translation": "lady"
  },
  {
    "lemma": "vlast",
    "cyr": "власт",
    "translation": "power"
  },
  {
    "lemma": "vlastvam",
    "cyr": "властвам",
    "translation": "rule"
  },
  {
    "lemma": "vlěza",
    "cyr": "вляза",
    "translation": "enter"
  },
  {
    "lemma": "vlězna",
    "cyr": "влязна",
    "translation": "enter"
  },
  {
    "lemma": "vmesto",
    "cyr": "вместо",
    "translation": "instead"
  },
  {
    "lemma": "vnuk",
    "cyr": "внук",
    "translation": "grandson"
  },
  {
    "lemma": "vočka",
    "cyr": "вочка",
    "translation": "fruit"
  },
  {
    "lemma": "voda",
    "cyr": "вода",
    "translation": "water"
  },
  {
    "lemma": "vodja",
    "cyr": "водя",
    "translation": "lead, have"
  },
  {
    "lemma": "voina",
    "cyr": "война",
    "translation": "war"
  },
  {
    "lemma": "voiska",
    "cyr": "войска",
    "translation": "army"
  },
  {
    "lemma": "voivoda",
    "cyr": "войвода",
    "translation": "duke, general"
  },
  {
    "lemma": "vol",
    "cyr": "вол",
    "translation": "ox"
  },
  {
    "lemma": "volčec",
    "cyr": "волчец",
    "translation": "thistle"
  },
  {
    "lemma": "voliti",
    "cyr": "волити",
    "translation": "want"
  },
  {
    "lemma": "volja",
    "cyr": "воля",
    "translation": "will"
  },
  {
    "lemma": "vosъk",
    "cyr": "восък",
    "translation": "wax"
  },
  {
    "lemma": "vozja",
    "cyr": "возя",
    "translation": "convey"
  },
  {
    "lemma": "vrač",
    "cyr": "врач",
    "translation": "doctor"
  },
  {
    "lemma": "vračevati",
    "cyr": "врачевати",
    "translation": "heal"
  },
  {
    "lemma": "vračevski",
    "cyr": "врачевски",
    "translation": "of doctors"
  },
  {
    "lemma": "vrag",
    "cyr": "враг",
    "translation": "enemy"
  },
  {
    "lemma": "vrata",
    "cyr": "врата",
    "translation": "door"
  },
  {
    "lemma": "vratar",
    "cyr": "вратар",
    "translation": "doorman"
  },
  {
    "lemma": "vražda",
    "cyr": "вражда",
    "translation": "hate"
  },
  {
    "lemma": "vrazumja",
    "cyr": "вразумя",
    "translation": "convince to be reasonable"
  },
  {
    "lemma": "vreme",
    "cyr": "време",
    "translation": "time, weather"
  },
  {
    "lemma": "vrъx",
    "cyr": "връх",
    "translation": "top, summit"
  },
  {
    "lemma": "vrъz",
    "cyr": "връз",
    "translation": "on"
  },
  {
    "lemma": "vse",
    "cyr": "все",
    "translation": "all"
  },
  {
    "lemma": "vsedъržitel",
    "cyr": "вседържител",
    "translation": "Pantocrator"
  },
  {
    "lemma": "vsegda",
    "cyr": "всегда",
    "translation": "always"
  },
  {
    "lemma": "vsěkakvo",
    "cyr": "всякакво",
    "translation": "anything"
  },
  {
    "lemma": "vsěki",
    "cyr": "всеки",
    "translation": "every"
  },
  {
    "lemma": "vselja",
    "cyr": "вселя",
    "translation": "settle"
  },
  {
    "lemma": "vsemilostiv",
    "cyr": "всемилостив",
    "translation": "most merciful"
  },
  {
    "lemma": "vsesilen",
    "cyr": "всесилен",
    "translation": "most powerful"
  },
  {
    "lemma": "vsičko",
    "cyr": "всичко",
    "translation": "everything"
  },
  {
    "lemma": "vtori",
    "cyr": "втори",
    "translation": "second"
  },
  {
    "lemma": "vzema",
    "cyr": "взема",
    "translation": "take"
  },
  {
    "lemma": "vzimam",
    "cyr": "взимам",
    "translation": "take"
  },
  {
    "lemma": "vъlk",
    "cyr": "вълк",
    "translation": "wolf"
  },
  {
    "lemma": "vъlna",
    "cyr": "вълна",
    "translation": "wool"
  },
  {
    "lemma": "vъniti",
    "cyr": "вънити",
    "translation": "enter"
  },
  {
    "lemma": "vъnimati",
    "cyr": "вънимати",
    "translation": "perceive, give attention"
  },
  {
    "lemma": "vъnǫtr",
    "cyr": "вънътр",
    "translation": "inside"
  },
  {
    "lemma": "vъrna",
    "cyr": "върна",
    "translation": "return"
  },
  {
    "lemma": "vъrša",
    "cyr": "върша",
    "translation": "thresh"
  },
  {
    "lemma": "vъrža",
    "cyr": "вържа",
    "translation": "bind"
  },
  {
    "lemma": "vъvidja",
    "cyr": "въвидя",
    "translation": "observe"
  },
  {
    "lemma": "vъzdam",
    "cyr": "въздам",
    "translation": "duly give"
  },
  {
    "lemma": "vъždelenie",
    "cyr": "въжделение",
    "translation": "desire"
  },
  {
    "lemma": "vъzdъrža",
    "cyr": "въздържа",
    "translation": "abstain"
  },
  {
    "lemma": "vъzdъržanie",
    "cyr": "въздържание",
    "translation": "abstinence"
  },
  {
    "lemma": "vъzdixanie",
    "cyr": "въздихание",
    "translation": "moan"
  },
  {
    "lemma": "vъzdrěmati",
    "cyr": "въздремати",
    "translation": "fall asleep"
  },
  {
    "lemma": "vъzdъxvam",
    "cyr": "въздъхвам",
    "translation": "gasp"
  },
  {
    "lemma": "vъže",
    "cyr": "въже",
    "translation": "rope"
  },
  {
    "lemma": "vъzigrati",
    "cyr": "възиграя",
    "translation": "start to dance"
  },
  {
    "lemma": "vъzkresenie",
    "cyr": "възкресение",
    "translation": "resurrection"
  },
  {
    "lemma": "vъzljubja",
    "cyr": "възлюбя",
    "translation": "love, be dear"
  },
  {
    "lemma": "vъznesa",
    "cyr": "възнеса",
    "translation": "lift"
  },
  {
    "lemma": "vъznesenie",
    "cyr": "възнесение",
    "translation": "ascension"
  },
  {
    "lemma": "vъpadnǫti",
    "cyr": "въпаднути",
    "translation": "fall down (into sin)"
  },
  {
    "lemma": "vъzpeja",
    "cyr": "възпея",
    "translation": "sing"
  },
  {
    "lemma": "vъzpleskam",
    "cyr": "възплескам",
    "translation": "clap"
  },
  {
    "lemma": "vъzradvam",
    "cyr": "възрадувам",
    "translation": "rejoice"
  },
  {
    "lemma": "vъzsilati",
    "cyr": "възсилати",
    "translation": "send"
  },
  {
    "lemma": "vъzupiti",
    "cyr": "възупити",
    "translation": "shout"
  },
  {
    "lemma": "vъzxvalja",
    "cyr": "възхваля",
    "translation": "praise"
  },
  {
    "lemma": "vъzzyvati",
    "cyr": "въззывати",
    "translation": "call"
  },
  {
    "lemma": "xabar",
    "cyr": "хабар",
    "translation": "message"
  },
  {
    "lemma": "xaide",
    "cyr": "хайде",
    "translation": "come!"
  },
  {
    "lemma": "xaiduk",
    "cyr": "хайдук",
    "translation": "robber"
  },
  {
    "lemma": "xala",
    "cyr": "хала",
    "translation": "dragon"
  },
  {
    "lemma": "Xam",
    "cyr": "Хам",
    "translation": "Ham"
  },
  {
    "lemma": "xaresam",
    "cyr": "харесам",
    "translation": "like"
  },
  {
    "lemma": "xekimdži",
    "cyr": "хекимджи",
    "translation": "doctor"
  },
  {
    "lemma": "xergelia",
    "cyr": "хергеля",
    "translation": "herd"
  },
  {
    "lemma": "xič",
    "cyr": "хич",
    "translation": "thus"
  },
  {
    "lemma": "xiljada",
    "cyr": "хиляда",
    "translation": "thousand"
  },
  {
    "lemma": "xitrost",
    "cyr": "хитрост",
    "translation": "cunning"
  },
  {
    "lemma": "xitъr",
    "cyr": "хитър",
    "translation": "cunning"
  },
  {
    "lemma": "xiža",
    "cyr": "хижа",
    "translation": "house, cottage"
  },
  {
    "lemma": "xladen",
    "cyr": "хладен",
    "translation": "cold"
  },
  {
    "lemma": "xladovina",
    "cyr": "хладовина",
    "translation": "coolness"
  },
  {
    "lemma": "xlěb",
    "cyr": "хляб",
    "translation": "bread"
  },
  {
    "lemma": "xlebar",
    "cyr": "хлебар",
    "translation": "bread baker"
  },
  {
    "lemma": "xleben",
    "cyr": "хлебен",
    "translation": "of bread"
  },
  {
    "lemma": "xoču",
    "cyr": "хочу",
    "translation": "will"
  },
  {
    "lemma": "xod",
    "cyr": "ход",
    "translation": "walk"
  },
  {
    "lemma": "xodja",
    "cyr": "ходя",
    "translation": "walk"
  },
  {
    "lemma": "xorotja",
    "cyr": "хоротя",
    "translation": "talk"
  },
  {
    "lemma": "xotěti",
    "cyr": "хотeти",
    "translation": "want"
  },
  {
    "lemma": "xranitel",
    "cyr": "хранител",
    "translation": "guardian"
  },
  {
    "lemma": "xranja",
    "cyr": "храня",
    "translation": "feed, protect"
  },
  {
    "lemma": "Xrisa",
    "cyr": "Хриса",
    "translation": "Chrysa"
  },
  {
    "lemma": "xristianin",
    "cyr": "христянин",
    "translation": "Christian"
  },
  {
    "lemma": "xristianka",
    "cyr": "христянка",
    "translation": "Christian woman"
  },
  {
    "lemma": "xristianski",
    "cyr": "христянски",
    "translation": "Christian"
  },
  {
    "lemma": "Xristos",
    "cyr": "Христос",
    "translation": "Christ"
  },
  {
    "lemma": "Xristov",
    "cyr": "Христов",
    "translation": "Christ's"
  },
  {
    "lemma": "xrom",
    "cyr": "хром",
    "translation": "lame"
  },
  {
    "lemma": "xrъt",
    "cyr": "хрът",
    "translation": "greyhound"
  },
  {
    "lemma": "xubav",
    "cyr": "хубав",
    "translation": "beautiful"
  },
  {
    "lemma": "xubavo",
    "cyr": "хубаво",
    "translation": "beautifully"
  },
  {
    "lemma": "xubost",
    "cyr": "хубост",
    "translation": "beauty"
  },
  {
    "lemma": "xud",
    "cyr": "худ",
    "translation": "weak"
  },
  {
    "lemma": "xulen",
    "cyr": "хулен",
    "translation": "slanderous"
  },
  {
    "lemma": "xulja",
    "cyr": "хуля",
    "translation": "slander, blaspheme"
  },
  {
    "lemma": "xulnik",
    "cyr": "хулник",
    "translation": "blasphemer"
  },
  {
    "lemma": "xvalja",
    "cyr": "хваля",
    "translation": "praise"
  },
  {
    "lemma": "xъlm",
    "cyr": "хълм",
    "translation": "hill"
  },
  {
    "lemma": "xъlmie",
    "cyr": "хълмие",
    "translation": "hills"
  },
  {
    "lemma": "za",
    "cyr": "за",
    "translation": "for, about"
  },
  {
    "lemma": "zabija",
    "cyr": "забия",
    "translation": "hit"
  },
  {
    "lemma": "zabravja",
    "cyr": "забравя",
    "translation": "forget"
  },
  {
    "lemma": "začena",
    "cyr": "зачена",
    "translation": "conceive"
  },
  {
    "lemma": "začuvam",
    "cyr": "зачувам",
    "translation": "save"
  },
  {
    "lemma": "zadъrža",
    "cyr": "задържа",
    "translation": "hold, control"
  },
  {
    "lemma": "zaedno",
    "cyr": "заедно",
    "translation": "together"
  },
  {
    "lemma": "zafalja",
    "cyr": "зафаля",
    "translation": "celebrate"
  },
  {
    "lemma": "zagradja",
    "cyr": "заградя",
    "translation": "close, put a fence"
  },
  {
    "lemma": "zagriža",
    "cyr": "загрижа",
    "translation": "care"
  },
  {
    "lemma": "zagubja",
    "cyr": "загубя",
    "translation": "lose"
  },
  {
    "lemma": "zagъrmja",
    "cyr": "загърмя",
    "translation": "thunder"
  },
  {
    "lemma": "zaida",
    "cyr": "зайда",
    "translation": "go away, set (sun)"
  },
  {
    "lemma": "zaključa",
    "cyr": "заключа",
    "translation": "lock"
  },
  {
    "lemma": "zakolja",
    "cyr": "заколя",
    "translation": "slaughter"
  },
  {
    "lemma": "zakon",
    "cyr": "закон",
    "translation": "law"
  },
  {
    "lemma": "zakopaja",
    "cyr": "закопая",
    "translation": "dig"
  },
  {
    "lemma": "zakrija",
    "cyr": "закрия",
    "translation": "cover"
  },
  {
    "lemma": "zakъlna",
    "cyr": "закълна",
    "translation": "swear"
  },
  {
    "lemma": "žalba",
    "cyr": "жалба",
    "translation": "sorrow"
  },
  {
    "lemma": "žalja",
    "cyr": "жаля",
    "translation": "be sad"
  },
  {
    "lemma": "žalno",
    "cyr": "жално",
    "translation": "sadly"
  },
  {
    "lemma": "žalost",
    "cyr": "жалост",
    "translation": "sorrow"
  },
  {
    "lemma": "zaman",
    "cyr": "заман",
    "translation": "time, constantly"
  },
  {
    "lemma": "zamina",
    "cyr": "замина",
    "translation": "miss, pass around"
  },
  {
    "lemma": "zamislja",
    "cyr": "замисля",
    "translation": "think"
  },
  {
    "lemma": "zanesa",
    "cyr": "занеса",
    "translation": "bring"
  },
  {
    "lemma": "zapad",
    "cyr": "запад",
    "translation": "West"
  },
  {
    "lemma": "zapalja",
    "cyr": "запаля",
    "translation": "ignite"
  },
  {
    "lemma": "zapčija",
    "cyr": "запчия",
    "translation": "tax collector"
  },
  {
    "lemma": "zapečatja",
    "cyr": "запечатя",
    "translation": "seal"
  },
  {
    "lemma": "zapěja",
    "cyr": "запея",
    "translation": "sing"
  },
  {
    "lemma": "zapiša",
    "cyr": "запиша",
    "translation": "write down"
  },
  {
    "lemma": "zapištja",
    "cyr": "запищя",
    "translation": "squeal"
  },
  {
    "lemma": "zaplača",
    "cyr": "заплача",
    "translation": "cry"
  },
  {
    "lemma": "zaplaša",
    "cyr": "заплаша",
    "translation": "scare"
  },
  {
    "lemma": "zaplata",
    "cyr": "заплата",
    "translation": "pay"
  },
  {
    "lemma": "započna",
    "cyr": "започна",
    "translation": "begin"
  },
  {
    "lemma": "zapověd",
    "cyr": "заповед",
    "translation": "command"
  },
  {
    "lemma": "zapovědam",
    "cyr": "заповядам",
    "translation": "command"
  },
  {
    "lemma": "zapra",
    "cyr": "запра",
    "translation": "forbid"
  },
  {
    "lemma": "zaradi",
    "cyr": "заради",
    "translation": "for"
  },
  {
    "lemma": "zaradvam",
    "cyr": "зарадвам",
    "translation": "rejoice"
  },
  {
    "lemma": "zaran",
    "cyr": "заран",
    "translation": "early morning"
  },
  {
    "lemma": "zarъčam",
    "cyr": "заръчам",
    "translation": "command"
  },
  {
    "lemma": "zaskъrcam",
    "cyr": "заскърцам",
    "translation": "gnash"
  },
  {
    "lemma": "zasměja",
    "cyr": "засмея",
    "translation": "laugh"
  },
  {
    "lemma": "zaspja",
    "cyr": "заспя",
    "translation": "fall asleep"
  },
  {
    "lemma": "zasramja",
    "cyr": "засрамя",
    "translation": "be ashamed"
  },
  {
    "lemma": "zastareja",
    "cyr": "застарея",
    "translation": "become old"
  },
  {
    "lemma": "zašto",
    "cyr": "защо",
    "translation": "for"
  },
  {
    "lemma": "zato",
    "cyr": "зато",
    "translation": "thus"
  },
  {
    "lemma": "zatova",
    "cyr": "затова",
    "translation": "thus"
  },
  {
    "lemma": "zatrija",
    "cyr": "затрия",
    "translation": "destroy, delete"
  },
  {
    "lemma": "zatvorja",
    "cyr": "затворя",
    "translation": "close, incarcerate"
  },
  {
    "lemma": "zavarja",
    "cyr": "заваря",
    "translation": "meet"
  },
  {
    "lemma": "zaveda",
    "cyr": "заведа",
    "translation": "lead, bring"
  },
  {
    "lemma": "zavesa",
    "cyr": "завеса",
    "translation": "curtain"
  },
  {
    "lemma": "zavidja",
    "cyr": "завидя",
    "translation": "be envious"
  },
  {
    "lemma": "zavidliv",
    "cyr": "завидлив",
    "translation": "envious"
  },
  {
    "lemma": "zavist",
    "cyr": "завист",
    "translation": "envy"
  },
  {
    "lemma": "zavistnik",
    "cyr": "завистник",
    "translation": "envious"
  },
  {
    "lemma": "zavъrža",
    "cyr": "завържа",
    "translation": "bind"
  },
  {
    "lemma": "Zaxaria",
    "cyr": "Захаря",
    "translation": "Zechariah"
  },
  {
    "lemma": "Zaxarin",
    "cyr": "захарин",
    "translation": "Zechariah's"
  },
  {
    "lemma": "zaxranja",
    "cyr": "захраня",
    "translation": "feed"
  },
  {
    "lemma": "zazidam",
    "cyr": "зазидам",
    "translation": "build"
  },
  {
    "lemma": "zdanie",
    "cyr": "здание",
    "translation": "creation"
  },
  {
    "lemma": "zde",
    "cyr": "зде",
    "translation": "here"
  },
  {
    "lemma": "zdrav",
    "cyr": "здрав",
    "translation": "healthy"
  },
  {
    "lemma": "zdravja",
    "cyr": "здравя",
    "translation": "greet"
  },
  {
    "lemma": "že",
    "cyr": "же",
    "translation": "and, also"
  },
  {
    "lemma": "žega",
    "cyr": "жега",
    "translation": "heat"
  },
  {
    "lemma": "želaja",
    "cyr": "желая",
    "translation": "desire, wish"
  },
  {
    "lemma": "zelen",
    "cyr": "зелен",
    "translation": "green"
  },
  {
    "lemma": "zělo",
    "cyr": "зяло",
    "translation": "very"
  },
  {
    "lemma": "zema",
    "cyr": "зема",
    "translation": "take"
  },
  {
    "lemma": "zemja",
    "cyr": "земя",
    "translation": "land, earth"
  },
  {
    "lemma": "zemlen",
    "cyr": "землен",
    "translation": "of the Earth"
  },
  {
    "lemma": "zemleno",
    "cyr": "землено",
    "translation": "like on the Earth"
  },
  {
    "lemma": "zemlja",
    "cyr": "земля",
    "translation": "land, earth"
  },
  {
    "lemma": "žena",
    "cyr": "жена",
    "translation": "woman"
  },
  {
    "lemma": "ženski",
    "cyr": "женски",
    "translation": "female"
  },
  {
    "lemma": "žetva",
    "cyr": "жетва",
    "translation": "harvest"
  },
  {
    "lemma": "žetvar",
    "cyr": "жетвар",
    "translation": "harvester"
  },
  {
    "lemma": "žežъk",
    "cyr": "жежък",
    "translation": "hot"
  },
  {
    "lemma": "zina",
    "cyr": "зина",
    "translation": "roar"
  },
  {
    "lemma": "žitnica",
    "cyr": "житница",
    "translation": "barn"
  },
  {
    "lemma": "žito",
    "cyr": "жито",
    "translation": "crops"
  },
  {
    "lemma": "živ",
    "cyr": "жив",
    "translation": "alive"
  },
  {
    "lemma": "živeja",
    "cyr": "живея",
    "translation": "live"
  },
  {
    "lemma": "živenica",
    "cyr": "живеница",
    "translation": "scrofula"
  },
  {
    "lemma": "živina",
    "cyr": "живина",
    "translation": "creature"
  },
  {
    "lemma": "život",
    "cyr": "живот",
    "translation": "life"
  },
  {
    "lemma": "životen",
    "cyr": "животен",
    "translation": "of life"
  },
  {
    "lemma": "zjafet",
    "cyr": "зяфет",
    "translation": "banquet"
  },
  {
    "lemma": "zlak",
    "cyr": "злак",
    "translation": "plant"
  },
  {
    "lemma": "zlaten",
    "cyr": "златен",
    "translation": "golden"
  },
  {
    "lemma": "zlato",
    "cyr": "злато",
    "translation": "gold"
  },
  {
    "lemma": "zlatokrilen",
    "cyr": "златокрилен",
    "translation": "golden-winged"
  },
  {
    "lemma": "Zlatoust",
    "cyr": "Златоуст",
    "translation": "Chrysostom"
  },
  {
    "lemma": "zle",
    "cyr": "зле",
    "translation": "badly"
  },
  {
    "lemma": "zlina",
    "cyr": "злина",
    "translation": "evil"
  },
  {
    "lemma": "zlo",
    "cyr": "зло",
    "translation": "evil"
  },
  {
    "lemma": "zloba",
    "cyr": "злоба",
    "translation": "anger"
  },
  {
    "lemma": "zločest",
    "cyr": "злочест",
    "translation": "bad, misfortunate"
  },
  {
    "lemma": "zločestnik",
    "cyr": "злочестник",
    "translation": "evil one"
  },
  {
    "lemma": "zloumen",
    "cyr": "злоумен",
    "translation": "wicked"
  },
  {
    "lemma": "žlъč",
    "cyr": "жлъч",
    "translation": "bile, anger"
  },
  {
    "lemma": "zmija",
    "cyr": "змия",
    "translation": "snake"
  },
  {
    "lemma": "znaja",
    "cyr": "зная",
    "translation": "know"
  },
  {
    "lemma": "znamenie",
    "cyr": "знамение",
    "translation": "sign, omen"
  },
  {
    "lemma": "znemoga",
    "cyr": "знемога",
    "translation": "become incapable"
  },
  {
    "lemma": "zova",
    "cyr": "зова",
    "translation": "call"
  },
  {
    "lemma": "žrebe",
    "cyr": "жребе",
    "translation": "lot"
  },
  {
    "lemma": "zra",
    "cyr": "зра",
    "translation": "see"
  },
  {
    "lemma": "zvěr",
    "cyr": "звяр",
    "translation": "beast"
  },
  {
    "lemma": "zvezda",
    "cyr": "звезда",
    "translation": "star"
  },
  {
    "lemma": "žаden",
    "cyr": "жаден",
    "translation": "thirsty"
  },
  {
    "lemma": "zъb",
    "cyr": "зъб",
    "translation": "tooth"
  },
  {
    "lemma": "zъl",
    "cyr": "зъл",
    "translation": "evil, angry"
  },
  {
    "lemma": "žъlt",
    "cyr": "жълт",
    "translation": "yellow"
  },
  {
    "lemma": "žъltica",
    "cyr": "жълтица",
    "translation": "golden coin"
  },
  {
    "lemma": "žъna",
    "cyr": "жъна",
    "translation": "harvest"
  },
  {
    "lemma": "zъrno",
    "cyr": "зърно",
    "translation": "grain"
  }
]